import React from 'react';

const Decor3: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-3 prefix__map-decor"
      transform="translate(144.5 193.5)"
    >
      <defs>
        <linearGradient
          id="bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
          data-name="grad-190"
          x1="817.8"
          y1="123.26"
          x2="817.79"
          y2="125.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="edcae3fb-5bdc-4272-a1b1-23bed677300c"
          data-name="grad-16"
          x1="817.79"
          y1="123.78"
          x2="817.8"
          y2="126.64"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="b1578dbc-05d9-4979-be41-e1046d346475"
          data-name="grad-13"
          x1="817.76"
          y1="124.33"
          x2="817.82"
          y2="127.56"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
          data-name="grad-196"
          x1="817.72"
          y1="124.88"
          x2="817.83"
          y2="128.38"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="a7bf3d33-71e8-4696-a6fd-5a16df62df00"
          data-name="grad-195"
          x1="817.68"
          y1="125.43"
          x2="817.84"
          y2="129.11"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="e543d764-0bb6-4907-bc87-07a2c2b099f2"
          data-name="grad-47"
          x1="817.63"
          y1="125.99"
          x2="817.83"
          y2="129.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
          data-name="grad-9"
          x1="817.68"
          y1="127.52"
          x2="817.84"
          y2="131.35"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="afe99a36-5f2c-49d1-99f2-ecc0315940ee"
          data-name="grad-8"
          x1="817.72"
          y1="129.05"
          x2="817.83"
          y2="132.89"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="a793eb4f-a46e-459a-9444-2c84971b614e"
          data-name="grad-7"
          x1="817.75"
          y1="130.58"
          x2="817.82"
          y2="134.37"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="eca93904-f979-4ff2-817e-3ce3a60916f6"
          data-name="grad-2"
          x1="817.78"
          y1="132.11"
          x2="817.81"
          y2="135.78"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="a275e7fe-7113-4525-8eb1-0622eeb65669"
          data-name="grad-126"
          x1="817.81"
          y1="133.64"
          x2="817.79"
          y2="137.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="b2a8039b-5155-4b37-a0f8-c500558db551"
          data-name="grad-210"
          cx="817.67"
          cy="129.67"
          r="12.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="f1fcf38c-9301-468b-bd64-79dba11ade5c"
          x1="915.64"
          y1="171.65"
          x2="915.62"
          y2="173.99"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="b8801255-1ccd-46b2-b96c-f7f50fac117e"
          x1="915.62"
          y1="172.17"
          x2="915.64"
          y2="174.99"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="a643feb2-9ac1-426a-8a2b-14f8d8f8540d"
          x1="915.59"
          y1="172.7"
          x2="915.65"
          y2="175.89"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="a4101cc1-25eb-4486-9a35-76f3ef8ce09e"
          data-name="grad-12"
          x1="915.56"
          y1="173.25"
          x2="915.66"
          y2="176.7"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="afeed956-40cf-4a91-a6b0-c09b37e4bc8c"
          data-name="grad-11"
          x1="915.51"
          y1="173.79"
          x2="915.67"
          y2="177.42"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="b6031f31-7047-474e-8c9f-02851daa34f8"
          x1="915.47"
          y1="174.35"
          x2="915.67"
          y2="178.03"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="bd259be6-bb1e-4067-b01c-15f3d44bce3b"
          x1="915.51"
          y1="175.86"
          x2="915.67"
          y2="179.63"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="a8d54fbe-9b8d-46fa-9f8a-53d0865309c9"
          x1="915.55"
          y1="177.36"
          x2="915.67"
          y2="181.16"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="a2ec5343-ea0a-4542-b1e8-031a514b72f5"
          x1="915.58"
          y1="178.87"
          x2="915.65"
          y2="182.62"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="a8ef8ec2-c1f4-45cc-904a-febf3d047db4"
          x1="915.61"
          y1="180.38"
          x2="915.64"
          y2="184.01"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="a999e1c0-8365-41a3-86b6-9c6879ffc5b7"
          x1="915.64"
          y1="181.9"
          x2="915.62"
          y2="185.34"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="fe7cbc1d-7be2-44a3-837c-7c5450e91c33"
          cx="915.5"
          cy="177.97"
          r="12.5"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="e50eba5a-ba20-46fd-a14e-4222aed9199c"
          x1="843.8"
          y1="89.26"
          x2="843.79"
          y2="91.63"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="b2189e5f-eb01-4d62-a2d6-0c48248eb5cc"
          x1="843.79"
          y1="89.78"
          x2="843.8"
          y2="92.64"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="b37e09ef-eada-4d99-92d6-68d6ddf042e6"
          x1="843.76"
          y1="90.33"
          x2="843.82"
          y2="93.56"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="b3ae698a-f590-4b75-9371-0f09215d57df"
          x1="843.72"
          y1="90.88"
          x2="843.83"
          y2="94.38"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="ae302e20-1eb2-4f55-bead-1db821c211e4"
          x1="843.68"
          y1="91.43"
          x2="843.84"
          y2="95.11"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="ade823d4-0c9e-4ec5-abf0-e8d417681d20"
          x1="843.63"
          y1="91.99"
          x2="843.83"
          y2="95.73"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="f5928045-49e1-4d3f-b8cc-458b3134b3ae"
          x1="843.68"
          y1="93.52"
          x2="843.84"
          y2="97.35"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="bf17acb9-c983-4309-af26-1fba2298681a"
          x1="843.72"
          y1="95.05"
          x2="843.83"
          y2="98.89"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="baa233bb-f001-4586-9aa5-7e5b2740eefa"
          x1="843.75"
          y1="96.58"
          x2="843.82"
          y2="100.37"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="b06b4701-5c6d-41e1-9e2e-b39f69791741"
          x1="843.78"
          y1="98.11"
          x2="843.81"
          y2="101.78"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="fba9e733-e0f6-4612-8134-646343c20ef7"
          x1="843.81"
          y1="99.64"
          x2="843.79"
          y2="103.13"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="fe23bdc3-5585-4910-90d8-a643e6ced625"
          cx="843.67"
          cy="95.67"
          r="12.67"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="ff7f4347-695a-4ac0-a468-c0d5b25a5bc0"
          x1="1130.42"
          y1="101.42"
          x2="1130.38"
          y2="108.72"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="b245e1b4-7f64-4dcd-9c2f-b74fab4cb8d4"
          x1="1130.37"
          y1="103.04"
          x2="1130.42"
          y2="111.83"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="b3445430-a77f-443b-9372-3b7a820c62fd"
          x1="1130.28"
          y1="104.71"
          x2="1130.47"
          y2="114.66"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="a9963598-83fe-4cfc-9713-0757f422d7e4"
          data-name="grad-12"
          x1="1130.18"
          y1="106.41"
          x2="1130.51"
          y2="117.19"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="aeba4199-e341-4758-a931-01977ce58711"
          data-name="grad-11"
          x1="1130.05"
          y1="108.12"
          x2="1130.53"
          y2="119.43"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="af5afef0-9853-48f4-b546-c42a0049cfff"
          x1="1129.89"
          y1="109.84"
          x2="1130.52"
          y2="121.34"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="e3658ef8-be2b-4a33-84bf-099fb73e096b"
          x1="1130.03"
          y1="114.55"
          x2="1130.53"
          y2="126.33"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="b50aa4af-7373-4709-8e8f-843273b83b55"
          x1="1130.16"
          y1="119.25"
          x2="1130.52"
          y2="131.09"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="a992d583-10e8-40fc-9a2c-ff06f37551d7"
          x1="1130.26"
          y1="123.96"
          x2="1130.48"
          y2="135.64"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="a45fd7ca-e49d-4bc3-b302-f6f94c003c3a"
          x1="1130.36"
          y1="128.67"
          x2="1130.43"
          y2="139.99"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="f01f425c-d059-4dd3-b1c5-14e49e51ae0c"
          x1="1130.43"
          y1="133.4"
          x2="1130.37"
          y2="144.14"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="b9ad089b-2bc1-4965-b434-a09090273333"
          cx="1130"
          cy="121.16"
          r="39"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="a85302c0-d016-4d31-8b29-7c328466ef6f"
          x1="1121.42"
          y1="242.42"
          x2="1121.38"
          y2="249.72"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="e3202c66-4597-4465-9991-e1c2839d0c68"
          x1="1121.37"
          y1="244.04"
          x2="1121.42"
          y2="252.83"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="b4b61301-67ac-4a50-ac3b-e51a396d6905"
          x1="1121.28"
          y1="245.71"
          x2="1121.47"
          y2="255.66"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="a2bcc8e0-f064-43c0-a8d4-bb63bbc1c97c"
          x1="1121.18"
          y1="247.41"
          x2="1121.51"
          y2="258.19"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="f444f5aa-e7a5-4f6b-a4a1-5966318ef460"
          x1="1121.05"
          y1="249.12"
          x2="1121.53"
          y2="260.43"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="b8cc4dcb-b485-4fc7-b6ec-c5d19c791492"
          x1="1120.89"
          y1="250.84"
          x2="1121.52"
          y2="262.34"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="a4ec58d8-ec1f-4ad5-86e6-5b4ed63b73d1"
          x1="1121.03"
          y1="255.55"
          x2="1121.53"
          y2="267.33"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="f562c511-fc14-4264-9169-fdc882498d18"
          x1="1121.16"
          y1="260.25"
          x2="1121.52"
          y2="272.09"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="b6d83e25-6457-4eed-9cb2-519409b3fa78"
          x1="1121.26"
          y1="264.96"
          x2="1121.48"
          y2="276.64"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="b593c2ca-2c12-45f9-a210-efd31e8e95a0"
          x1="1121.36"
          y1="269.67"
          x2="1121.43"
          y2="280.99"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="aa2d94e5-8d00-4131-91b0-e063c981ad28"
          x1="1121.43"
          y1="274.4"
          x2="1121.37"
          y2="285.14"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="ac566857-16d7-43c3-8a0d-5b0342961259"
          cx="1121"
          cy="262.16"
          r="39"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="ba5dc3ad-9640-4eb4-83ac-d45eeef27445"
          x1="19.21"
          y1="255.38"
          x2="19.19"
          y2="258.94"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="bf70bcc5-2f34-4ae4-b761-b0a011d7225f"
          x1="19.18"
          y1="256.18"
          x2="19.21"
          y2="260.46"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="a9267c93-e035-4ce8-acd5-3bcd79bdb6b3"
          x1="19.14"
          y1="256.99"
          x2="19.23"
          y2="261.83"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="b01302d9-400c-40cd-95e0-9ee9a74c3ae5"
          x1="19.09"
          y1="257.81"
          x2="19.25"
          y2="263.07"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="a0c674de-7f50-4f83-bf7e-dea81de0b49e"
          x1="19.02"
          y1="258.65"
          x2="19.26"
          y2="264.16"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="a8730845-1cf6-4296-a2f7-93b7df99caf2"
          x1="18.95"
          y1="259.48"
          x2="19.25"
          y2="265.09"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="a5fee7d8-3872-4a46-866e-5239a6298c65"
          x1="19.02"
          y1="261.78"
          x2="19.26"
          y2="267.52"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="f0b4392b-a31c-4b75-bc2e-965c71524c44"
          x1="19.08"
          y1="264.07"
          x2="19.25"
          y2="269.84"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="b79bff0f-04e3-44eb-ba02-7a183361766a"
          x1="19.13"
          y1="266.36"
          x2="19.23"
          y2="272.06"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="bddb0ffe-a506-47ff-9b4a-2e3c37ceba96"
          x1="19.17"
          y1="268.66"
          x2="19.21"
          y2="274.17"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="a8b263b1-f5de-4d84-ac83-6ae046b89b74"
          x1="19.21"
          y1="270.96"
          x2="19.18"
          y2="276.2"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="e7cedaba-c675-453f-a65e-3d0e0a00be41"
          cx="19"
          cy="265"
          r="19"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="a5bc01ad-b6df-4217-9d0b-0f4ac108fd93"
          x1="222.21"
          y1="345.38"
          x2="222.19"
          y2="348.94"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="b8e0f518-ac80-4970-91ec-30667050d5dd"
          x1="222.18"
          y1="346.18"
          x2="222.21"
          y2="350.46"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="e511fb5b-8cfd-4b2c-ab32-b972dbf89ca0"
          x1="222.14"
          y1="346.99"
          x2="222.23"
          y2="351.83"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="bc7ce822-c65a-44bf-ba1f-692039b7fb60"
          x1="222.09"
          y1="347.81"
          x2="222.25"
          y2="353.07"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="a05cba04-413e-43e4-a0c8-31fb9f8a7105"
          x1="222.02"
          y1="348.65"
          x2="222.26"
          y2="354.16"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="b39da79f-c650-4655-b018-666537597be8"
          x1="221.95"
          y1="349.48"
          x2="222.25"
          y2="355.09"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="fd9cfc3d-ef49-4141-bf9b-0c8a333b850e"
          x1="222.02"
          y1="351.78"
          x2="222.26"
          y2="357.52"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="a1243a90-1b2b-4d9c-87e7-36f2e30adf0b"
          x1="222.08"
          y1="354.07"
          x2="222.25"
          y2="359.84"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="b07e2b7d-e090-4bf0-9b78-ab3a85e02624"
          x1="222.13"
          y1="356.36"
          x2="222.23"
          y2="362.06"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="bb5351ec-6fcc-4be0-ba98-99df721a8162"
          x1="222.17"
          y1="358.66"
          x2="222.21"
          y2="364.17"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="eb8bd43f-40ab-40c7-b6e4-9c11445146ca"
          x1="222.21"
          y1="360.96"
          x2="222.18"
          y2="366.2"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="ab5f328d-8776-4191-8a58-ac5520c82187"
          cx="222"
          cy="355"
          r="19"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="adaa3490-e4c2-4bd4-992a-4dbc4232551d"
          x1="180.76"
          y1="214.12"
          x2="180.74"
          y2="218.34"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="a4024057-91df-46d6-afde-370f1cc103f7"
          x1="180.73"
          y1="215.06"
          x2="180.76"
          y2="220.13"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="f10a680e-9def-4756-aa4c-18df52b9f54b"
          x1="180.68"
          y1="216.02"
          x2="180.79"
          y2="221.77"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="affda58b-7601-4cec-92dc-57c3c11916e4"
          data-name="grad-12"
          x1="180.62"
          y1="217"
          x2="180.81"
          y2="223.23"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="e8b2ba0a-ecc5-491c-b4f2-0be25d7ae1c1"
          data-name="grad-11"
          x1="180.55"
          y1="217.99"
          x2="180.82"
          y2="224.52"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="b0eda82d-9a06-4545-936d-045379aa8d9f"
          x1="180.46"
          y1="218.98"
          x2="180.82"
          y2="225.63"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="b335d22a-2173-4f88-89fc-17c056297d61"
          x1="180.54"
          y1="221.7"
          x2="180.83"
          y2="228.51"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="a9fdd0cf-2b73-4cb7-8e56-72fd8be5ac25"
          x1="180.61"
          y1="224.42"
          x2="180.82"
          y2="231.26"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="bc8f25e9-a117-4a97-83be-b3e4cc85d435"
          x1="180.67"
          y1="227.14"
          x2="180.8"
          y2="233.88"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="e2d1c53d-ded8-4abf-8027-f89b0faf98cf"
          x1="180.72"
          y1="229.86"
          x2="180.77"
          y2="236.39"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="ac856df2-15b8-4a83-a9dd-840b8d4db090"
          x1="180.77"
          y1="232.59"
          x2="180.73"
          y2="238.79"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="e6db86c7-4258-492b-b46c-356c34cbfa60"
          cx="180.52"
          cy="225.52"
          r="22.52"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
        <linearGradient
          id="a82126c9-6222-4a8d-ae2a-f07613f6b65a"
          x1="74.76"
          y1="298.12"
          x2="74.74"
          y2="302.34"
          xlinkHref="#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c"
        />
        <linearGradient
          id="e854b514-d35c-4b45-80ce-f286932fe09b"
          x1="74.73"
          y1="299.06"
          x2="74.76"
          y2="304.13"
          xlinkHref="#edcae3fb-5bdc-4272-a1b1-23bed677300c"
        />
        <linearGradient
          id="aa6a86a4-9c20-4645-be0b-ae5b59e1bdc2"
          x1="74.68"
          y1="300.02"
          x2="74.79"
          y2="305.77"
          xlinkHref="#b1578dbc-05d9-4979-be41-e1046d346475"
        />
        <linearGradient
          id="b144f187-0e02-415d-af7c-7781a8efffa0"
          data-name="grad-12"
          x1="74.62"
          y1="301"
          x2="74.81"
          y2="307.23"
          xlinkHref="#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361"
        />
        <linearGradient
          id="bc12ca3c-a9fd-4752-8f11-70e6644baaf5"
          data-name="grad-11"
          x1="74.55"
          y1="301.99"
          x2="74.82"
          y2="308.52"
          xlinkHref="#a7bf3d33-71e8-4696-a6fd-5a16df62df00"
        />
        <linearGradient
          id="bf7e7cb1-b608-40f4-8a24-e3ec2bd7a0bb"
          x1="74.46"
          y1="302.98"
          x2="74.82"
          y2="309.63"
          xlinkHref="#e543d764-0bb6-4907-bc87-07a2c2b099f2"
        />
        <linearGradient
          id="a6ec3196-d0dd-4541-b782-0bae753ee60b"
          x1="74.54"
          y1="305.7"
          x2="74.83"
          y2="312.51"
          xlinkHref="#a0ec79a0-858d-4ac8-9ab4-c8aa86132615"
        />
        <linearGradient
          id="b3dd8cff-485c-4375-a4a3-cb242a5647bf"
          x1="74.61"
          y1="308.42"
          x2="74.82"
          y2="315.26"
          xlinkHref="#afe99a36-5f2c-49d1-99f2-ecc0315940ee"
        />
        <linearGradient
          id="e88108e1-f89d-445a-8090-92ff8bbc5cc9"
          x1="74.67"
          y1="311.14"
          x2="74.8"
          y2="317.88"
          xlinkHref="#a793eb4f-a46e-459a-9444-2c84971b614e"
        />
        <linearGradient
          id="a0abda93-0d3e-4546-9baf-ce67aa6b44ff"
          x1="74.72"
          y1="313.86"
          x2="74.77"
          y2="320.39"
          xlinkHref="#eca93904-f979-4ff2-817e-3ce3a60916f6"
        />
        <linearGradient
          id="bd2c30c0-1db6-4cea-8518-4c63bf53ab40"
          x1="74.77"
          y1="316.59"
          x2="74.73"
          y2="322.79"
          xlinkHref="#a275e7fe-7113-4525-8eb1-0622eeb65669"
        />
        <radialGradient
          id="efc490f2-5df7-4795-bb28-939b06cbcd15"
          cx="74.52"
          cy="309.52"
          r="22.52"
          xlinkHref="#b2a8039b-5155-4b37-a0f8-c500558db551"
        />
      </defs>
      <g>
        <path
          d="M889.69,0V97.73l63.09-.64V44.18Zm31.58,77.7A21.73,21.73,0,1,1,943,56,21.73,21.73,0,0,1,921.27,77.7Z"
          fill="#6d4c89"
        />
        <path
          d="M921.27,33.81a21.08,21.08,0,0,1,16.49,5.67A22.34,22.34,0,0,1,943.05,47a22.58,22.58,0,0,1,0,18,22.45,22.45,0,0,1-5.28,7.48,21.11,21.11,0,0,1-16.5,5.66,23.53,23.53,0,0,0,14.84-7.32,21.86,21.86,0,0,0,0-29.69A23.57,23.57,0,0,0,921.27,33.81Z"
          fill="#e59661"
        />
        <line
          x1="889.5"
          y1="0.5"
          x2="889.5"
          y2="97.5"
          fill="none"
          stroke="#e59661"
          strokeMiterlimit="10"
        />
      </g>
      <g>
        <g opacity="0.19">
          <g>
            <path
              d="M1068.31,242.86c.27-.27.56-.52.85-.76a8.7,8.7,0,0,1,1.36-.95c.43-.24.9-.4,1.35-.6a4.92,4.92,0,0,0,1.13-.66c.36-.3.65-.68,1-1a3.23,3.23,0,0,1,.92-.57q.38-.11.75-.18a3.74,3.74,0,0,1,.75,0,.1.1,0,0,0,.1-.09,5.07,5.07,0,0,1,5.29,3.06,1.47,1.47,0,0,0-.08.55,3.34,3.34,0,0,0,.35,1.18,2.3,2.3,0,0,1,.22,1.34,12.46,12.46,0,0,1-.56,1.43,2.28,2.28,0,0,0-.14.77,2.5,2.5,0,0,0,.15.72,1.87,1.87,0,0,1,.07.81,6.65,6.65,0,0,1-.23.76c-.07.26-.08.53-.13.8a4.29,4.29,0,0,1-.13.6,6.94,6.94,0,0,1-1.69,2.34,3.84,3.84,0,0,0-.84,1.43,6.88,6.88,0,0,0-.21,1.36,3.13,3.13,0,0,1-.23,1.09,3.6,3.6,0,0,1-1,1.18c-1,.81-2,1.48-3,2.35a8.05,8.05,0,0,0-.63.68c-.19.23-.36.47-.56.69a1.93,1.93,0,0,1-1,.61c-.35.08-.71.09-1.07.14a2.88,2.88,0,0,0-1.5.52,2.18,2.18,0,0,1-.67.5,1.84,1.84,0,0,1-.7.07,7.45,7.45,0,0,0-1.41-.11l-.06,0a4.75,4.75,0,0,1-3-2.12,8.24,8.24,0,0,0-.25-1.63,16.84,16.84,0,0,1-.45-1.83,5.56,5.56,0,0,1,0-.91c0-.31.06-.61.06-.92,0-.58-.11-1.16-.08-1.74a2.62,2.62,0,0,1,.25-.95,8.28,8.28,0,0,1,.47-.82,2.67,2.67,0,0,0,.34-.86,5.78,5.78,0,0,0,.13-.93c0-.41.06-.82.1-1.23a21.87,21.87,0,0,1,1.19-2.3,4.52,4.52,0,0,1,1-.25c.52-.08,1-.11,1.56-.18.07,0,.14-.08.11-.15-.18-.39-.38-.77-.53-1.18a1.77,1.77,0,0,1-.11-.91,1.6,1.6,0,0,1,.26-.58C1068,243.23,1068.14,243,1068.31,242.86Z"
              fill="#141c66"
            />
            <path d="M1079.27,239.59s-6.75,17-31.87,44" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1067.83,274.71c.44-.32.86-.67,1.27-1a36.19,36.19,0,0,1,7.91-2.79c.37.06.74.11,1.11.14s.92,0,1.38,0h1.61a10.86,10.86,0,0,0,3.05-.38c.48-.14.92-.39,1.39-.58.32-.12.64-.23,1-.33,5.19,0,9,1.26,9.38,3.46a2.15,2.15,0,0,1,0,.91c-.09.13-.18.25-.28.37a6.28,6.28,0,0,1-1.53,1.38,9.51,9.51,0,0,1-1.83.85,12.72,12.72,0,0,0-2.23.83,8.14,8.14,0,0,0-1.68,1.36,10.8,10.8,0,0,1-1.66,1.43,3,3,0,0,1-1.82.57,5.74,5.74,0,0,1-1.35-.43,5.53,5.53,0,0,0-1.66-.3,1.59,1.59,0,0,0-1.19.35c-.32.32-.55.72-.87,1.05a3.72,3.72,0,0,1-2.93,1,14.52,14.52,0,0,1-3.26-.73c-.57-.17-1.15-.32-1.74-.44-.3-.06-.6-.11-.9-.14s-.69,0-1-.07a13.59,13.59,0,0,1-4-1.14c-.66-.27-1.32-.52-2-.72-.2-1.12.5-2.34,1.88-3.52A9.19,9.19,0,0,0,1067.83,274.71Z"
              fill="#141c66"
            />
            <path d="M1096.62,273.61s-29.54.62-49.14,11.34" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1065.48,276.71c.39-.2.76-.42,1.13-.64a28,28,0,0,1,6.55-1.18c.29.09.57.18.86.25s.72.12,1.08.18l1.26.19a8.68,8.68,0,0,0,2.44.09c.39-.05.77-.19,1.16-.28s.53-.1.8-.13c4.07.66,6.87,2.12,6.92,3.9a1.75,1.75,0,0,1-.13.71,3.07,3.07,0,0,1-.26.25,4.8,4.8,0,0,1-1.38.89,6.77,6.77,0,0,1-1.54.43,11.43,11.43,0,0,0-1.85.37,6.34,6.34,0,0,0-1.49.86,9,9,0,0,1-1.48.9,2.33,2.33,0,0,1-1.51.22,4.11,4.11,0,0,1-1-.51,4.29,4.29,0,0,0-1.26-.44,1.21,1.21,0,0,0-1,.12c-.3.21-.53.5-.82.71a3,3,0,0,1-2.43.44,11.41,11.41,0,0,1-2.46-1c-.43-.2-.86-.4-1.31-.56a5.08,5.08,0,0,0-.69-.23c-.26-.08-.53-.12-.8-.18a11,11,0,0,1-3-1.41c-.48-.29-1-.57-1.46-.82,0-.9.69-1.77,1.92-2.52A6.76,6.76,0,0,0,1065.48,276.71Z"
              fill="#141c66"
            />
            <path d="M1088.19,279.5s-23.23-3.27-40,2.65" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1061,271.09a.61.61,0,0,0,.46,0,.65.65,0,0,0,.23-.48,4.75,4.75,0,0,0,0-.92v0a4.41,4.41,0,0,0,.62.09.77.77,0,0,0,.43-.08c.24-.16.16-.49.1-.71s-.09-.33-.14-.49c.33-.38.68-.76,1-1.15l.23.19a4.78,4.78,0,0,0,.59.41,1.15,1.15,0,0,0,.53.2.12.12,0,0,0,.14-.13c0-.25-.11-.49-.16-.73a1.56,1.56,0,0,1,0-.71c.07-.27.36-.32.56-.46a.68.68,0,0,0,.23-.52,2.81,2.81,0,0,0,0-.29c.47-.44,1-.87,1.46-1.31l.33.24a2,2,0,0,0,.9.44.74.74,0,0,0,.8-.42,1.72,1.72,0,0,0,0-1.12,5.1,5.1,0,0,0-.19-.55l.47-.51c.51-.4,1-.81,1.58-1.21h.09a.9.9,0,0,1,.41.16,1.91,1.91,0,0,0,.67.19.11.11,0,0,0,.13-.1c0-.34-.09-1.05.37-1.17.13,0,.26.12.38.17a.34.34,0,0,0,.43-.08c.19-.24.06-.6.15-.88s.46,0,.57.16a6.34,6.34,0,0,0,.61.76c.08.07.19,0,.19-.11,0-.61,0-1.22-.08-1.83,1.17-.75,2.32-1.44,3.42-2.05,0,.08,0,.15.08.22a.12.12,0,0,0,.17.05,4.7,4.7,0,0,1,.17,1.05c0,.21,0,.43,0,.64s.22.19.23,0a5.17,5.17,0,0,0,0-.68,10.44,10.44,0,0,0-.15-1.59c1-.52,1.9-1,2.77-1.35a4.77,4.77,0,0,1,.21,1.3c0,.19,0,.38,0,.56a.12.12,0,0,0,.23,0,3,3,0,0,0,.06-.59c0-.38.08-.75.11-1.13,0-.14,0-.28,0-.43a20.82,20.82,0,0,1,2.58-.88,13,13,0,0,0,.43,1.63.12.12,0,0,0,.18.05,2.51,2.51,0,0,0,.69-1.23,5.55,5.55,0,0,0,.15-.73,2.48,2.48,0,0,1,2.33.6c.81,1.08-.23,3.38-2.55,6.17-.47-.09-.94-.16-1.41-.23a.12.12,0,0,0-.06.22,8.27,8.27,0,0,0,1.16.38c-.62.72-1.32,1.48-2.1,2.25a20.7,20.7,0,0,0-2.35.44.12.12,0,0,0-.1.13c.08.49.2,1,.31,1.46-1.15,1-2.41,2.07-3.75,3.11a9.41,9.41,0,0,0-2.33.55,5.11,5.11,0,0,0-1.45,1c-.22.2-.43.4-.66.59s-.46.35-.66.55c-.39.39-.68.86-1.06,1.26a1.32,1.32,0,0,1-1.28.51,3.22,3.22,0,0,1-.89-.57.45.45,0,0,0-.37-.09.59.59,0,0,0-.31.33,2.44,2.44,0,0,0-.09,1.34l.06.42c-4.68,2.45-8.35,3.33-9.36,2-.63-.84-.14-2.4,1.19-4.36Z"
              fill="#141c66"
            />
            <path d="M1083.86,257.26s-33.3,25.52-36.21,26.95" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1072.85,256.26a1.52,1.52,0,0,1,.53.72l-.21.78a12.16,12.16,0,0,0-.25,1.2,9.46,9.46,0,0,1-.25,1.15,8.22,8.22,0,0,1-.77,1.68,7.71,7.71,0,0,0-1,1.85c-.14.56-.13,1.13-.22,1.69v0l-.49.73a22.63,22.63,0,0,1-3.62,4.06l-.36.22a31.8,31.8,0,0,0-3.5,1.76,1.55,1.55,0,0,1-.88-.26c-1.59-1.11-.42-5.51,2.61-9.82S1071.26,255.15,1072.85,256.26Z"
              fill="#141c66"
            />
            <path d="M1064.5,262s1.49,8.76-15.06,21.43" fill="#141c66" />
            <path
              d="M1072.08,258.39a4.4,4.4,0,0,1-1,2.12,9.51,9.51,0,0,0-1.49,1.67,3.32,3.32,0,0,0-.36,1.16c0,.39,0,.77-.1,1.16a2.4,2.4,0,0,1-.46,1.14,1.94,1.94,0,0,1-.78.53,5.16,5.16,0,0,0-.86.47,3.22,3.22,0,0,0-.81,1.11,3.77,3.77,0,0,1-.85,1.12,3,3,0,0,1-.78.4,2.52,2.52,0,0,0-.79.52,2.37,2.37,0,0,0-.52.74,1.68,1.68,0,0,1-.43.65,2.4,2.4,0,0,1-1.09.39l-.12,0a1,1,0,0,1-.35-.14c-1.26-.88.18-5.09,3.21-9.4s6.5-7.09,7.76-6.21a1,1,0,0,1,.35.5A9,9,0,0,0,1072.08,258.39Z"
              fill="#141c66"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1018.21,224.93c-.08-.53-.12-1.08-.15-1.61a13.39,13.39,0,0,1,.07-2.37c.1-.7.31-1.38.47-2.06a6.82,6.82,0,0,0,.2-1.85c0-.68-.22-1.34-.27-2a4.44,4.44,0,0,1,.14-1.54c.13-.35.27-.69.42-1a8.8,8.8,0,0,1,.6-.9.14.14,0,0,0,0-.19,7.58,7.58,0,0,1,3.6-3.14,7.45,7.45,0,0,1,4.42-.31,2.22,2.22,0,0,0,.54.56,4.68,4.68,0,0,0,1.66.61,3.21,3.21,0,0,1,1.72.89,15.6,15.6,0,0,1,1.16,1.86,3.53,3.53,0,0,0,.77.82,3.58,3.58,0,0,0,1,.44,2.63,2.63,0,0,1,1,.62,8.49,8.49,0,0,1,.68.9,7.81,7.81,0,0,0,.8.83c.2.21.4.43.58.66.85,1.12.91,2.61,1.23,3.94a5.55,5.55,0,0,0,.92,2.18,10.66,10.66,0,0,0,1.38,1.39,4.31,4.31,0,0,1,1.05,1.2,5.22,5.22,0,0,1,.47,2.21c.09,1.8-.06,3.61.15,5.41a11.58,11.58,0,0,0,.23,1.31c.1.41.24.81.32,1.23a2.82,2.82,0,0,1-.12,1.6,13.57,13.57,0,0,1-.74,1.35,4,4,0,0,0-.69,2.16,3.23,3.23,0,0,1,0,1.2,2.57,2.57,0,0,1-.53.86,11.32,11.32,0,0,0-1.33,1.52.29.29,0,0,0,0,.09,7,7,0,0,1-1.86,1.11,7.1,7.1,0,0,1-3.1.49,11,11,0,0,0-2.09-1.1,24.57,24.57,0,0,1-2.48-1.05,7.34,7.34,0,0,1-1.09-.72c-.35-.27-.64-.59-1-.85-.67-.5-1.44-.86-2.07-1.4a3.58,3.58,0,0,1-.88-1.09c-.21-.4-.36-.83-.54-1.25a4.09,4.09,0,0,0-.68-1.11,10.76,10.76,0,0,0-1-.95c-.43-.39-.89-.76-1.33-1.15a34.22,34.22,0,0,1-1.62-3.33,6.67,6.67,0,0,1,.59-1.37c.35-.66.76-1.29,1.12-1.94,0-.08,0-.23-.09-.25-.6-.13-1.21-.23-1.79-.41a2.52,2.52,0,0,1-1.15-.64,2.36,2.36,0,0,1-.44-.79C1018.35,225.63,1018.28,225.28,1018.21,224.93Z"
              fill="#396039"
            />
            <path
              d="M1023.81,209.6a123.78,123.78,0,0,1,8.18,17.64c2.34,6,4.37,12.22,6.24,18.43s3.41,12.53,4.91,18.84c.73,3.16,1.38,6.34,2.07,9.5l1.78,9.57-1.94-9.53c-.72-3.16-1.38-6.34-2.13-9.49-1.53-6.3-3.12-12.59-5-18.79s-3.82-12.39-6.13-18.45L1030,222.8c-.64-1.49-1.23-3-1.91-4.47A89.24,89.24,0,0,0,1023.81,209.6Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1054.28,252.65c0-.78,0-1.56-.09-2.33a51.72,51.72,0,0,1,3.56-11.44c.38-.37.76-.75,1.1-1.15s.8-1,1.18-1.58.91-1.23,1.35-1.85a15.54,15.54,0,0,0,2.18-3.81c.24-.69.33-1.4.52-2.1.12-.47.28-.93.44-1.39,4.44-5.94,9.09-9.19,12-7.8a3.3,3.3,0,0,1,1,.8c.07.2.13.41.19.62a9.09,9.09,0,0,1,.26,2.94,12.4,12.4,0,0,1-.58,2.82,20.31,20.31,0,0,0-1,3.26,11.78,11.78,0,0,0,.13,3.08,15.55,15.55,0,0,1,.22,3.12,4.25,4.25,0,0,1-.9,2.58,8.33,8.33,0,0,1-1.64,1.18,7.87,7.87,0,0,0-1.76,1.65,2.21,2.21,0,0,0-.61,1.65c.08.64.35,1.25.46,1.89A5.33,5.33,0,0,1,1071,249a21,21,0,0,1-3.61,3.11c-.68.52-1.35,1-2,1.62-.33.29-.64.59-.94.9s-.63.76-1,1.13a19.16,19.16,0,0,1-4.77,3.67c-.86.52-1.71,1.06-2.51,1.66-1.45-.73-2.26-2.57-2.44-5.15A12.44,12.44,0,0,0,1054.28,252.65Z"
              fill="#2f4f2f"
            />
            <path
              d="M1077.57,218.74c-1.7,2.49-3.33,5-4.9,7.62s-3.13,5.18-4.62,7.81q-4.46,7.89-8.27,16.13a171.92,171.92,0,0,0-6.76,16.81c-.88,2.89-1.84,5.75-2.5,8.7-.83,2.91-1.28,5.91-1.86,8.88a107,107,0,0,1,4.15-17.65,173.63,173.63,0,0,1,6.66-16.89q3.87-8.21,8.39-16.09C1070.87,228.81,1074.07,223.67,1077.57,218.74Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1054.57,257c.1-.61.17-1.23.22-1.84a41.26,41.26,0,0,1,4.24-8.51c.35-.25.7-.5,1-.77s.75-.72,1.12-1.09l1.3-1.27a12.65,12.65,0,0,0,2.18-2.71c.28-.51.44-1,.68-1.58.16-.35.34-.69.52-1,4.24-4.1,8.29-6.05,10.37-4.6a2.59,2.59,0,0,1,.71.76c0,.17,0,.34.07.51a7.09,7.09,0,0,1-.17,2.34,10.16,10.16,0,0,1-.81,2.13,16,16,0,0,0-1.16,2.44,9,9,0,0,0-.29,2.43,12,12,0,0,1-.23,2.47,3.28,3.28,0,0,1-1,1.91,6,6,0,0,1-1.43.71,6.34,6.34,0,0,0-1.59,1.07,1.76,1.76,0,0,0-.69,1.22c0,.52.12,1,.12,1.54a4.25,4.25,0,0,1-1.58,3.16,17.4,17.4,0,0,1-3.22,2c-.6.31-1.2.64-1.77,1-.28.19-.57.38-.84.59s-.59.51-.89.77a15.28,15.28,0,0,1-4.21,2.26c-.73.31-1.47.62-2.17,1-1-.76-1.45-2.3-1.26-4.35A10.26,10.26,0,0,0,1054.57,257Z"
              fill="#396039"
            />
            <path
              d="M1077.13,233.42q-2.48,2.61-4.8,5.36c-1.57,1.82-3.1,3.66-4.6,5.54q-4.5,5.63-8.53,11.59a139.71,139.71,0,0,0-7.44,12.31c-1,2.15-2.17,4.27-3.07,6.5s-1.76,4.46-2.59,6.71a84.7,84.7,0,0,1,5.46-13.32,139.38,139.38,0,0,1,7.37-12.39q4.08-5.94,8.62-11.54C1070.58,240.45,1073.75,236.83,1077.13,233.42Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1044.31,257.38a.85.85,0,0,0,.35-.57,1,1,0,0,0-.36-.67,7.35,7.35,0,0,0-1-.81v0a4.23,4.23,0,0,0,.63-.64,1,1,0,0,0,.27-.56c0-.41-.41-.59-.73-.72l-.68-.25c-.14-.7-.28-1.43-.41-2.19l.41-.1a8.62,8.62,0,0,0,1-.32,1.82,1.82,0,0,0,.68-.44.17.17,0,0,0,0-.26c-.3-.18-.65-.31-1-.46a2.17,2.17,0,0,1-.85-.54c-.25-.31-.06-.68-.06-1a1,1,0,0,0-.39-.69,2.78,2.78,0,0,0-.33-.27c-.09-.91-.18-1.84-.25-2.79l.56-.16a3.05,3.05,0,0,0,1.27-.67,1,1,0,0,0,.19-1.27,2.41,2.41,0,0,0-1.28-1,6.24,6.24,0,0,0-.8-.26c0-.32-.11-.64-.17-1,0-.93,0-1.88,0-2.84a.44.44,0,0,1,.08-.11,1.44,1.44,0,0,1,.53-.33,2.85,2.85,0,0,0,.79-.6.16.16,0,0,0,0-.23c-.38-.32-1.29-.8-1-1.42.07-.18.37-.21.52-.29a.5.5,0,0,0,.28-.57c-.12-.42-.64-.58-.88-.92s.41-.51.66-.53a8,8,0,0,0,1.39,0,.17.17,0,0,0,0-.31c-.71-.5-1.42-1-2.16-1.46.13-2,.32-3.9.57-5.67l.31.09a.17.17,0,0,0,.21-.15,7.21,7.21,0,0,1,1.35.7c.25.17.49.36.73.55s.4-.09.24-.24a8.87,8.87,0,0,0-.78-.59,15.45,15.45,0,0,0-1.94-1.18c.23-1.55.5-3,.81-4.33a6.63,6.63,0,0,1,1.67.87l.61.55a.17.17,0,0,0,.23-.24,4.15,4.15,0,0,0-.62-.57c-.4-.37-.79-.74-1.2-1.09l-.48-.38a29.69,29.69,0,0,1,1.18-3.71,20.53,20.53,0,0,0,2.24.9.16.16,0,0,0,.21-.16,3.59,3.59,0,0,0-.82-1.83,6.75,6.75,0,0,0-.71-.81c.82-1.38,1.73-2.15,2.68-2.15,1.93,0,3.66,3.15,4.89,8.19-.51.45-1,.93-1.47,1.4a.17.17,0,0,0,.21.27,10.93,10.93,0,0,0,1.41-1c.31,1.33.57,2.78.8,4.33a25.48,25.48,0,0,0-1.5,3.06.17.17,0,0,0,.06.23c.63.33,1.29.6,1.93.89.2,2.19.33,4.52.37,6.94a12.68,12.68,0,0,0-1.35,3.14,7.07,7.07,0,0,0-.11,2.51c0,.42.09.83.11,1.25s0,.82.07,1.23c.12.78.41,1.52.54,2.29a1.87,1.87,0,0,1-.51,1.89,4.17,4.17,0,0,1-1.41.54.67.67,0,0,0-.42.35.85.85,0,0,0,.12.64,3.37,3.37,0,0,0,1.45,1.24l.53.29c-1.18,7.45-3.3,12.41-5.72,12.41-1.49,0-2.87-1.89-4-5.09Z"
              fill="#659965"
            />
            <path
              d="M1048,219.4c.29,10.74.37,21.48.5,32.23l0,16.12c-.06,5.37,0,10.75-.48,16.11.26-2.68.2-5.37.24-8.05l0-8.06-.1-16.12Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1037.43,231.17a2.11,2.11,0,0,1,1.27,0l.72.91c.37.45.75.89,1.16,1.3a13.35,13.35,0,0,1,1.1,1.27A11.36,11.36,0,0,1,1043,237a10.65,10.65,0,0,0,1.32,2.66c.51.63,1.18,1.11,1.75,1.69l0,0c.15.39.28.78.42,1.18a32.47,32.47,0,0,1,1.57,7.61q0,.3-.06.6c-.25,1.83-.93,3.65-1,5.5a2.28,2.28,0,0,1-1,.8c-2.63.86-6.67-4.23-9-11.37S1034.81,232,1037.43,231.17Z"
              fill="#3b6818"
            />
            <path
              d="M1036.93,245.66s11.31,5.76,11.7,35.52"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.34"
            />
            <path
              d="M1039.22,233.86a6.42,6.42,0,0,1,1.56,3,13.92,13.92,0,0,0,.64,3.13,4.28,4.28,0,0,0,1,1.4c.4.38.84.71,1.23,1.1a3.39,3.39,0,0,1,.92,1.51,2.87,2.87,0,0,1,0,1.34,6.39,6.39,0,0,0-.2,1.4,4.67,4.67,0,0,0,.57,1.87,5.31,5.31,0,0,1,.57,1.93,4.46,4.46,0,0,1-.21,1.23,3.79,3.79,0,0,0-.09,1.35,3.28,3.28,0,0,0,.42,1.22,2.7,2.7,0,0,1,.37,1,3.26,3.26,0,0,1-.48,1.57l-.09.17a1.21,1.21,0,0,1-.46.28c-2.07.68-5.66-4.56-8-11.7s-2.57-13.49-.5-14.17a1.37,1.37,0,0,1,.87,0A13.23,13.23,0,0,0,1039.22,233.86Z"
              fill="#659965"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            d="M652,117s36-20,94,4l13.5-20.5S703,80,672,102Z"
            fill="#415c93"
          />
          <line
            x1="651.5"
            y1="94.5"
            x2="651.5"
            y2="116.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="700.5"
            y1="100.5"
            x2="700.5"
            y2="109.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="710.5"
            y1="82.5"
            x2="710.5"
            y2="91.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="748.5"
            y1="98.5"
            x2="748.5"
            y2="120.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="759.5"
            y1="78.5"
            x2="759.5"
            y2="100.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="671.5"
            y1="80.5"
            x2="671.5"
            y2="102.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            d="M651.5,97.72s24,16.78,49-.22c0,0,15,15,48,5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <path
            d="M672,83.38s15.51,13.91,38.51,1c0,0,36,16.77,49-3.56"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M752.33,109s-36.46-17.27-86.65-2.88"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      <g>
        <path
          d="M832.56,94.71c1.8-3,2.41-3.64,1.65-5.64s-1.5-.29-.74-4A3.9,3.9,0,0,0,830,80c-1.32-.14-7.57,3.53-6.52,5.52s1.51,7.66.38,8.13S830.45,98.2,832.56,94.71Z"
          fill="#396039"
        />
        <path
          d="M831.36,87.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S831.36,87.81,831.36,87.81Z"
          fill="#447244"
        />
        <path
          d="M835.91,85c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S835.91,85,835.91,85Z"
          fill="#6b996b"
        />
        <path
          d="M829,97.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.46-1-3.69,1.11-3.78,1.84A4.74,4.74,0,0,0,822.29,97C824.11,97.73,827.11,96,829,97.38Z"
          fill="#447244"
        />
        <path
          d="M835.34,99c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C840.19,99.38,837.19,97.62,835.34,99Z"
          fill="#447244"
        />
        <path
          d="M839.2,96.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0A3.92,3.92,0,0,1,842,98.67a3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,839.2,96.21Z"
          fill="#396039"
        />
        <path
          d="M832.83,97.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,832.83,97.7Z"
          fill="#704d3c"
        />
        <path
          d="M836,97.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
          fill="#634b42"
        />
        <path
          d="M830.64,96.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,830.64,96.34Z"
          fill="#44322c"
        />
        <path
          d="M835.39,96.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1.05-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,835.39,96.79Z"
          fill="#6b996b"
        />
        <g>
          <path d="M831,94.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
          <path
            d="M831,94.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C831.24,93.05,831,93.84,831,94.43Z"
            fill="#634b42"
          />
        </g>
        <path
          d="M827.77,94.32c-.56-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,827.77,94.32Z"
          fill="#6b996b"
        />
        <path
          d="M828.89,86.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S828.89,86.08,828.89,86.08Z"
          fill="#6b996b"
        />
        <path
          d="M823.11,96.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C822.3,96.7,822.94,96,823.11,96.23Z"
          fill="#447244"
        />
        <path
          d="M835,99.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.26,1.26,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C834.8,100.14,834.54,99.9,835,99.9Z"
          fill="#396039"
        />
        <path
          d="M832.62,92.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1,.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.75.34-1.63-.31-2.19-1.34l-.25-.51h0S832.21,93.39,832.62,92.48Z"
          fill="#447244"
        />
        <path
          d="M840.08,91.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.27-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S840.78,94.12,840.08,91.92Z"
          fill="#447244"
        />
        <path
          d="M829,113.05s.24-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C829,113.32,829,113.05,829,113.05Z"
          fill="#44322c"
        />
        <path
          d="M832,112.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-1.95,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.14.57a3.16,3.16,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,832,112.93Z"
          fill="#44322c"
        />
        <path
          d="M831.35,105.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92,2.62,2.62,0,0,0-.72,1.72,3.89,3.89,0,0,0,.25,1.87,7.5,7.5,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C831.43,106.77,831.18,106,831.35,105.41Z"
          fill="#44322c"
        />
        <path
          d="M831.35,92.93c0,.38.17.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C831.47,93.68,831.35,93.31,831.35,92.93Z"
          fill="#44322c"
        />
      </g>
      <g>
        <g>
          <rect
            x="817.16"
            y="130.53"
            width="1.27"
            height="22.47"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="817.8"
              cy="124.57"
              rx="2.61"
              ry="0.51"
              fill="url(#bd71d05b-8f0a-4d12-9cd6-1ff9d9db735c)"
            />
            <ellipse
              cx="817.8"
              cy="125.46"
              rx="3.6"
              ry="0.67"
              fill="url(#edcae3fb-5bdc-4272-a1b1-23bed677300c)"
            />
            <ellipse
              cx="817.8"
              cy="126.35"
              rx="4.59"
              ry="0.83"
              fill="url(#b1578dbc-05d9-4979-be41-e1046d346475)"
            />
            <ellipse
              cx="817.8"
              cy="127.24"
              rx="5.57"
              ry="0.99"
              fill="url(#fe6b45fa-5f4d-41a8-a2a9-2fcd139ba361)"
            />
            <ellipse
              cx="817.8"
              cy="128.13"
              rx="6.56"
              ry="1.15"
              fill="url(#a7bf3d33-71e8-4696-a6fd-5a16df62df00)"
            />
            <ellipse
              cx="817.8"
              cy="129.03"
              rx="7.55"
              ry="1.31"
              fill="url(#e543d764-0bb6-4907-bc87-07a2c2b099f2)"
            />
            <ellipse
              cx="817.8"
              cy="130.34"
              rx="6.81"
              ry="1.2"
              fill="url(#a0ec79a0-858d-4ac8-9ab4-c8aa86132615)"
            />
            <ellipse
              cx="817.8"
              cy="131.65"
              rx="6.07"
              ry="1.09"
              fill="url(#afe99a36-5f2c-49d1-99f2-ecc0315940ee)"
            />
            <ellipse
              cx="817.8"
              cy="132.96"
              rx="5.32"
              ry="0.98"
              fill="url(#a793eb4f-a46e-459a-9444-2c84971b614e)"
            />
            <ellipse
              cx="817.8"
              cy="134.27"
              rx="4.58"
              ry="0.86"
              fill="url(#eca93904-f979-4ff2-817e-3ce3a60916f6)"
            />
            <ellipse
              cx="817.8"
              cy="135.58"
              rx="3.84"
              ry="0.75"
              fill="url(#a275e7fe-7113-4525-8eb1-0622eeb65669)"
            />
          </g>
        </g>
        <circle
          cx="817.67"
          cy="129.67"
          r="12.67"
          fill="url(#b2a8039b-5155-4b37-a0f8-c500558db551)"
        />
      </g>
      <g>
        <g>
          <rect
            x="915"
            y="178.82"
            width="1.25"
            height="22.18"
            rx="0.63"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="915.63"
              cy="172.95"
              rx="2.57"
              ry="0.51"
              fill="url(#f1fcf38c-9301-468b-bd64-79dba11ade5c)"
            />
            <ellipse
              cx="915.63"
              cy="173.83"
              rx="3.55"
              ry="0.66"
              fill="url(#b8801255-1ccd-46b2-b96c-f7f50fac117e)"
            />
            <ellipse
              cx="915.63"
              cy="174.7"
              rx="4.52"
              ry="0.82"
              fill="url(#a643feb2-9ac1-426a-8a2b-14f8d8f8540d)"
            />
            <ellipse
              cx="915.63"
              cy="175.58"
              rx="5.5"
              ry="0.98"
              fill="url(#a4101cc1-25eb-4486-9a35-76f3ef8ce09e)"
            />
            <ellipse
              cx="915.63"
              cy="176.46"
              rx="6.48"
              ry="1.13"
              fill="url(#afeed956-40cf-4a91-a6b0-c09b37e4bc8c)"
            />
            <ellipse
              cx="915.63"
              cy="177.34"
              rx="7.45"
              ry="1.29"
              fill="url(#b6031f31-7047-474e-8c9f-02851daa34f8)"
            />
            <ellipse
              cx="915.63"
              cy="178.63"
              rx="6.72"
              ry="1.18"
              fill="url(#bd259be6-bb1e-4067-b01c-15f3d44bce3b)"
            />
            <ellipse
              cx="915.63"
              cy="179.93"
              rx="5.99"
              ry="1.07"
              fill="url(#a8d54fbe-9b8d-46fa-9f8a-53d0865309c9)"
            />
            <ellipse
              cx="915.63"
              cy="181.22"
              rx="5.25"
              ry="0.96"
              fill="url(#a2ec5343-ea0a-4542-b1e8-031a514b72f5)"
            />
            <ellipse
              cx="915.63"
              cy="182.52"
              rx="4.52"
              ry="0.85"
              fill="url(#a8ef8ec2-c1f4-45cc-904a-febf3d047db4)"
            />
            <ellipse
              cx="915.63"
              cy="183.81"
              rx="3.79"
              ry="0.74"
              fill="url(#a999e1c0-8365-41a3-86b6-9c6879ffc5b7)"
            />
          </g>
        </g>
        <circle
          cx="915.5"
          cy="177.97"
          r="12.5"
          fill="url(#fe7cbc1d-7be2-44a3-837c-7c5450e91c33)"
        />
      </g>
      <g>
        <g>
          <rect
            x="843.16"
            y="96.53"
            width="1.27"
            height="22.47"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="843.8"
              cy="90.57"
              rx="2.61"
              ry="0.51"
              fill="url(#e50eba5a-ba20-46fd-a14e-4222aed9199c)"
            />
            <ellipse
              cx="843.8"
              cy="91.46"
              rx="3.6"
              ry="0.67"
              fill="url(#b2189e5f-eb01-4d62-a2d6-0c48248eb5cc)"
            />
            <ellipse
              cx="843.8"
              cy="92.35"
              rx="4.59"
              ry="0.83"
              fill="url(#b37e09ef-eada-4d99-92d6-68d6ddf042e6)"
            />
            <ellipse
              cx="843.8"
              cy="93.24"
              rx="5.57"
              ry="0.99"
              fill="url(#b3ae698a-f590-4b75-9371-0f09215d57df)"
            />
            <ellipse
              cx="843.8"
              cy="94.13"
              rx="6.56"
              ry="1.15"
              fill="url(#ae302e20-1eb2-4f55-bead-1db821c211e4)"
            />
            <ellipse
              cx="843.8"
              cy="95.03"
              rx="7.55"
              ry="1.31"
              fill="url(#ade823d4-0c9e-4ec5-abf0-e8d417681d20)"
            />
            <ellipse
              cx="843.8"
              cy="96.34"
              rx="6.81"
              ry="1.2"
              fill="url(#f5928045-49e1-4d3f-b8cc-458b3134b3ae)"
            />
            <ellipse
              cx="843.8"
              cy="97.65"
              rx="6.07"
              ry="1.09"
              fill="url(#bf17acb9-c983-4309-af26-1fba2298681a)"
            />
            <ellipse
              cx="843.8"
              cy="98.96"
              rx="5.32"
              ry="0.98"
              fill="url(#baa233bb-f001-4586-9aa5-7e5b2740eefa)"
            />
            <ellipse
              cx="843.8"
              cy="100.27"
              rx="4.58"
              ry="0.86"
              fill="url(#b06b4701-5c6d-41e1-9e2e-b39f69791741)"
            />
            <ellipse
              cx="843.8"
              cy="101.58"
              rx="3.84"
              ry="0.75"
              fill="url(#fba9e733-e0f6-4612-8134-646343c20ef7)"
            />
          </g>
        </g>
        <circle
          cx="843.67"
          cy="95.67"
          r="12.67"
          fill="url(#fe23bdc3-5585-4910-90d8-a643e6ced625)"
        />
      </g>
      <g>
        <g>
          <rect
            x="1128.44"
            y="123.8"
            width="3.91"
            height="69.2"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="1130.4"
              cy="105.47"
              rx="8.03"
              ry="1.58"
              fill="url(#ff7f4347-695a-4ac0-a468-c0d5b25a5bc0)"
            />
            <ellipse
              cx="1130.4"
              cy="108.22"
              rx="11.07"
              ry="2.07"
              fill="url(#b245e1b4-7f64-4dcd-9c2f-b74fab4cb8d4)"
            />
            <ellipse
              cx="1130.4"
              cy="110.96"
              rx="14.12"
              ry="2.56"
              fill="url(#b3445430-a77f-443b-9372-3b7a820c62fd)"
            />
            <ellipse
              cx="1130.4"
              cy="113.7"
              rx="17.16"
              ry="3.05"
              fill="url(#a9963598-83fe-4cfc-9713-0757f422d7e4)"
            />
            <ellipse
              cx="1130.4"
              cy="116.44"
              rx="20.2"
              ry="3.54"
              fill="url(#aeba4199-e341-4758-a931-01977ce58711)"
            />
            <ellipse
              cx="1130.4"
              cy="119.18"
              rx="23.25"
              ry="4.03"
              fill="url(#af5afef0-9853-48f4-b546-c42a0049cfff)"
            />
            <ellipse
              cx="1130.4"
              cy="123.22"
              rx="20.96"
              ry="3.69"
              fill="url(#e3658ef8-be2b-4a33-84bf-099fb73e096b)"
            />
            <ellipse
              cx="1130.4"
              cy="127.26"
              rx="18.68"
              ry="3.35"
              fill="url(#b50aa4af-7373-4709-8e8f-843273b83b55)"
            />
            <ellipse
              cx="1130.4"
              cy="131.29"
              rx="16.39"
              ry="3"
              fill="url(#a992d583-10e8-40fc-9a2c-ff06f37551d7)"
            />
            <ellipse
              cx="1130.4"
              cy="135.33"
              rx="14.11"
              ry="2.66"
              fill="url(#a45fd7ca-e49d-4bc3-b302-f6f94c003c3a)"
            />
            <ellipse
              cx="1130.4"
              cy="139.37"
              rx="11.82"
              ry="2.32"
              fill="url(#f01f425c-d059-4dd3-b1c5-14e49e51ae0c)"
            />
          </g>
        </g>
        <circle
          cx="1130"
          cy="121.16"
          r="39"
          fill="url(#b9ad089b-2bc1-4965-b434-a09090273333)"
        />
      </g>
      <g>
        <path
          d="M773.21,246.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M776.41,247.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S776.4,241.76,776.41,247.51Z"
          fill="#43771c"
        />
        <path
          d="M773.21,247.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.31-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S773.22,241.76,773.21,247.51Z"
          fill="#43771c"
        />
        <path
          d="M777.47,250.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C766.47,245.41,777.05,248,777.47,250.2Z"
          fill="#529022"
        />
        <path
          d="M774.36,249.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C784.75,246.11,774.55,247.65,774.36,249.91Z"
          fill="#529022"
        />
        <path
          d="M777.85,249s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.35,1.58C768.81,249.82,777.2,247.07,777.85,249Z"
          fill="#426642"
        />
        <path
          d="M773.21,249.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C783.8,250.18,774,247.25,773.21,249.44Z"
          fill="#426642"
        />
        <path
          d="M776,249.9c-.69-8.8,8.59-19.05,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.09,9.88,0,0-4.85-4.06-10.62,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M775.45,249.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.7,7.62,0,0-3.74-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
          fill="#396039"
        />
        <path
          d="M774.59,252.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S774.59,249.26,774.59,252.58Z"
          fill="#659965"
        />
        <path
          d="M776.1,251.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S776.1,248,776.1,251.3Z"
          fill="#659965"
        />
        <path
          d="M784.53,279.63c-1-2.59-1.21-17.95-7-29,.78,3.06,5.95,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S785.65,282.52,784.53,279.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <g>
        <g>
          <rect
            x="1119.44"
            y="264.8"
            width="3.91"
            height="69.2"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="1121.4"
              cy="246.47"
              rx="8.03"
              ry="1.58"
              fill="url(#a85302c0-d016-4d31-8b29-7c328466ef6f)"
            />
            <ellipse
              cx="1121.4"
              cy="249.22"
              rx="11.07"
              ry="2.07"
              fill="url(#e3202c66-4597-4465-9991-e1c2839d0c68)"
            />
            <ellipse
              cx="1121.4"
              cy="251.96"
              rx="14.12"
              ry="2.56"
              fill="url(#b4b61301-67ac-4a50-ac3b-e51a396d6905)"
            />
            <ellipse
              cx="1121.4"
              cy="254.7"
              rx="17.16"
              ry="3.05"
              fill="url(#a2bcc8e0-f064-43c0-a8d4-bb63bbc1c97c)"
            />
            <ellipse
              cx="1121.4"
              cy="257.44"
              rx="20.2"
              ry="3.54"
              fill="url(#f444f5aa-e7a5-4f6b-a4a1-5966318ef460)"
            />
            <ellipse
              cx="1121.4"
              cy="260.18"
              rx="23.25"
              ry="4.03"
              fill="url(#b8cc4dcb-b485-4fc7-b6ec-c5d19c791492)"
            />
            <ellipse
              cx="1121.4"
              cy="264.22"
              rx="20.96"
              ry="3.69"
              fill="url(#a4ec58d8-ec1f-4ad5-86e6-5b4ed63b73d1)"
            />
            <ellipse
              cx="1121.4"
              cy="268.26"
              rx="18.68"
              ry="3.35"
              fill="url(#f562c511-fc14-4264-9169-fdc882498d18)"
            />
            <ellipse
              cx="1121.4"
              cy="272.29"
              rx="16.39"
              ry="3"
              fill="url(#b6d83e25-6457-4eed-9cb2-519409b3fa78)"
            />
            <ellipse
              cx="1121.4"
              cy="276.33"
              rx="14.11"
              ry="2.66"
              fill="url(#b593c2ca-2c12-45f9-a210-efd31e8e95a0)"
            />
            <ellipse
              cx="1121.4"
              cy="280.37"
              rx="11.82"
              ry="2.32"
              fill="url(#aa2d94e5-8d00-4131-91b0-e063c981ad28)"
            />
          </g>
        </g>
        <circle
          cx="1121"
          cy="262.16"
          r="39"
          fill="url(#ac566857-16d7-43c3-8a0d-5b0342961259)"
        />
      </g>
      <g>
        <path
          d="M886.21,452.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M889.41,453.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S889.4,447.76,889.41,453.51Z"
          fill="#43771c"
        />
        <path
          d="M886.21,453.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.31-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S886.22,447.76,886.21,453.51Z"
          fill="#43771c"
        />
        <path
          d="M890.47,456.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C879.47,451.41,890.05,454,890.47,456.2Z"
          fill="#529022"
        />
        <path
          d="M887.36,455.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C897.75,452.11,887.55,453.65,887.36,455.91Z"
          fill="#529022"
        />
        <path
          d="M890.85,455s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.35,1.58C881.81,455.82,890.2,453.07,890.85,455Z"
          fill="#426642"
        />
        <path
          d="M886.21,455.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C896.8,456.18,887,453.25,886.21,455.44Z"
          fill="#426642"
        />
        <path
          d="M889,455.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.09,9.88,0,0-4.85-4.06-10.62,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M888.45,455.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.7,7.62,0,0-3.74-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
          fill="#396039"
        />
        <path
          d="M887.59,458.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S887.59,455.26,887.59,458.58Z"
          fill="#659965"
        />
        <path
          d="M889.1,457.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S889.1,454,889.1,457.3Z"
          fill="#659965"
        />
        <path
          d="M897.53,485.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,5.95,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S898.65,488.52,897.53,485.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <g>
        <path
          d="M934.84,440.22s-12.7,26.37,3.37,40.78H913.28s9.13-4.48,10.25-7.37,1.24-21.51,9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M931.65,441.51s-1.34-15.22-10-17.2c0,0,3.61,3.09,1.8,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.63,1.42,13.39,8.45a8.11,8.11,0,0,0-8.9,2.71S931.66,435.76,931.65,441.51Z"
          fill="#43771c"
        />
        <path
          d="M934.84,441.51s1.35-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.3-7.47,13.39-5.6,0,0-11.63,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S934.83,435.76,934.84,441.51Z"
          fill="#43771c"
        />
        <path
          d="M930.58,444.2s16.83-21.91,35.6-13.48c0,0-10.62-.4-11.51.85,0,0,3.48-.55,3.3,2.88,0,0-7.21-3.46-9.25-1.75,0,0,4,.8,3.77,2.49,0,0-6.43-1.53-8.09,0,0,0,4.15,1,2.49,3,0,0-5.68-2.47-8.41,1.22,0,0,2.38-.81,3.11.07C941.59,439.41,931,442,930.58,444.2Z"
          fill="#529022"
        />
        <path
          d="M933.7,443.91s-14.41-20.73-33.82-10.2c0,0,10.53-1.48,11.29-.29a3.31,3.31,0,0,0-3.56,3.28s7.49-4.27,9.32-2.73c0,0-4,1.23-4,2.93,0,0,6.51-2.22,8-.86,0,0-4.2,1.42-2.77,3.29,0,0,5.87-3.1,8.19.4,0,0-2.26-.59-3.08.38C923.3,440.11,933.5,441.65,933.7,443.91Z"
          fill="#529022"
        />
        <path
          d="M930.2,443s16-12.71,28.93,4.58c0,0-8-5.6-8.83-4.84a3.86,3.86,0,0,1,2.07,4.38s-5-6.86-6.74-6.22c0,0,2.91,2.73,2.48,4.24,0,0-4.64-4.63-6.12-4,0,0,3,3,1.46,4.07,0,0-3.94-5.15-6.55-3,0,0,1.91.39,2.34,1.58C939.24,443.82,930.86,441.07,930.2,443Z"
          fill="#426642"
        />
        <path
          d="M934.85,443.44s-19-14.62-33.88,4.57c0,0,9.26-6.13,10.28-5.27a4.16,4.16,0,0,0-2.35,4.89s5.68-7.61,7.79-6.86c0,0-3.36,3-2.83,4.72,0,0,5.36-5.12,7.11-4.4,0,0-3.47,3.29-1.63,4.55,0,0,4.53-5.72,7.63-3.2,0,0-2.24.4-2.72,1.74C924.25,444.18,934,441.25,934.85,443.44Z"
          fill="#426642"
        />
        <path
          d="M932.07,443.9c.69-8.8-8.6-19-15.27-18.41,0,0,13.19-2.56,15.32,5.34,0,0-2.67-10.47-6.57-10.47,0,0,8.6-2.35,10.15,4.91,0,0,4.64-9.07,0-10.3,0,0,10.62,2.83,6.08,9.88,0,0,4.86-4.06,10.62,1.28,0,0-11.31.21-13.23,4.7,0,0,5-3.21,7.9,0,0,0-10-1.66-12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M932.61,443.9c.53-6.79-6.63-14.69-11.77-14.2,0,0,10.16-2,11.81,4.12,0,0-2.06-8.07-5.06-8.07,0,0,6.63-1.81,7.82,3.79,0,0,3.58-7,0-8,0,0,8.19,2.18,4.69,7.62,0,0,3.75-3.13,8.19,1,0,0-8.72.17-10.21,3.63,0,0,3.83-2.47,6.1,0,0,0-7.7-1.28-9.64,4.4Z"
          fill="#396039"
        />
        <path
          d="M933.46,446.58s-.77-8.8-5.8-9.94c0,0,2.09,1.79,1,3.24,0,0-1.9-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.68,4.68,0,0,0-5.14,1.56S933.47,443.26,933.46,446.58Z"
          fill="#659965"
        />
        <path
          d="M932,445.3s.78-8.8,5.81-9.94c0,0-2.1,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S932,442,932,445.3Z"
          fill="#659965"
        />
        <path
          d="M923.53,473.63c1-2.59,1.21-17.95,7-29.05-.78,3.06-6,24-3.28,30,1.07,2.39-2.39,4.61-7.18,6.46h-6.75S922.41,476.52,923.53,473.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <ellipse
        cx="1153.5"
        cy="401.5"
        rx="11.5"
        ry="4.5"
        fill="#141c66"
        opacity="0.28"
      />
      <g>
        <path d="M1136.49,387.3v0h0Z" fill="#ef6291" />
        <path
          d="M1163.61,381.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
          fill="#ef6291"
        />
        <path
          d="M1158.18,398.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08h-.08l-5.9-11.58h27.12Z"
          fill="#c1567f"
        />
        <path
          d="M1163.61,381.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
          fill="#c16f86"
        />
        <path
          d="M1162.08,381.8c0,1.35-5.69,2.44-12.23,2.44s-11.84-1.1-11.84-2.46,5.3-2.46,11.84-2.46S1162.08,380.44,1162.08,381.8Z"
          fill="#513126"
        />
        <path
          d="M1158,399.22c-9.41.46-9.1-11.1-9.1-11.1l-12.15-.43,5.66,11.11h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1154.09,400.51,1157.24,400,1158,399.22Z"
          fill="#602b8e"
          opacity="0.35"
        />
        <path
          d="M1163.61,381.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1163.61,383.33,1163.61,381.8Z"
          fill="#ef6291"
        />
        <path
          d="M1143.67,384.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1142.59,389,1143.67,384.24,1143.67,384.24Z"
          fill="#602b8e"
          opacity="0.35"
        />
        <g>
          <path
            d="M1140.63,379.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1143.55,378.6,1140.63,379.18Z"
            fill="#1c7f19"
          />
          <path
            d="M1135,372.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1137.61,374.15,1136.32,373.26,1135,372.34Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1153.42,377c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1156.34,376.39,1153.42,377Z"
            fill="#1c7f19"
          />
          <path
            d="M1147.83,370.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1150.41,371.93,1149.11,371,1147.83,370.13Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1148.19,383.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1151.11,383.2,1148.19,383.77Z"
            fill="#1b6817"
          />
          <path
            d="M1142.6,376.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1145.18,378.74,1143.88,377.85,1142.6,376.94Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1142.54,383.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1143.91,380.74,1144.64,383.36,1142.54,383.77Z"
            fill="#1b6817"
          />
          <path
            d="M1138.52,378.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,14.84,14.84,0,0,0-1.27-1.11C1140.37,380.15,1139.44,379.51,1138.52,378.86Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1142.3,373.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1143.68,370.44,1144.42,373.08,1142.3,373.5Z"
            fill="#1c7f19"
          />
          <path
            d="M1138.24,368.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.8,2.8,0,0,0-.89-1.41,11.49,11.49,0,0,0-1.28-1.13C1140.11,369.85,1139.17,369.2,1138.24,368.53Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1144.07,381.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S1141.16,380.49,1144.07,381.06Z"
            fill="#1c7f19"
          />
          <path
            d="M1149.67,374.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1149.67,374.23Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1155.26,374.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1152.34,373.84,1155.26,374.42Z"
            fill="#1c7f19"
          />
          <path
            d="M1160.85,367.58c-1.28.92-2.57,1.81-3.78,2.82a19.9,19.9,0,0,0-1.76,1.55,7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1160.85,367.58Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1144.09,375.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1142.71,372.33,1142,375,1144.09,375.39Z"
            fill="#1b6817"
          />
          <path
            d="M1148.16,370.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1148.16,370.42Z"
            fill="#30562e"
          />
        </g>
        <path
          d="M1143.93,383.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,3.62,3.62,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.61,10.61,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.34,13.34,0,0,0,1143.93,383.15Z"
          fill="#30562e"
        />
        <path
          d="M1150.05,373.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a19.08,19.08,0,0,0-.12-2.52,13,13,0,0,0-.55-2.46c0-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1149.55,373.8,1149.8,373.52,1150.05,373.14Z"
          fill="#30562e"
        />
        <path
          d="M1155.36,368.63a7,7,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1155.36,368.63Z"
          fill="#30562e"
        />
        <g>
          <path
            d="M1156.47,380.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1155.09,377.58,1154.35,380.23,1156.47,380.64Z"
            fill="#1b6817"
          />
          <path
            d="M1155,383c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1153.64,380,1152.9,382.61,1155,383Z"
            fill="#1b6817"
          />
          <path
            d="M1160.53,375.67c-.93.67-1.87,1.32-2.75,2.05a13.61,13.61,0,0,0-1.28,1.13,2.78,2.78,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1160.53,375.67Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1151.56,382.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1148.64,382.13,1151.56,382.7Z"
            fill="#1c7f19"
          />
          <path
            d="M1157.15,375.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1157.15,375.87Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1148.74,376c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1150.12,373,1150.86,375.63,1148.74,376Z"
            fill="#1c7f19"
          />
          <path
            d="M1144.68,371.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1146.55,372.39,1145.61,371.74,1144.68,371.08Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M1155.45,371c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.68,2.55S1156.84,371.54,1155.45,371Z"
            fill="#bc784a"
          />
          <path
            d="M1154.7,371.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1156.17,371.31,1154.7,371.16Z"
            fill="#ed863a"
          />
          <path
            d="M1154.61,371.4c-1.82-.2-.23-2.73-.7-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1156.09,371.55,1154.61,371.4Z"
            fill="#bc784a"
          />
          <path
            d="M1154.86,371.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1156.17,372.3,1154.86,371.91Z"
            fill="#ed863a"
          />
        </g>
        <g>
          <path
            d="M1149.69,371.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1151.15,372.21,1149.69,371.93Z"
            fill="#bc784a"
          />
          <path
            d="M1149,372.2c-1.83.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1150.45,372.1,1149,372.2Z"
            fill="#ed863a"
          />
          <path
            d="M1148.93,372.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1150.42,372.35,1148.93,372.45Z"
            fill="#bc784a"
          />
          <path
            d="M1149.26,372.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1150.62,373.07,1149.26,372.92Z"
            fill="#ed863a"
          />
        </g>
        <g>
          <path
            d="M1144.21,370.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1142.74,370.48,1144.21,370.21Z"
            fill="#bc784a"
          />
          <path
            d="M1144.92,370.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1143.44,370.37,1144.92,370.48Z"
            fill="#ed863a"
          />
          <path
            d="M1145,370.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1143.48,370.62,1145,370.73Z"
            fill="#bc784a"
          />
          <path
            d="M1144.64,371.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1143.28,371.35,1144.64,371.19Z"
            fill="#ed863a"
          />
        </g>
        <ellipse
          cx="1157.33"
          cy="379.3"
          rx="1.15"
          ry="0.35"
          transform="translate(123.74 1023.49) rotate(-50.08)"
          fill="#b2eff9"
          opacity="0.25"
        />
      </g>
      <g>
        <g>
          <rect
            x="221.24"
            y="356.29"
            width="1.91"
            height="33.71"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="222.19"
              cy="347.36"
              rx="3.91"
              ry="0.77"
              fill="url(#a5bc01ad-b6df-4217-9d0b-0f4ac108fd93)"
            />
            <ellipse
              cx="222.19"
              cy="348.7"
              rx="5.39"
              ry="1.01"
              fill="url(#b8e0f518-ac80-4970-91ec-30667050d5dd)"
            />
            <ellipse
              cx="222.19"
              cy="350.03"
              rx="6.88"
              ry="1.25"
              fill="url(#e511fb5b-8cfd-4b2c-ab32-b972dbf89ca0)"
            />
            <ellipse
              cx="222.19"
              cy="351.37"
              rx="8.36"
              ry="1.49"
              fill="url(#bc7ce822-c65a-44bf-ba1f-692039b7fb60)"
            />
            <ellipse
              cx="222.19"
              cy="352.7"
              rx="9.84"
              ry="1.72"
              fill="url(#a05cba04-413e-43e4-a0c8-31fb9f8a7105)"
            />
            <ellipse
              cx="222.19"
              cy="354.04"
              rx="11.33"
              ry="1.96"
              fill="url(#b39da79f-c650-4655-b018-666537597be8)"
            />
            <ellipse
              cx="222.19"
              cy="356"
              rx="10.21"
              ry="1.8"
              fill="url(#fd9cfc3d-ef49-4141-bf9b-0c8a333b850e)"
            />
            <ellipse
              cx="222.19"
              cy="357.97"
              rx="9.1"
              ry="1.63"
              fill="url(#a1243a90-1b2b-4d9c-87e7-36f2e30adf0b)"
            />
            <ellipse
              cx="222.19"
              cy="359.94"
              rx="7.99"
              ry="1.46"
              fill="url(#b07e2b7d-e090-4bf0-9b78-ab3a85e02624)"
            />
            <ellipse
              cx="222.19"
              cy="361.91"
              rx="6.87"
              ry="1.3"
              fill="url(#bb5351ec-6fcc-4be0-ba98-99df721a8162)"
            />
            <ellipse
              cx="222.19"
              cy="363.87"
              rx="5.76"
              ry="1.13"
              fill="url(#eb8bd43f-40ab-40c7-b6e4-9c11445146ca)"
            />
          </g>
        </g>
        <circle
          cx="222"
          cy="355"
          r="19"
          fill="url(#ab5f328d-8776-4191-8a58-ac5520c82187)"
        />
      </g>
      <g>
        <g>
          <rect
            x="179.62"
            y="227.05"
            width="2.26"
            height="39.95"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="180.75"
              cy="216.46"
              rx="4.64"
              ry="0.91"
              fill="url(#adaa3490-e4c2-4bd4-992a-4dbc4232551d)"
            />
            <ellipse
              cx="180.75"
              cy="218.05"
              rx="6.39"
              ry="1.19"
              fill="url(#a4024057-91df-46d6-afde-370f1cc103f7)"
            />
            <ellipse
              cx="180.75"
              cy="219.63"
              rx="8.15"
              ry="1.48"
              fill="url(#f10a680e-9def-4756-aa4c-18df52b9f54b)"
            />
            <ellipse
              cx="180.75"
              cy="221.21"
              rx="9.91"
              ry="1.76"
              fill="url(#affda58b-7601-4cec-92dc-57c3c11916e4)"
            />
            <ellipse
              cx="180.75"
              cy="222.8"
              rx="11.67"
              ry="2.04"
              fill="url(#e8b2ba0a-ecc5-491c-b4f2-0be25d7ae1c1)"
            />
            <ellipse
              cx="180.75"
              cy="224.38"
              rx="13.42"
              ry="2.33"
              fill="url(#b0eda82d-9a06-4545-936d-045379aa8d9f)"
            />
            <ellipse
              cx="180.75"
              cy="226.71"
              rx="12.1"
              ry="2.13"
              fill="url(#b335d22a-2173-4f88-89fc-17c056297d61)"
            />
            <ellipse
              cx="180.75"
              cy="229.04"
              rx="10.78"
              ry="1.93"
              fill="url(#a9fdd0cf-2b73-4cb7-8e56-72fd8be5ac25)"
            />
            <ellipse
              cx="180.75"
              cy="231.37"
              rx="9.46"
              ry="1.73"
              fill="url(#bc8f25e9-a117-4a97-83be-b3e4cc85d435)"
            />
            <ellipse
              cx="180.75"
              cy="233.7"
              rx="8.14"
              ry="1.54"
              fill="url(#e2d1c53d-ded8-4abf-8027-f89b0faf98cf)"
            />
            <ellipse
              cx="180.75"
              cy="236.03"
              rx="6.82"
              ry="1.34"
              fill="url(#ac856df2-15b8-4a83-a9dd-840b8d4db090)"
            />
          </g>
        </g>
        <circle
          cx="180.52"
          cy="225.52"
          r="22.52"
          fill="url(#e6db86c7-4258-492b-b46c-356c34cbfa60)"
        />
      </g>
      <g>
        <g>
          <rect
            x="73.62"
            y="311.05"
            width="2.26"
            height="39.95"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="74.75"
              cy="300.46"
              rx="4.64"
              ry="0.91"
              fill="url(#a82126c9-6222-4a8d-ae2a-f07613f6b65a)"
            />
            <ellipse
              cx="74.75"
              cy="302.05"
              rx="6.39"
              ry="1.19"
              fill="url(#e854b514-d35c-4b45-80ce-f286932fe09b)"
            />
            <ellipse
              cx="74.75"
              cy="303.63"
              rx="8.15"
              ry="1.48"
              fill="url(#aa6a86a4-9c20-4645-be0b-ae5b59e1bdc2)"
            />
            <ellipse
              cx="74.75"
              cy="305.21"
              rx="9.91"
              ry="1.76"
              fill="url(#b144f187-0e02-415d-af7c-7781a8efffa0)"
            />
            <ellipse
              cx="74.75"
              cy="306.8"
              rx="11.67"
              ry="2.04"
              fill="url(#bc12ca3c-a9fd-4752-8f11-70e6644baaf5)"
            />
            <ellipse
              cx="74.75"
              cy="308.38"
              rx="13.42"
              ry="2.33"
              fill="url(#bf7e7cb1-b608-40f4-8a24-e3ec2bd7a0bb)"
            />
            <ellipse
              cx="74.75"
              cy="310.71"
              rx="12.1"
              ry="2.13"
              fill="url(#a6ec3196-d0dd-4541-b782-0bae753ee60b)"
            />
            <ellipse
              cx="74.75"
              cy="313.04"
              rx="10.78"
              ry="1.93"
              fill="url(#b3dd8cff-485c-4375-a4a3-cb242a5647bf)"
            />
            <ellipse
              cx="74.75"
              cy="315.37"
              rx="9.46"
              ry="1.73"
              fill="url(#e88108e1-f89d-445a-8090-92ff8bbc5cc9)"
            />
            <ellipse
              cx="74.75"
              cy="317.7"
              rx="8.14"
              ry="1.54"
              fill="url(#a0abda93-0d3e-4546-9baf-ce67aa6b44ff)"
            />
            <ellipse
              cx="74.75"
              cy="320.03"
              rx="6.82"
              ry="1.34"
              fill="url(#bd2c30c0-1db6-4cea-8518-4c63bf53ab40)"
            />
          </g>
        </g>
        <circle
          cx="74.52"
          cy="309.52"
          r="22.52"
          fill="url(#efc490f2-5df7-4795-bb28-939b06cbcd15)"
        />
      </g>
      <g>
        <path
          d="M108.36,258.35c3.58-5.92,4.81-7.26,3.28-11.25s-3-.58-1.46-8.08-4.28-9.72-6.91-10-15.11,7-13,11,3,15.28.74,16.22S104.15,265.32,108.36,258.35Z"
          fill="#396039"
        />
        <path
          d="M106,244.59c-.11-3.23,4.75-4.51,3.16-6s-3.45-5.27-5-3.28-2.7,4.92-3.87,3.28-2.46-1.7-3.22,0-.12,3.81-1.93,3.28-2.64.29-2.4,2.05,1.58,1.06,2.75,3.16,6.44,1.82,5.56.65S106,244.59,106,244.59Z"
          fill="#447244"
        />
        <path
          d="M115,239c2.63-4.16,6.32-8,10-4.39s-2.46,10,0,12.47,1.94,8.9,0,9.14-11.12.23-13.52,1.35-5.51-3-5.57-7S115,239,115,239Z"
          fill="#6b996b"
        />
        <path
          d="M101.16,263.68c6.17,4.7,6.62-11.66,0-10.25s-8.78,1-10.89-1.93-7.38,2.22-7.56,3.68,1.53,6.39,5.16,7.79S97.47,260.86,101.16,263.68Z"
          fill="#447244"
        />
        <path
          d="M113.91,267c-6.17,4.71-6.62-11.65,0-10.24s8.78,1,10.89-1.94,7.38,2.23,7.56,3.69-1.53,6.39-5.16,7.79S117.6,264.14,113.91,267Z"
          fill="#447244"
        />
        <path
          d="M121.6,261.33c.88-1.75,3.45,1.64,3.45,1.64s-.17-2.28,1.23-3.1,2.05,1.29,2.05,1.29c.12-1.64,3.46-.12,2.52,1.83h0a7.78,7.78,0,0,1-3.65,3.26,6.49,6.49,0,0,1-2.61.34l-3.15-.8S120.72,263.09,121.6,261.33Z"
          fill="#396039"
        />
        <path
          d="M108.89,264.32c-1.23,2.17-1.93,21.67,0,30.63,0,0-5.62-1-7.38-.06-.17.58-.17.06-.17.06s7.78-27.12,1-35.08-14.17,0-14.17,0,2-4.69,6.38-5,10.43,5.33,10.72,6.44c0,0,.23-8.55-2.52-11.53s.76-5.15.76-5.15-3.63,1.11,2.23,8.72c3,3.95.88,11.3.88,11.3s1.87-5.74,6.56-4.51,7.49,6.68,11.88,6.33a23.19,23.19,0,0,1-9.25-2.75A5.42,5.42,0,0,0,108.89,264.32Z"
          fill="#704d3c"
        />
        <path
          d="M115.3,263.4a5.37,5.37,0,0,0-6.41.92c-.42.75-.78,3.55-1,7.27-1.4-4.85,1.12-10.61,1.91-11.12a4.43,4.43,0,0,1,3.37-.37,10.46,10.46,0,0,1,3.09,1.47Z"
          fill="#634b42"
        />
        <path
          d="M104.53,261.6c.64,1.46,1.34,5.75.55,8h0c-.15-4-.92-7.56-2.75-9.7a14.69,14.69,0,0,0-1.21-1.26l-.28-.82A10.57,10.57,0,0,1,104.53,261.6Z"
          fill="#44322c"
        />
        <path
          d="M114,262.49c1.69-.55,1.8-2.93,3.81-2.79s2.25,3,3.92,4.9,3,1.47,4.36,2.12-3.65,7.8-8.28,5.21-4.19-2.15-5.79-3.2S110.22,263.72,114,262.49Z"
          fill="#6b996b"
        />
        <g>
          <path d="M105.21,258.82c0,.1,0,.12,0,.05v-.05Z" fill="#7f2c03" />
          <path
            d="M105.14,257.78c-.21-2.72-.8-6.31-2.4-8a3.46,3.46,0,0,1-1-2.12l.8-.16a16,16,0,0,0,3.23,5.85l.13.18C105.72,255,105.24,256.62,105.14,257.78Z"
            fill="#634b42"
          />
        </g>
        <path
          d="M98.8,257.57c-1.11-1.39.11-3.44-1.64-4.43s-3.55,1.28-6,1.92-3.34-.45-4.8-.64-1.27,8.51,4,8.91,4.68.53,6.6.53S101.28,260.68,98.8,257.57Z"
          fill="#6b996b"
        />
        <path
          d="M101,241.13c1.16-1.82,2.77-3.48,4.39-1.92s-1.08,4.36,0,5.46.84,3.9,0,4-4.87.1-5.92.59-2.41-1.31-2.44-3S101,241.13,101,241.13Z"
          fill="#6b996b"
        />
        <path
          d="M89.5,261.39c.34.5,1.31.41,1.88.18s.89-2,1.8-1.66,1.35,1.2,2.36.91.58-1.38,1.87-1.4,2.41.47,2.45,1.14a1,1,0,0,1,0,.17h0s0,.1,0,.15a3.29,3.29,0,0,1-2.82,3c-1.92,0-1.31-.13-6.6-.53a4.16,4.16,0,0,1-1.94-.62C87.88,262.33,89.17,260.88,89.5,261.39Z"
          fill="#447244"
        />
        <path
          d="M113.28,268.71c1.29,0,3.87,1.41,4.22.12s2.93-1.58,3.22-1a2.55,2.55,0,0,0,2.75.88c.88-.47,1.76.7,1.36,1.16-1.63,1.85-4.38,3.53-7,2.06-3.21-1.8-4-2.14-4.69-2.53C112.82,269.18,112.29,268.71,113.28,268.71Z"
          fill="#396039"
        />
        <path
          d="M108.48,253.9c.82-1.82,2.81-1.47,4.22-1.23s1,2.1,2.11,1.23,3.57,1.23,2.64,2.75h0a21.56,21.56,0,0,0-5.92.94c-1.49.68-3.25-.63-4.38-2.67l-.5-1h0S107.66,255.71,108.48,253.9Z"
          fill="#447244"
        />
        <path
          d="M123.35,252.78c-.52-1.64,1.82-3,0-3s-4.8,1.81-4.5-.82-.53-4-2.52-3.87-3.51-4.09-2.4-5.06-6.21,1.84-3,4.6,4.39,1.87,4.28,3.16,0,4,2.45,4.39-.69,3.75,1.15,4.51S124.76,257.18,123.35,252.78Z"
          fill="#447244"
        />
        <path
          d="M101.34,295s.48-1.69,1.1-4.33c4.89-2.51,5.24-10.68,5.25-10.92a82.7,82.7,0,0,0,1.2,15.25s-5.62-1-7.38-.06C101.34,295.47,101.34,295,101.34,295Z"
          fill="#44322c"
        />
        <path
          d="M107.17,294.7a29.74,29.74,0,0,0-.72-4.65,30.87,30.87,0,0,1-.07-4.71c.18-3.14.48-6.26.62-9.4,0-.78.09-1.56.1-2.34a8.66,8.66,0,0,0,0-1.15c-.06-.36-.19-.75-.27-1.13a13.29,13.29,0,0,1-.39-2.34,4.81,4.81,0,0,1,.31-2.37c.72-1.37,1.31-2.93,2.65-3.88a3.88,3.88,0,0,1,2.29-.55,10.3,10.3,0,0,1,2.34.32,10.87,10.87,0,0,0-2.34-.24,3.8,3.8,0,0,0-2.19.61c-1.26.92-1.85,2.46-2.54,3.84a4.74,4.74,0,0,0-.26,2.25,13.74,13.74,0,0,0,.41,2.29c.09.39.22.74.3,1.15a8.2,8.2,0,0,1,0,1.2c0,.79,0,1.58-.07,2.36-.18,3.14-.52,6.27-.74,9.39a33.22,33.22,0,0,0,0,4.68A30.52,30.52,0,0,1,107.17,294.7Z"
          fill="#44322c"
        />
        <path
          d="M105.93,279.69a14,14,0,0,0,0,1.94,2.83,2.83,0,0,1-.12,1,2.93,2.93,0,0,1-.51.87,5.23,5.23,0,0,0-1.45,3.4,7.47,7.47,0,0,0,0,1.89,15,15,0,0,0,.5,1.85,15.82,15.82,0,0,1,.41,3.87,21,21,0,0,0-.67-3.8,11,11,0,0,1-.56-1.87,8.21,8.21,0,0,1,0-2,5.45,5.45,0,0,1,1.59-3.54,2.49,2.49,0,0,0,.52-.77,2.71,2.71,0,0,0,.15-.91A14,14,0,0,1,105.93,279.69Z"
          fill="#44322c"
        />
        <path
          d="M105.93,254.8c.07.75.36,1.44.4,2.21a8.2,8.2,0,0,1-.15,1.09,4.42,4.42,0,0,0,.21,1.06,10.54,10.54,0,0,1,.63,4.43c-.09.78-.4,1.46-.47,2.18a14.55,14.55,0,0,0-.12,2.19,27.32,27.32,0,0,0,.5,4.41,20.4,20.4,0,0,1-.77-4.39,13,13,0,0,1,.07-2.25c.07-.77.38-1.48.45-2.18a11,11,0,0,0-.55-4.32,4.29,4.29,0,0,1-.17-1.13c0-.43.21-.72.2-1.1C106.18,256.29,105.94,255.55,105.93,254.8Z"
          fill="#44322c"
        />
      </g>
      <g>
        <path
          d="M276.56,212.81c3.05-5,4.09-6.19,2.79-9.58s-2.54-.5-1.25-6.88-3.64-8.28-5.88-8.53-12.87,6-11.07,9.38,2.56,13,.63,13.81S273,218.74,276.56,212.81Z"
          fill="#396039"
        />
        <path
          d="M274.51,201.09c-.1-2.74,4-3.84,2.7-5.09s-2.95-4.49-4.24-2.79-2.3,4.19-3.3,2.79-2.09-1.44-2.74,0-.1,3.24-1.64,2.79-2.25.25-2.05,1.75,1.35.9,2.35,2.69,5.48,1.55,4.73.55S274.51,201.09,274.51,201.09Z"
          fill="#447244"
        />
        <path
          d="M282.24,196.35c2.25-3.54,5.39-6.78,8.53-3.74s-2.09,8.48,0,10.62,1.65,7.58,0,7.78-9.48.2-11.52,1.15-4.69-2.54-4.74-5.93S282.24,196.35,282.24,196.35Z"
          fill="#6b996b"
        />
        <path
          d="M270.42,217.35c5.26,4,5.64-9.93,0-8.73s-7.48.85-9.27-1.65-6.29,1.9-6.44,3.15,1.3,5.43,4.39,6.63S267.28,215,270.42,217.35Z"
          fill="#447244"
        />
        <path
          d="M281.28,220.14c-5.25,4-5.64-9.93,0-8.73s7.48.85,9.28-1.64,6.28,1.89,6.43,3.14-1.3,5.43-4.39,6.63S284.42,217.75,281.28,220.14Z"
          fill="#447244"
        />
        <path
          d="M287.83,215.35c.75-1.49,2.94,1.4,2.94,1.4s-.15-1.95,1.05-2.65,1.74,1.1,1.74,1.1c.1-1.39,2.95-.1,2.15,1.56h0a6.63,6.63,0,0,1-3.11,2.78,5.52,5.52,0,0,1-2.22.29l-2.68-.68A6.43,6.43,0,0,1,287.83,215.35Z"
          fill="#396039"
        />
        <path
          d="M277,217.9c-1.05,1.84-1.65,18.45,0,26.08,0,0-4.79-.85-6.29,0-.15.5-.15,0-.15,0s6.64-23.09.85-29.88-12.07,0-12.07,0,1.7-4,5.44-4.28,8.87,4.53,9.12,5.48c0,0,.2-7.28-2.14-9.82s.65-4.39.65-4.39-3.09.95,1.89,7.43c2.59,3.36.75,9.62.75,9.62s1.6-4.88,5.59-3.84,6.38,5.69,10.12,5.39a19.66,19.66,0,0,1-7.88-2.34A4.6,4.6,0,0,0,277,217.9Z"
          fill="#704d3c"
        />
        <path
          d="M282.46,217.11a4.57,4.57,0,0,0-5.45.79c-.36.63-.67,3-.85,6.19-1.2-4.14.95-9,1.62-9.48a3.79,3.79,0,0,1,2.87-.31,8.86,8.86,0,0,1,2.63,1.26Z"
          fill="#634b42"
        />
        <path
          d="M273.29,215.58c.55,1.24,1.15,4.9.47,6.79h0c-.12-3.43-.78-6.44-2.34-8.27a11.8,11.8,0,0,0-1-1.07l-.23-.7A8.94,8.94,0,0,1,273.29,215.58Z"
          fill="#44322c"
        />
        <path
          d="M281.35,216.34c1.45-.47,1.54-2.5,3.25-2.38s1.92,2.58,3.34,4.18,2.58,1.24,3.71,1.8-3.1,6.64-7,4.43-3.56-1.82-4.93-2.72S278.13,217.38,281.35,216.34Z"
          fill="#6b996b"
        />
        <g>
          <path d="M273.87,213.21c0,.09,0,.1,0,0v0Z" fill="#7f2c03" />
          <path
            d="M273.82,212.33c-.19-2.32-.69-5.38-2.05-6.85a3,3,0,0,1-.89-1.81l.68-.13a13.82,13.82,0,0,0,2.75,5l.12.16C274.3,210,273.9,211.34,273.82,212.33Z"
            fill="#634b42"
          />
        </g>
        <path
          d="M268.41,212.15c-.94-1.19.1-2.93-1.39-3.78s-3,1.1-5.09,1.64-2.84-.38-4.09-.55-1.08,7.26,3.43,7.59,4,.45,5.62.45S270.52,214.8,268.41,212.15Z"
          fill="#6b996b"
        />
        <path
          d="M270.31,198.15c1-1.55,2.36-3,3.74-1.64s-.92,3.71,0,4.65.72,3.32,0,3.41-4.15.08-5.05.5-2.05-1.12-2.07-2.6S270.31,198.15,270.31,198.15Z"
          fill="#6b996b"
        />
        <path
          d="M260.5,215.4c.28.43,1.11.35,1.59.15s.76-1.66,1.53-1.41,1.16,1,2,.78.49-1.18,1.59-1.2,2,.41,2.09,1c0,.05,0,.1,0,.15h0a.51.51,0,0,0,0,.13,2.79,2.79,0,0,1-2.4,2.53c-1.64,0-1.11-.11-5.62-.45a3.53,3.53,0,0,1-1.66-.52C259.11,216.2,260.21,215,260.5,215.4Z"
          fill="#447244"
        />
        <path
          d="M280.75,221.64c1.09,0,3.29,1.19,3.59.1s2.49-1.35,2.74-.85a2.2,2.2,0,0,0,2.34.75c.75-.4,1.5.59,1.16,1-1.39,1.57-3.73,3-6,1.74-2.73-1.53-3.39-1.81-4-2.15C280.35,222,279.9,221.64,280.75,221.64Z"
          fill="#396039"
        />
        <path
          d="M276.66,209c.69-1.55,2.39-1.25,3.59-1.05s.85,1.8,1.79,1.05,3,1,2.25,2.34h0a18.49,18.49,0,0,0-5,.8c-1.27.59-2.76-.53-3.73-2.27l-.42-.88h0S276,210.56,276.66,209Z"
          fill="#447244"
        />
        <path
          d="M289.32,208.07c-.44-1.4,1.55-2.59,0-2.59s-4.09,1.54-3.84-.7-.44-3.44-2.14-3.29-3-3.49-2-4.32-5.29,1.57-2.55,3.92,3.74,1.59,3.64,2.69,0,3.39,2.1,3.74-.6,3.19,1,3.84S290.52,211.81,289.32,208.07Z"
          fill="#447244"
        />
        <path
          d="M270.57,244s.41-1.43.94-3.69c4.17-2.14,4.47-9.09,4.47-9.3a70.31,70.31,0,0,0,1,13s-4.79-.85-6.29,0C270.57,244.43,270.57,244,270.57,244Z"
          fill="#44322c"
        />
        <path
          d="M275.54,243.77a26.9,26.9,0,0,0-.61-4,25.7,25.7,0,0,1-.06-4c.15-2.67.4-5.33.52-8,0-.67.08-1.34.09-2a7.9,7.9,0,0,0,0-1c-.05-.3-.16-.64-.23-1a12.11,12.11,0,0,1-.34-2,4.2,4.2,0,0,1,.27-2,8.48,8.48,0,0,1,2.26-3.31,3.37,3.37,0,0,1,1.95-.47,8.76,8.76,0,0,1,2,.28,8.83,8.83,0,0,0-2-.21,3.28,3.28,0,0,0-1.87.52,8.43,8.43,0,0,0-2.16,3.27,4,4,0,0,0-.23,1.92,11.94,11.94,0,0,0,.36,2c.07.33.18.63.25,1a8.82,8.82,0,0,1,.05,1c0,.67,0,1.34-.07,2-.15,2.67-.44,5.33-.63,8a26.71,26.71,0,0,0,0,4A26.23,26.23,0,0,1,275.54,243.77Z"
          fill="#44322c"
        />
        <path
          d="M274.49,231a11.35,11.35,0,0,0,0,1.65,2.23,2.23,0,0,1-.1.84,2.14,2.14,0,0,1-.44.74,4.44,4.44,0,0,0-1.23,2.9,7.22,7.22,0,0,0,0,1.61,11.86,11.86,0,0,0,.43,1.57,14.19,14.19,0,0,1,.35,3.3,18.2,18.2,0,0,0-.58-3.23,10.22,10.22,0,0,1-.47-1.6,6.75,6.75,0,0,1,0-1.68,4.54,4.54,0,0,1,1.35-3,1.92,1.92,0,0,0,.57-1.44A11.36,11.36,0,0,1,274.49,231Z"
          fill="#44322c"
        />
        <path
          d="M274.49,209.79c.05.64.3,1.22.34,1.88,0,.32-.14.67-.13.93a3.66,3.66,0,0,0,.17.9,9,9,0,0,1,.55,3.78c-.08.66-.35,1.24-.41,1.85a13,13,0,0,0-.1,1.87,22.68,22.68,0,0,0,.43,3.75,16.85,16.85,0,0,1-.66-3.74,10.28,10.28,0,0,1,.06-1.92c.06-.65.32-1.25.38-1.85a9.32,9.32,0,0,0-.47-3.68,3.84,3.84,0,0,1-.14-1c0-.37.18-.61.17-.93C274.7,211.05,274.5,210.42,274.49,209.79Z"
          fill="#44322c"
        />
      </g>
      <g>
        <g opacity="0.2">
          <path
            d="M977.31,257.67c4.79-.49,6.05-.37,7.63-2.89s-.93-1.9,3.88-4.2,3.61-6.45,2.67-8-10.24-5.46-11.57-2.62-7.24,8.08-8.71,7.22S971.67,258.25,977.31,257.67Z"
            fill="#141c66"
          />
          <path
            d="M984,250.57c1.74-1.42,4.49.74,4.64-.75s1.49-4.13-.26-4.14-3.86.56-3.44-.78-.09-2.08-1.35-1.79-2.17,1.53-2.64.3-1.26-1.34-2.14-.47.07,1.32-.61,2.85,1.69,4.35,2,3.37S984,250.57,984,250.57Z"
            fill="#141c66"
          />
          <path
            d="M990.86,253.28c3.41-.28,7.08.18,6.64,3.73s-6.57,2.81-6.94,5.23-4.14,4.81-5.08,3.83-4.79-6.09-6.42-7-.65-4.31,1.54-6S990.86,253.28,990.86,253.28Z"
            fill="#141c66"
          />
          <path
            d="M971.33,255.9c0,5.4,9.25-1.21,5.7-4.3s-4.24-4.46-3.49-6.86-4.34-3.17-5.22-2.66-2.91,3.52-2.17,6.13S971.34,252.67,971.33,255.9Z"
            fill="#141c66"
          />
          <path
            d="M974.85,264.36c-5.2-1.46,3.71-8.56,5.7-4.29s3.13,5.3,5.64,5.24,1.85,5,1.11,5.75-4.18,1.83-6.49.4S978,265.24,974.85,264.36Z"
            fill="#141c66"
          />
          <path
            d="M981.2,266.28c1.34-.24.54,2.61.54,2.61s1.19-1.05,2.24-.62.14,1.68.14,1.68c1-.62,1.51,1.88,0,2.17h0a5.48,5.48,0,0,1-3.35-.66,4.58,4.58,0,0,1-1.28-1.31l-.87-2.09A5.24,5.24,0,0,1,981.2,266.28Z"
            fill="#141c66"
          />
          <path
            d="M974.21,260.47c-1.72.22-12.86,8-17,12.84,0,0-1.8-3.55-3.06-4.13-.4.15-.11-.07-.11-.07s18.34-7,19.93-14.15-6-7.89-6-7.89,3.44-.85,5.48,1.44,1.41,8,.91,8.66c0,0,4.85-3.45,5.36-6.23s3.19-1.74,3.19-1.74-2.14-1.55-3.92,4.89c-.92,3.35-5.92,5.23-5.92,5.23s4-1.36,5.26,1.76-.57,7,1.46,9.26a16.1,16.1,0,0,1-2.34-6.3A3.78,3.78,0,0,0,974.21,260.47Z"
            fill="#141c66"
          />
          <path
            d="M977.41,263.65a3.74,3.74,0,0,0-3.2-3.18,18.86,18.86,0,0,0-4.46,2.49c2.11-2.81,6.37-3.83,7-3.6a3.11,3.11,0,0,1,1.61,1.72,7.16,7.16,0,0,1,.47,2.33Z"
            fill="#141c66"
          />
          <path
            d="M973.9,256.9a10.23,10.23,0,0,1-4.2,3.65h0c2.17-1.77,3.81-3.68,4.24-5.59a9.59,9.59,0,0,0,.18-1.21l.35-.5A7.4,7.4,0,0,1,973.9,256.9Z"
            fill="#141c66"
          />
          <path
            d="M977.37,262.54c1,.72,2.38-.22,3.15.95s-.74,2.52-1.09,4.24.46,2.3.66,3.31-5.87,1.24-6.37-2.42-.56-3.23-.65-4.56S975.1,261,977.37,262.54Z"
            fill="#141c66"
          />
          <g>
            <path d="M975.73,256.12c-.05.06-.05.06,0,0l0,0Z" fill="#141c66" />
            <path
              d="M976.28,255.64c1.42-1.26,3.17-3.09,3.46-4.7a2.46,2.46,0,0,1,.74-1.47l.43.38a11,11,0,0,0-1.9,4.24c0,.06,0,.11,0,.16C978,254.81,977,255.21,976.28,255.64Z"
              fill="#141c66"
            />
          </g>
          <path
            d="M973.73,252c.31-1.2,2-1.38,1.78-2.77s-2.2-1.44-3.57-2.52-1.15-2-1.66-2.94-5.26,2.87-3.27,6,1.67,2.82,2.47,3.89S973,254.71,973.73,252Z"
            fill="#141c66"
          />
          <path
            d="M983.81,246.38c1.5-.12,3.1.08,2.91,1.63s-2.88,1.23-3,2.29-1.81,2.1-2.22,1.67a23.11,23.11,0,0,0-2.81-3c-.71-.38-.28-1.89.67-2.63S983.81,246.38,983.81,246.38Z"
            fill="#141c66"
          />
          <path
            d="M967.71,248.46c-.14.39.32.9.69,1.11s1.46-.32,1.67.31-.1,1.26.49,1.7,1-.26,1.56.45.75,1.54.4,1.84l-.1.07h0l-.1.05a2.3,2.3,0,0,1-2.84-.32c-.8-1.07-.47-.78-2.47-3.89a3,3,0,0,1-.47-1.34C966.51,248,967.85,248.06,967.71,248.46Z"
            fill="#141c66"
          />
          <path
            d="M973.61,264.75c.54.72.84,2.74,1.7,2.4s2.11,1,1.91,1.37a1.77,1.77,0,0,0,.66,1.9c.63.29.35,1.27-.08,1.24-1.71-.13-3.79-1-4.08-3-.35-2.54-.48-3.11-.56-3.67C973.15,264.69,973.19,264.2,973.61,264.75Z"
            fill="#141c66"
          />
          <path
            d="M979.83,255.87c1.36-.3,2,.95,2.46,1.83s-.76,1.44.2,1.69.81,2.5-.43,2.62h0a15,15,0,0,0-3-2.9c-1-.54-1-2.06-.35-3.55l.36-.71h0S978.48,256.18,979.83,255.87Z"
            fill="#141c66"
          />
          <path
            d="M986.69,263.68c.69-1,2.45-.27,1.69-1.28s-3-1.91-1.43-2.85,2-2,1.09-3,.81-3.67,1.81-3.46-3.63-2.68-3.81.26.8,3.23,0,3.71-2.22,1.67-1.41,3.21-2.38,1.18-2,2.52S984.84,266.3,986.69,263.68Z"
            fill="#141c66"
          />
          <path
            d="M954,269.11s1.14-.44,2.87-1.2c3.45,1.66,8.14-1.57,8.28-1.66a57,57,0,0,0-8,7.06s-1.8-3.55-3.06-4.13C953.72,269.33,954,269.11,954,269.11Z"
            fill="#141c66"
          />
          <path
            d="M956.6,272.25a14.21,14.21,0,0,0,2.06-2.05,23.46,23.46,0,0,1,3.85-2.9c1.27-.81,6.06-3.81,6.56-4.44s1.76-2.34,3-2.57,2.59-.57,3.58,0a5.54,5.54,0,0,1,1.7,2.25"
            fill="#141c66"
          />
          <path
            d="M964.42,265.27c-1.33.74-1.32,1.3-2.63,1.11a4.75,4.75,0,0,0-3.88,2.11,11.66,11.66,0,0,1-2.21,2.35"
            fill="#141c66"
          />
          <path
            d="M978.26,254.83c-.73.66-.85,1.11-1.58,1.35s-1.48,2.39-3.56,3.15-4.21,3.42-4.21,3.42"
            fill="#141c66"
          />
        </g>
        <g>
          <path
            d="M960.86,230.46c4.34-7.18,5.83-8.81,4-13.65s-3.63-.71-1.78-9.81-5.19-11.8-8.39-12.15-18.34,8.53-15.78,13.36,3.65,18.55.9,19.69S955.74,238.93,960.86,230.46Z"
            fill="#396039"
          />
          <path
            d="M957.94,213.76c-.14-3.91,5.76-5.48,3.84-7.25s-4.19-6.4-6-4-3.27,6-4.69,4-3-2.07-3.91,0-.15,4.62-2.35,4-3.2.35-2.92,2.49,1.92,1.27,3.35,3.83S953,219,952,217.6,957.94,213.76,957.94,213.76Z"
            fill="#447244"
          />
          <path
            d="M969,207c3.2-5,7.68-9.67,12.16-5.33s-3,12.09,0,15.14,2.35,10.81,0,11.1-13.51.28-16.42,1.63-6.69-3.63-6.76-8.46S969,207,969,207Z"
            fill="#6b996b"
          />
          <path
            d="M952.11,236.93c7.49,5.71,8-14.14,0-12.44s-10.66,1.21-13.22-2.34-9,2.7-9.17,4.48,1.85,7.74,6.25,9.45S947.63,233.52,952.11,236.93Z"
            fill="#447244"
          />
          <path
            d="M967.59,240.92c-7.49,5.7-8-14.15,0-12.45s10.66,1.21,13.22-2.34,9,2.7,9.18,4.48-1.85,7.75-6.26,9.45S972.07,237.5,967.59,240.92Z"
            fill="#447244"
          />
          <path
            d="M976.92,234.09c1.07-2.13,4.2,2,4.2,2s-.21-2.77,1.49-3.77,2.49,1.57,2.49,1.57c.14-2,4.2-.14,3.06,2.22h0a9.44,9.44,0,0,1-4.43,4,7.78,7.78,0,0,1-3.17.41l-3.82-1S975.86,236.22,976.92,234.09Z"
            fill="#396039"
          />
          <path
            d="M961.5,237.72c-1.5,2.63-2.35,26.3,0,37.18,0,0-6.83-1.21-9-.07-.21.71-.21.07-.21.07s9.45-32.92,1.2-42.59-17.2,0-17.2,0,2.42-5.68,7.75-6.11,12.65,6.47,13,7.82c0,0,.28-10.38-3.06-14s.93-6.25.93-6.25-4.41,1.35,2.7,10.59c3.68,4.79,1.06,13.72,1.06,13.72s2.28-7,8-5.47,9.1,8.1,14.43,7.68a28,28,0,0,1-11.23-3.35A6.58,6.58,0,0,0,961.5,237.72Z"
            fill="#704d3c"
          />
          <path
            d="M969.28,236.6a6.51,6.51,0,0,0-7.78,1.12c-.52.9-1,4.31-1.21,8.82-1.71-5.89,1.35-12.88,2.32-13.5a5.36,5.36,0,0,1,4.08-.44,12.68,12.68,0,0,1,3.75,1.78Z"
            fill="#634b42"
          />
          <path
            d="M956.2,234.41c.78,1.78,1.64,7,.68,9.68h0c-.19-4.88-1.12-9.17-3.35-11.78a16.49,16.49,0,0,0-1.47-1.52l-.34-1A12.69,12.69,0,0,1,956.2,234.41Z"
            fill="#44322c"
          />
          <path
            d="M967.7,235.5c2.06-.67,2.19-3.56,4.63-3.39s2.73,3.68,4.75,5.95,3.68,1.78,5.3,2.57-4.43,9.46-10,6.32-5.09-2.6-7-3.88S963.11,237,967.7,235.5Z"
            fill="#6b996b"
          />
          <g>
            <path d="M957,231c0,.13,0,.15,0,.07V231Z" fill="#7f2c03" />
            <path
              d="M957,229.78c-.26-3.3-1-7.67-2.92-9.77a4.27,4.27,0,0,1-1.27-2.57l1-.19c.35,1.58,1.42,3.86,3.92,7.1l.16.22C957.65,226.44,957.06,228.36,957,229.78Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M949.25,229.52c-1.35-1.69.13-4.17-2-5.38S943,225.7,940,226.48s-4-.55-5.83-.78-1.54,10.33,4.88,10.82,5.68.63,8,.64S952.25,233.3,949.25,229.52Z"
            fill="#6b996b"
          />
          <path
            d="M952,209.57c1.4-2.21,3.36-4.23,5.32-2.34s-1.31,5.29,0,6.63,1,4.73,0,4.85-5.91.13-7.19.72-2.92-1.59-3-3.7S952,209.57,952,209.57Z"
            fill="#6b996b"
          />
          <path
            d="M938,234.16c.41.61,1.59.5,2.27.22s1.08-2.38,2.19-2,1.64,1.46,2.87,1.1.7-1.68,2.27-1.7,2.93.57,3,1.38c0,.07,0,.14,0,.21h0a1,1,0,0,0,0,.18c-.28,2.09-2,3.62-3.43,3.62-2.33,0-1.58-.16-8-.64a5.26,5.26,0,0,1-2.36-.75C936,235.3,937.56,233.54,938,234.16Z"
            fill="#447244"
          />
          <path
            d="M966.83,243.05c1.56,0,4.69,1.7,5.12.14s3.55-1.92,3.91-1.21,2.27,1.64,3.34,1.07,2.13.85,1.65,1.41c-2,2.24-5.32,4.28-8.52,2.49-3.9-2.18-4.84-2.59-5.7-3.06C966.27,243.62,965.63,243.05,966.83,243.05Z"
            fill="#396039"
          />
          <path
            d="M961,225.06c1-2.2,3.41-1.78,5.12-1.49s1.21,2.56,2.56,1.49,4.33,1.49,3.21,3.34h0c-3,.21-5.91.55-7.19,1.14-1.81.84-3.94-.75-5.32-3.23l-.6-1.26h0S960,227.27,961,225.06Z"
            fill="#447244"
          />
          <path
            d="M979.06,223.71c-.64-2,2.2-3.7,0-3.7s-5.83,2.21-5.48-1-.64-4.91-3.05-4.69-4.26-5-2.92-6.15-7.53,2.24-3.62,5.58,5.33,2.27,5.19,3.84,0,4.83,3,5.33-.85,4.55,1.39,5.47S980.76,229,979.06,223.71Z"
            fill="#447244"
          />
          <path
            d="M952.33,274.9s.58-2,1.34-5.26c5.93-3,6.36-13,6.37-13.25,0,6.74.44,13.82,1.46,18.51,0,0-6.83-1.21-9-.07C952.33,275.54,952.33,274.9,952.33,274.9Z"
            fill="#44322c"
          />
          <path
            d="M959.41,274.6c0-1.92-.62-3.74-.87-5.64a37.82,37.82,0,0,1-.12-5.73c.21-3.81.6-7.6.78-11.4,0-1,.1-1.9.12-2.85a10.64,10.64,0,0,0-.05-1.39c-.08-.43-.24-.91-.34-1.37a17,17,0,0,1-.49-2.84,5.87,5.87,0,0,1,.39-2.89c.43-.86.84-1.71,1.34-2.54a6.59,6.59,0,0,1,1.9-2.17,4.79,4.79,0,0,1,2.78-.67,12.79,12.79,0,0,1,2.83.4,12.25,12.25,0,0,0-2.83-.29,4.62,4.62,0,0,0-2.66.73c-1.53,1.12-2.23,3-3.06,4.68a5.66,5.66,0,0,0-.32,2.72,17.83,17.83,0,0,0,.5,2.78c.1.47.25.89.35,1.4a10.31,10.31,0,0,1,.06,1.46c0,1-.05,1.91-.1,2.86-.21,3.81-.59,7.61-.87,11.4a37.27,37.27,0,0,0,0,5.69C958.92,270.82,959.52,272.68,959.41,274.6Z"
            fill="#44322c"
          />
          <path
            d="M957.91,256.38a15.36,15.36,0,0,0,0,2.35,3.52,3.52,0,0,1-.14,1.2,3.43,3.43,0,0,1-.63,1.06,6.32,6.32,0,0,0-1.75,4.13,9.83,9.83,0,0,0,0,2.3,16.66,16.66,0,0,0,.61,2.24,19.17,19.17,0,0,1,.5,4.7,25.44,25.44,0,0,0-.82-4.61,12.57,12.57,0,0,1-.67-2.28,10.14,10.14,0,0,1-.07-2.4,9,9,0,0,1,.57-2.33,5.3,5.3,0,0,1,1.37-2,3,3,0,0,0,.62-.93,3.36,3.36,0,0,0,.18-1.11A15.44,15.44,0,0,1,957.91,256.38Z"
            fill="#44322c"
          />
          <path
            d="M957.91,226.16c.08.91.43,1.74.48,2.68a3.17,3.17,0,0,1-.07.69,2.24,2.24,0,0,0-.12.64,5.39,5.39,0,0,0,.26,1.28,12.9,12.9,0,0,1,.77,5.39c-.11.94-.49,1.76-.58,2.64a18.17,18.17,0,0,0-.14,2.66,32.24,32.24,0,0,0,.61,5.35,24,24,0,0,1-.93-5.34,13.88,13.88,0,0,1,.08-2.73c.09-.92.45-1.78.54-2.64a13.18,13.18,0,0,0-.67-5.25,5.6,5.6,0,0,1-.2-1.37,2.27,2.27,0,0,1,.14-.68,2.38,2.38,0,0,0,.1-.65C958.21,228,957.92,227.06,957.91,226.16Z"
            fill="#44322c"
          />
        </g>
      </g>
      <g>
        <g opacity="0.19">
          <g>
            <path
              d="M1009.32,197c.13-.13.27-.25.4-.36a3.59,3.59,0,0,1,.65-.45,5.24,5.24,0,0,1,.64-.29,2.17,2.17,0,0,0,.53-.31c.18-.15.31-.33.48-.47a1.34,1.34,0,0,1,.44-.27l.35-.09a2.17,2.17,0,0,1,.36,0,0,0,0,0,0,.05,0,2.42,2.42,0,0,1,2.51,1.45.78.78,0,0,0,0,.26,1.4,1.4,0,0,0,.17.56,1.17,1.17,0,0,1,.1.64,5.66,5.66,0,0,1-.27.68,1.09,1.09,0,0,0-.06.36,1.28,1.28,0,0,0,.07.34.86.86,0,0,1,0,.39c0,.12-.07.24-.1.36s0,.25-.07.38a1.4,1.4,0,0,1-.06.28,3.25,3.25,0,0,1-.8,1.11,1.8,1.8,0,0,0-.4.68,3.55,3.55,0,0,0-.1.64,1.31,1.31,0,0,1-.11.52,1.66,1.66,0,0,1-.49.56c-.47.39-1,.71-1.42,1.12-.1.1-.21.21-.3.32l-.26.33a.93.93,0,0,1-.45.28,3,3,0,0,1-.51.07,1.38,1.38,0,0,0-.71.25,1.49,1.49,0,0,1-.32.24.74.74,0,0,1-.33,0,3.07,3.07,0,0,0-.67,0h0a2.32,2.32,0,0,1-.67-.28,2.24,2.24,0,0,1-.74-.73,4,4,0,0,0-.12-.77,8.52,8.52,0,0,1-.22-.87,2.07,2.07,0,0,1,0-.43c0-.15,0-.29,0-.44s-.06-.55,0-.83a1.16,1.16,0,0,1,.12-.44c.06-.14.15-.26.22-.39a1.21,1.21,0,0,0,.16-.41,3.11,3.11,0,0,0,.07-.44c0-.2,0-.39,0-.59a11.39,11.39,0,0,1,.57-1.09,2,2,0,0,1,.48-.11c.24,0,.49-.05.74-.09a.06.06,0,0,0,0-.07c-.09-.19-.18-.37-.25-.56a.92.92,0,0,1-.06-.43.72.72,0,0,1,.13-.28A2.85,2.85,0,0,1,1009.32,197Z"
              fill="#141c66"
            />
            <path d="M1014.52,195.44s-3.2,8.05-15.12,20.85" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1009.09,212.1c.21-.16.41-.32.6-.49a17.31,17.31,0,0,1,3.76-1.32,4.6,4.6,0,0,0,.52.06,4.85,4.85,0,0,0,.66,0h.76a5.06,5.06,0,0,0,1.45-.18c.23-.07.44-.19.66-.27a3.57,3.57,0,0,1,.46-.16c2.46,0,4.25.59,4.45,1.64a1,1,0,0,1,0,.43,1.09,1.09,0,0,1-.13.17,2.88,2.88,0,0,1-.73.66,4,4,0,0,1-.86.4,6.42,6.42,0,0,0-1.06.4,4.09,4.09,0,0,0-.8.64,5,5,0,0,1-.78.68,1.45,1.45,0,0,1-.87.27,2.8,2.8,0,0,1-.64-.2,2.35,2.35,0,0,0-.79-.14.75.75,0,0,0-.56.16c-.15.15-.26.34-.41.5a1.83,1.83,0,0,1-1.4.49,6.87,6.87,0,0,1-1.54-.35c-.27-.08-.55-.15-.82-.21l-.43-.07c-.16,0-.33,0-.49,0a6.11,6.11,0,0,1-1.92-.54c-.31-.12-.63-.24-.94-.34a1.91,1.91,0,0,1,.88-1.67A4.41,4.41,0,0,0,1009.09,212.1Z"
              fill="#141c66"
            />
            <path d="M1022.75,211.57s-14,.3-23.31,5.38" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1008,213a5.54,5.54,0,0,0,.53-.3,13.31,13.31,0,0,1,3.11-.56c.14,0,.27.09.41.12a4.5,4.5,0,0,0,.51.08l.6.09a4,4,0,0,0,1.15.05c.19,0,.37-.09.56-.13l.38-.07c1.93.32,3.25,1,3.28,1.85a1,1,0,0,1-.06.34l-.13.12a2.34,2.34,0,0,1-.65.42,3.6,3.6,0,0,1-.73.21,5.07,5.07,0,0,0-.88.17,3.36,3.36,0,0,0-.71.41,4.53,4.53,0,0,1-.7.43,1.16,1.16,0,0,1-.71.1,2.16,2.16,0,0,1-.48-.24,1.79,1.79,0,0,0-.6-.21.53.53,0,0,0-.46.06c-.14.09-.25.23-.38.33a1.41,1.41,0,0,1-1.16.21,5.61,5.61,0,0,1-1.17-.47c-.2-.09-.4-.19-.62-.27l-.32-.1-.38-.09a5.24,5.24,0,0,1-1.44-.67,7.87,7.87,0,0,0-.69-.38c0-.43.32-.85.91-1.2A3.59,3.59,0,0,0,1008,213Z"
              fill="#141c66"
            />
            <path d="M1018.75,214.37s-11-1.55-19,1.25" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1005.85,210.38a.32.32,0,0,0,.22,0,.3.3,0,0,0,.11-.23,2.14,2.14,0,0,0,0-.44h0l.29,0a.38.38,0,0,0,.21,0c.11-.08.07-.23,0-.34l-.06-.23c.15-.18.32-.36.5-.54l.11.08a2.83,2.83,0,0,0,.28.2.55.55,0,0,0,.25.1.06.06,0,0,0,.06-.07c0-.11,0-.23-.07-.35a.91.91,0,0,1,0-.33c0-.13.18-.15.27-.22a.32.32,0,0,0,.11-.24v-.14l.7-.63.15.12a1,1,0,0,0,.43.21.36.36,0,0,0,.38-.2.87.87,0,0,0,0-.53l-.09-.26.22-.24c.24-.2.49-.39.75-.58h0a.52.52,0,0,1,.19.08,1.11,1.11,0,0,0,.31.09s.07,0,.07,0-.05-.5.17-.55c.06,0,.13.05.18.08a.18.18,0,0,0,.21,0c.09-.12,0-.29.07-.42s.22,0,.27.07a2.08,2.08,0,0,0,.29.36s.09,0,.09-.05c0-.28,0-.57,0-.86.56-.36,1.1-.69,1.62-1a.3.3,0,0,1,0,.1.05.05,0,0,0,.08,0,2.09,2.09,0,0,1,.08.5c0,.1,0,.2,0,.3s.11.09.11,0a1.71,1.71,0,0,0,0-.32,3.91,3.91,0,0,0-.07-.76c.46-.24.91-.46,1.32-.64a2.23,2.23,0,0,1,.1.62l0,.27c0,.07.1.09.11,0a1.41,1.41,0,0,0,0-.28c0-.18,0-.36,0-.54a1.34,1.34,0,0,0,0-.2,8.08,8.08,0,0,1,1.22-.42,6.73,6.73,0,0,0,.21.77s.06.05.08,0a1.19,1.19,0,0,0,.33-.59,2.05,2.05,0,0,0,.07-.34,1.18,1.18,0,0,1,1.11.28c.38.52-.12,1.6-1.22,2.93-.22,0-.44-.08-.66-.11-.06,0-.09.08,0,.1a3.54,3.54,0,0,0,.55.18c-.3.35-.63.7-1,1.07a10.34,10.34,0,0,0-1.11.21.06.06,0,0,0,0,.06c0,.24.1.46.15.69-.55.49-1.14,1-1.78,1.48a4.11,4.11,0,0,0-1.1.26,2.22,2.22,0,0,0-.69.47l-.32.28c-.1.09-.21.16-.31.26s-.32.41-.5.6a.63.63,0,0,1-.61.24,1.68,1.68,0,0,1-.42-.27.2.2,0,0,0-.18,0c-.07,0-.11.09-.15.15a1.26,1.26,0,0,0,0,.64l0,.2c-2.22,1.16-4,1.58-4.44.93-.3-.39-.07-1.14.56-2.07Z"
              fill="#141c66"
            />
            <path d="M1016.7,203.82s-15.8,12.1-17.18,12.78" fill="#141c66" />
          </g>
          <g>
            <path
              d="M1011.47,203.35a.67.67,0,0,1,.26.33c0,.13-.07.25-.1.38a5.05,5.05,0,0,0-.12.56,4.88,4.88,0,0,1-.12.55,4.13,4.13,0,0,1-.37.8,3.84,3.84,0,0,0-.45.88c-.06.26-.06.53-.1.8h0c-.08.11-.15.23-.24.34a10.33,10.33,0,0,1-1.71,1.93l-.17.11a14.28,14.28,0,0,0-1.66.83.74.74,0,0,1-.42-.12c-.75-.53-.2-2.62,1.24-4.66S1010.72,202.82,1011.47,203.35Z"
              fill="#141c66"
            />
            <path d="M1007.51,206.09s.71,4.15-7.14,10.16" fill="#141c66" />
            <path
              d="M1011.11,204.35a2.1,2.1,0,0,1-.48,1,4.45,4.45,0,0,0-.71.79,1.94,1.94,0,0,0-.17.55c0,.19,0,.37,0,.55a1.11,1.11,0,0,1-.22.54,1,1,0,0,1-.37.26,1.81,1.81,0,0,0-.41.22,1.55,1.55,0,0,0-.39.52,1.65,1.65,0,0,1-.4.54,1.85,1.85,0,0,1-.37.19,1.11,1.11,0,0,0-.38.24,1.21,1.21,0,0,0-.24.35.74.74,0,0,1-.21.31,1.08,1.08,0,0,1-.51.18h-.06a.49.49,0,0,1-.17-.06c-.59-.42.09-2.42,1.53-4.46s3.08-3.36,3.68-3a.51.51,0,0,1,.16.24A4.91,4.91,0,0,0,1011.11,204.35Z"
              fill="#141c66"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M984.13,186.31c0-.29-.06-.58-.08-.87a7,7,0,0,1,0-1.29c0-.37.17-.74.25-1.11a3.44,3.44,0,0,0,.11-1c0-.36-.12-.72-.14-1.09a2.32,2.32,0,0,1,.07-.83c.07-.19.15-.37.23-.55a3.08,3.08,0,0,1,.32-.48.09.09,0,0,0,0-.11,4.11,4.11,0,0,1,2-1.7,4,4,0,0,1,2.39-.16,1.22,1.22,0,0,0,.3.3,2.56,2.56,0,0,0,.9.33,1.78,1.78,0,0,1,.93.48,8,8,0,0,1,.62,1,2,2,0,0,0,.42.44,1.75,1.75,0,0,0,.52.24,1.53,1.53,0,0,1,.53.33,4.2,4.2,0,0,1,.37.49,4.57,4.57,0,0,0,.43.45,3.59,3.59,0,0,1,.32.36,5.64,5.64,0,0,1,.67,2.14,2.87,2.87,0,0,0,.5,1.18,5.25,5.25,0,0,0,.74.75,2.36,2.36,0,0,1,.57.65,2.76,2.76,0,0,1,.26,1.2c0,1,0,2,.08,2.93,0,.24.07.48.12.71s.13.44.18.66a1.61,1.61,0,0,1-.07.87c-.11.26-.27.49-.4.73a2.19,2.19,0,0,0-.37,1.17,2,2,0,0,1,0,.65,1.58,1.58,0,0,1-.28.47,5.57,5.57,0,0,0-.72.82.17.17,0,0,0,0,.05,3.94,3.94,0,0,1-1,.61,4,4,0,0,1-1.69.26,6.41,6.41,0,0,0-1.13-.6,11.22,11.22,0,0,1-1.34-.57,4,4,0,0,1-.59-.38c-.19-.15-.35-.33-.54-.47-.36-.27-.78-.46-1.12-.75A2,2,0,0,1,988,194c-.12-.22-.2-.45-.3-.68a2.07,2.07,0,0,0-.37-.6,6.38,6.38,0,0,0-.52-.52c-.23-.21-.48-.41-.72-.62a19,19,0,0,1-.88-1.81,4.46,4.46,0,0,1,.32-.74c.19-.36.41-.69.61-1.05a.1.1,0,0,0,0-.14,8.46,8.46,0,0,1-1-.22,1.24,1.24,0,0,1-.62-.35,1.18,1.18,0,0,1-.24-.42Z"
              fill="#396039"
            />
            <path
              d="M987.17,178a68.47,68.47,0,0,1,4.43,9.56c1.27,3.28,2.37,6.62,3.38,10s1.85,6.78,2.66,10.2l1.12,5.15,1,5.19-1.05-5.17-1.15-5.14c-.83-3.41-1.69-6.82-2.72-10.18s-2.07-6.71-3.32-10c-.63-1.64-1.28-3.27-2-4.88A49.2,49.2,0,0,0,987.17,178Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1003.68,201.33c0-.42,0-.84,0-1.26a27.8,27.8,0,0,1,1.92-6.2,7.11,7.11,0,0,0,.6-.63,10.49,10.49,0,0,0,.64-.85c.24-.34.49-.67.73-1a8.86,8.86,0,0,0,1.18-2.07c.13-.37.18-.76.28-1.13s.16-.51.24-.76c2.41-3.22,4.93-5,6.49-4.23a1.82,1.82,0,0,1,.56.44c0,.11.07.22.1.34a5,5,0,0,1,.14,1.59,7.07,7.07,0,0,1-.31,1.52,10.22,10.22,0,0,0-.52,1.77,6.22,6.22,0,0,0,.07,1.67,8,8,0,0,1,.12,1.69,2.21,2.21,0,0,1-.49,1.4,4.12,4.12,0,0,1-.89.64,4.45,4.45,0,0,0-1,.89,1.2,1.2,0,0,0-.33.9c0,.34.19.67.25,1a2.9,2.9,0,0,1-.72,2.3,11.29,11.29,0,0,1-2,1.68c-.36.28-.73.57-1.07.88-.18.16-.35.32-.51.49s-.34.41-.51.61a10.46,10.46,0,0,1-2.59,2c-.46.28-.92.58-1.36.9-.79-.4-1.22-1.39-1.32-2.79A7.31,7.31,0,0,0,1003.68,201.33Z"
              fill="#2f4f2f"
            />
            <path
              d="M1016.29,183c-1.83,2.72-3.53,5.52-5.15,8.37s-3.11,5.76-4.49,8.73a95.65,95.65,0,0,0-3.66,9.11,66.33,66.33,0,0,0-2.36,9.53,58.35,58.35,0,0,1,2.25-9.57,90.83,90.83,0,0,1,3.61-9.14A115.48,115.48,0,0,1,1016.29,183Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1003.83,203.7c.06-.32.09-.66.12-1a22.45,22.45,0,0,1,2.3-4.61,5.7,5.7,0,0,0,.55-.42c.22-.18.41-.39.61-.59l.7-.69a6.79,6.79,0,0,0,1.19-1.47c.15-.27.23-.57.36-.85a5.93,5.93,0,0,1,.29-.56c2.29-2.22,4.48-3.28,5.61-2.49a1.39,1.39,0,0,1,.39.41l0,.28a3.82,3.82,0,0,1-.09,1.26,4.78,4.78,0,0,1-.44,1.16,8.34,8.34,0,0,0-.62,1.32,4.87,4.87,0,0,0-.16,1.32,6,6,0,0,1-.13,1.34,1.77,1.77,0,0,1-.55,1,3.79,3.79,0,0,1-.78.39,3.34,3.34,0,0,0-.86.58.91.91,0,0,0-.37.66c0,.28.06.55.06.83a2.3,2.3,0,0,1-.85,1.71,9.22,9.22,0,0,1-1.75,1.07c-.33.18-.65.35-1,.55l-.46.32c-.17.13-.32.28-.48.42a8.37,8.37,0,0,1-2.28,1.23,12.31,12.31,0,0,0-1.17.53,2.51,2.51,0,0,1-.69-2.36A5.53,5.53,0,0,0,1003.83,203.7Z"
              fill="#396039"
            />
            <path
              d="M1016.05,190.91c-1.77,1.9-3.46,3.88-5.09,5.9s-3.16,4.13-4.62,6.29a75.07,75.07,0,0,0-4,6.66,53.75,53.75,0,0,0-3.07,7.16,46.1,46.1,0,0,1,3-7.21q1.83-3.47,4-6.72A90.73,90.73,0,0,1,1016.05,190.91Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M998.27,203.89a.48.48,0,0,0,.19-.31.54.54,0,0,0-.19-.36,3.87,3.87,0,0,0-.56-.44v0a2.19,2.19,0,0,0,.34-.34.52.52,0,0,0,.14-.31c0-.22-.22-.32-.39-.38l-.37-.14c-.08-.38-.16-.78-.22-1.19l.22-.05a3.31,3.31,0,0,0,.53-.18,1,1,0,0,0,.37-.23.11.11,0,0,0,0-.15c-.17-.09-.35-.16-.53-.24a1.19,1.19,0,0,1-.46-.3c-.14-.17,0-.37,0-.56a.56.56,0,0,0-.22-.38l-.17-.14c0-.49-.1-1-.14-1.51l.3-.09a1.58,1.58,0,0,0,.69-.36.58.58,0,0,0,.11-.69,1.29,1.29,0,0,0-.7-.51,2.16,2.16,0,0,0-.43-.14l-.09-.53c0-.5,0-1,0-1.54l0-.06a.75.75,0,0,1,.28-.18,1.51,1.51,0,0,0,.43-.32.09.09,0,0,0,0-.13c-.2-.17-.69-.43-.55-.77,0-.1.19-.11.28-.15a.28.28,0,0,0,.15-.31c-.07-.23-.35-.32-.48-.5s.22-.28.36-.29a3.74,3.74,0,0,0,.75,0,.1.1,0,0,0,0-.17c-.38-.27-.77-.55-1.17-.79.07-1.08.18-2.11.31-3.07l.17.05a.09.09,0,0,0,.11-.08,3.57,3.57,0,0,1,.73.37l.4.3c.09.08.22-.05.13-.13a3.25,3.25,0,0,0-.42-.31,8.19,8.19,0,0,0-1-.64c.12-.85.27-1.63.44-2.35a3.67,3.67,0,0,1,.9.47l.33.3c.09.07.21-.05.13-.13a2.45,2.45,0,0,0-.34-.31l-.65-.59-.26-.21a16,16,0,0,1,.64-2,11.35,11.35,0,0,0,1.21.49.09.09,0,0,0,.12-.09,2,2,0,0,0-.45-1,3.08,3.08,0,0,0-.38-.43c.44-.76.94-1.17,1.45-1.17,1,0,2,1.7,2.65,4.43-.27.25-.54.51-.79.77-.08.07,0,.19.11.14a5.88,5.88,0,0,0,.76-.55c.17.72.31,1.51.43,2.35a14.15,14.15,0,0,0-.81,1.66.09.09,0,0,0,0,.12c.33.18.69.32,1,.48.11,1.19.18,2.45.2,3.76a6.63,6.63,0,0,0-.73,1.71,3.84,3.84,0,0,0-.06,1.35c0,.23,0,.46.06.68s0,.45,0,.67c.06.42.22.82.29,1.24a1,1,0,0,1-.28,1,2.49,2.49,0,0,1-.76.29.34.34,0,0,0-.23.19.41.41,0,0,0,.07.34,1.81,1.81,0,0,0,.78.67l.29.16c-.64,4-1.79,6.73-3.1,6.73-.81,0-1.55-1-2.16-2.76Z"
              fill="#659965"
            />
            <path
              d="M1000.25,183.31c.16,5.82.2,11.64.27,17.47v8.73c0,2.91,0,5.83-.26,8.73.14-1.45.11-2.91.13-4.36v-4.37l0-8.73Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M994.55,189.69a1.13,1.13,0,0,1,.68,0l.39.49c.2.25.41.48.63.71a8,8,0,0,1,.6.69,6.32,6.32,0,0,1,.69,1.25,5.52,5.52,0,0,0,.71,1.44,11.76,11.76,0,0,0,1,.92v0c.08.21.15.42.22.64a17.35,17.35,0,0,1,.86,4.12l0,.33a25.13,25.13,0,0,0-.53,3,1.19,1.19,0,0,1-.57.43c-1.42.46-3.61-2.29-4.88-6.16S993.12,190.16,994.55,189.69Z"
              fill="#3b6818"
            />
            <path
              d="M994.27,197.54s6.13,3.12,6.34,19.25"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.18"
            />
            <path
              d="M995.51,191.15a3.36,3.36,0,0,1,.85,1.6,7.14,7.14,0,0,0,.35,1.7,2.36,2.36,0,0,0,.55.76c.22.2.46.38.67.59a1.82,1.82,0,0,1,.5.82,1.63,1.63,0,0,1,0,.73,3.67,3.67,0,0,0-.11.75,2.68,2.68,0,0,0,.31,1,2.61,2.61,0,0,1,.31,1,2.35,2.35,0,0,1-.11.67,2,2,0,0,0,0,.73,2.05,2.05,0,0,0,.23.67,1.45,1.45,0,0,1,.2.56,1.81,1.81,0,0,1-.26.85l0,.09a.64.64,0,0,1-.25.15c-1.12.37-3.07-2.46-4.34-6.33s-1.4-7.31-.28-7.68a.79.79,0,0,1,.48,0A7.06,7.06,0,0,0,995.51,191.15Z"
              fill="#659965"
            />
          </g>
        </g>
      </g>
      <g>
        <g opacity="0.2">
          <path
            d="M880.63,305.41c5.35.32,6.72.67,8.9-1.82s-.68-2.26,5-3.93,5.12-6.45,4.37-8.36-10.29-7.83-12.26-4.94-9.4,7.59-10.87,6.38S874.32,305,880.63,305.41Z"
            fill="#141c66"
          />
          <path
            d="M889.2,298.78c2.17-1.24,4.82,1.63,5.25,0s2.37-4.28.45-4.6-4.35-.07-3.65-1.47.27-2.3-1.17-2.21-2.65,1.3-3-.14-1.15-1.7-2.28-.9-.15,1.46-1.17,3,1.09,5.08,1.57,4.05S889.2,298.78,889.2,298.78Z"
            fill="#141c66"
          />
          <path
            d="M896.31,303c3.81.3,7.76,1.46,6.64,5.28s-7.73,1.92-8.56,4.52-5.41,4.55-6.27,3.31-4.19-7.56-5.83-8.8.06-4.86,2.77-6.34S896.31,303,896.31,303Z"
            fill="#141c66"
          />
          <path
            d="M874.36,302.4c-1,5.94,10.4.32,7-3.71s-3.87-5.67-2.62-8.18-4.2-4.26-5.27-3.85S869.68,290,870,293,875,298.85,874.36,302.4Z"
            fill="#141c66"
          />
          <path
            d="M876.72,312.34c-5.46-2.54,5.61-8.76,7-3.71s2.5,6.39,5.27,6.77,1.14,5.88.2,6.53-4.93,1.26-7.21-.72S880,313.85,876.72,312.34Z"
            fill="#141c66"
          />
          <path
            d="M883.37,315.58c1.52,0,.12,3,.12,3s1.51-.95,2.58-.28-.14,1.87-.14,1.87c1.16-.51,1.33,2.33-.35,2.39h0a6.07,6.07,0,0,1-3.56-1.32,5.18,5.18,0,0,1-1.18-1.67l-.59-2.45A5.84,5.84,0,0,1,883.37,315.58Z"
            fill="#141c66"
          />
          <path
            d="M876.72,307.94c-1.94-.06-15.58,6.52-21,11.09,0,0-1.35-4.22-2.63-5.09-.47.09-.1-.1-.1-.1s21.43-4.47,24.44-12-5.13-9.72-5.13-9.72,3.93-.33,5.76,2.55.12,9.09-.54,9.69c0,0,6-2.93,7-5.9s3.81-1.34,3.81-1.34-2.07-2.09-5.18,4.68c-1.61,3.51-7.44,4.7-7.44,4.7s4.62-.8,5.47,2.87-1.87,7.56,0,10.45a18,18,0,0,1-1.46-7.35A4.2,4.2,0,0,0,876.72,307.94Z"
            fill="#141c66"
          />
          <path
            d="M879.67,312a4.17,4.17,0,0,0-2.95-4.07,20.58,20.58,0,0,0-5.36,1.95c2.83-2.73,7.69-3.08,8.33-2.72a3.45,3.45,0,0,1,1.47,2.18,8.12,8.12,0,0,1,.11,2.65Z"
            fill="#141c66"
          />
          <path
            d="M877,304c-.78,1-3.47,3-5.28,3.27h0c2.71-1.56,4.86-3.37,5.67-5.41a8.79,8.79,0,0,0,.42-1.29l.46-.48A8.13,8.13,0,0,1,877,304Z"
            fill="#141c66"
          />
          <path
            d="M879.82,310.78c1,1,2.66.18,3.3,1.61s-1.27,2.64-2,4.46.09,2.62.13,3.76-6.68.32-6.58-3.79,0-3.66.11-5.14S877.61,308.63,879.82,310.78Z"
            fill="#141c66"
          />
          <g>
            <path d="M879.16,303.42c-.06.06-.07.07,0,0l0,0Z" fill="#141c66" />
            <path
              d="M879.85,303c1.79-1.13,4-2.84,4.65-4.56a2.71,2.71,0,0,1,1.08-1.49l.39.5a12.46,12.46,0,0,0-2.84,4.33c0,.06,0,.11-.08.16C881.94,302.4,880.68,302.64,879.85,303Z"
              fill="#141c66"
            />
          </g>
          <path
            d="M877.7,298.57c.55-1.27,2.4-1.17,2.45-2.73s-2.17-2-3.49-3.41-.9-2.45-1.29-3.52-6.31,2.21-4.67,6,1.34,3.4,2,4.71S876.46,301.39,877.7,298.57Z"
            fill="#141c66"
          />
          <path
            d="M889.79,294.15c1.66.13,3.39.64,2.9,2.31s-3.38.84-3.74,2-2.37,2-2.75,1.45-1.83-3.31-2.54-3.85,0-2.13,1.21-2.78S889.79,294.15,889.79,294.15Z"
            fill="#141c66"
          />
          <path
            d="M871.71,293.57c-.22.41.19,1,.55,1.35s1.67-.1,1.79.64-.33,1.36.24,1.95,1.15-.11,1.63.77.55,1.83.11,2.1l-.12.05h0l-.11.05a2.57,2.57,0,0,1-3.07-.87c-.69-1.31-.38-.94-2-4.71a3.41,3.41,0,0,1-.28-1.56C870.48,292.79,871.94,293.16,871.71,293.57Z"
            fill="#141c66"
          />
          <path
            d="M875.29,312.54c.47.89.44,3.17,1.45,2.94s2.14,1.44,1.85,1.85a2,2,0,0,0,.39,2.21c.64.43.15,1.46-.31,1.35-1.85-.45-4-1.73-3.95-4.07.07-2.86,0-3.51,0-4.14C874.8,312.4,874.93,311.86,875.29,312.54Z"
            fill="#141c66"
          />
          <path
            d="M883.72,303.88c1.55-.09,2,1.4,2.37,2.45s-1.08,1.45-.08,1.89.45,2.9-.93,2.82h0a16.86,16.86,0,0,0-2.79-3.73c-1-.77-.74-2.45.25-4l.53-.71h0S882.18,304,883.72,303.88Z"
            fill="#141c66"
          />
          <path
            d="M889.87,313.69c.94-1,2.75.14,2.09-1.1s-3-2.64-1.07-3.39,2.59-1.83,1.74-3.13,1.55-3.89,2.61-3.48-3.51-3.6-4.23-.39.3,3.69-.63,4.08-2.73,1.44-2.12,3.28-2.83.88-2.68,2.42S887.37,316.25,889.87,313.69Z"
            fill="#141c66"
          />
          <path
            d="M853,313.84s1.33-.28,3.37-.81c3.49,2.45,9.23-.27,9.4-.35a63.46,63.46,0,0,0-10,6.35s-1.35-4.22-2.63-5.09C852.59,314,853,313.84,853,313.84Z"
            fill="#141c66"
          />
          <path
            d="M855.24,317.76a16.28,16.28,0,0,0,2.64-1.89,26,26,0,0,1,4.74-2.5c1.55-.67,7.36-3.11,8-3.71s2.35-2.27,3.78-2.3,2.94-.17,3.93.64a6.16,6.16,0,0,1,1.47,2.78"
            fill="#141c66"
          />
          <path
            d="M865.09,311.47c-1.59.59-1.68,1.2-3.09.76s-3.65.49-4.64,1.63a12.84,12.84,0,0,1-2.85,2.18"
            fill="#141c66"
          />
          <path
            d="M882.18,302.46c-.92.59-1.14,1.06-2,1.2s-2,2.37-4.47,2.83-5.24,3-5.24,3"
            fill="#141c66"
          />
        </g>
        <g>
          <path
            d="M861.54,266.31c5.14-8.49,6.89-10.42,4.71-16.14s-4.29-.84-2.1-11.6-6.14-14-9.92-14.38S832.54,234.28,835.56,240s4.32,21.93,1.07,23.28S855.49,276.31,861.54,266.31Z"
            fill="#396039"
          />
          <path
            d="M858.09,246.55c-.16-4.62,6.81-6.47,4.54-8.57s-5-7.57-7.14-4.71-3.87,7.06-5.55,4.71-3.53-2.44-4.62,0-.17,5.46-2.78,4.71-3.78.42-3.44,2.94,2.27,1.51,3.95,4.54,9.24,2.61,8,.92S858.09,246.55,858.09,246.55Z"
            fill="#447244"
          />
          <path
            d="M871.12,238.57c3.79-6,9.08-11.43,14.38-6.31s-3.53,14.29,0,17.91,2.77,12.78,0,13.11-16,.34-19.42,1.94-7.9-4.29-8-10S871.12,238.57,871.12,238.57Z"
            fill="#6b996b"
          />
          <path
            d="M851.2,274c8.86,6.75,9.5-16.73,0-14.71s-12.61,1.43-15.64-2.78-10.59,3.2-10.84,5.3,2.19,9.16,7.4,11.18S845.9,269.93,851.2,274Z"
            fill="#447244"
          />
          <path
            d="M869.5,278.67c-8.86,6.75-9.5-16.73,0-14.71s12.61,1.43,15.64-2.78,10.59,3.2,10.84,5.3-2.18,9.16-7.4,11.18S874.8,274.63,869.5,278.67Z"
            fill="#447244"
          />
          <path
            d="M880.54,270.6c1.26-2.52,5,2.35,5,2.35s-.25-3.28,1.76-4.45,3,1.85,3,1.85c.17-2.36,5-.17,3.61,2.63h0a11.17,11.17,0,0,1-5.24,4.68,9.29,9.29,0,0,1-3.75.48L880.32,277S879.28,273.12,880.54,270.6Z"
            fill="#396039"
          />
          <path
            d="M862.3,274.89c-1.77,3.11-2.78,31.1,0,44,0,0-8.07-1.43-10.59-.08-.26.84-.26.08-.26.08s11.18-38.92,1.43-50.35-20.34,0-20.34,0,2.86-6.73,9.16-7.23,15,7.65,15.39,9.24c0,0,.33-12.27-3.62-16.56s1.09-7.4,1.09-7.4-5.21,1.6,3.2,12.53c4.35,5.66,1.26,16.23,1.26,16.23s2.69-8.24,9.41-6.48,10.76,9.59,17.07,9.08c0,0-7.4-.42-13.28-4S862.3,274.89,862.3,274.89Z"
            fill="#704d3c"
          />
          <path
            d="M871.5,273.56a7.71,7.71,0,0,0-9.2,1.33c-.61,1.07-1.13,5.09-1.43,10.43-2-7,1.6-15.23,2.74-16a6.37,6.37,0,0,1,4.82-.52,14.87,14.87,0,0,1,4.44,2.11Z"
            fill="#634b42"
          />
          <path
            d="M856,271c.93,2.1,1.94,8.26.8,11.44h0c-.21-5.77-1.32-10.84-4-13.92a20.21,20.21,0,0,0-1.74-1.81c-.25-.72-.4-1.18-.4-1.18A15,15,0,0,1,856,271Z"
            fill="#44322c"
          />
          <path
            d="M869.63,272.26c2.43-.79,2.59-4.2,5.47-4s3.23,4.35,5.63,7,4.35,2.11,6.26,3-5.24,11.2-11.89,7.49-6-3.08-8.31-4.6S864.2,274,869.63,272.26Z"
            fill="#6b996b"
          />
          <g>
            <path d="M857,267c0,.16,0,.18,0,.08V267Z" fill="#7f2c03" />
            <path
              d="M856.92,265.5c-.31-3.9-1.16-9.06-3.45-11.55a5,5,0,0,1-1.5-3l1.15-.22c.41,1.87,1.69,4.55,4.64,8.39l.19.26C857.74,261.55,857.06,263.83,856.92,265.5Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M847.81,265.2c-1.59-2,.16-4.94-2.35-6.37s-5.09,1.85-8.58,2.77-4.78-.65-6.89-.93-1.82,12.23,5.78,12.8,6.72.75,9.47.75S851.37,269.66,847.81,265.2Z"
            fill="#6b996b"
          />
          <path
            d="M851,241.6c1.65-2.61,4-5,6.29-2.76s-1.55,6.26,0,7.84,1.21,5.59,0,5.74-7,.14-8.5.84-3.46-1.87-3.49-4.38S851,241.6,851,241.6Z"
            fill="#6b996b"
          />
          <path
            d="M834.47,270.68c.48.72,1.87.59,2.68.26s1.28-2.81,2.59-2.38,1.94,1.72,3.4,1.3.82-2,2.68-2,3.46.68,3.52,1.64c0,.08,0,.16,0,.24h0a1.5,1.5,0,0,0,0,.22c-.34,2.46-2.33,4.28-4.06,4.27-2.75,0-1.87-.18-9.47-.75a6.09,6.09,0,0,1-2.79-.89C832.14,272,834,270,834.47,270.68Z"
            fill="#447244"
          />
          <path
            d="M868.6,281.19c1.85,0,5.55,2,6,.17s4.21-2.27,4.63-1.43,2.69,1.93,4,1.26,2.52,1,1.95,1.67c-2.35,2.64-6.29,5.06-10.08,2.95-4.61-2.58-5.72-3.07-6.73-3.63C867.94,281.87,867.18,281.19,868.6,281.19Z"
            fill="#396039"
          />
          <path
            d="M861.71,259.92c1.18-2.6,4-2.1,6-1.76s1.43,3,3,1.76,5.13,1.77,3.79,3.95h0c-3.57.25-7,.64-8.5,1.35-2.13,1-4.65-.89-6.28-3.83l-.72-1.48h0S860.53,262.53,861.71,259.92Z"
            fill="#447244"
          />
          <path
            d="M883.06,258.32c-.76-2.36,2.61-4.37,0-4.37s-6.89,2.61-6.47-1.17-.76-5.8-3.62-5.55-5-5.88-3.44-7.27-8.91,2.64-4.29,6.59,6.3,2.7,6.14,4.54,0,5.72,3.53,6.31-1,5.38,1.64,6.47S885.08,264.63,883.06,258.32Z"
            fill="#447244"
          />
          <path
            d="M851.45,318.85s.7-2.41,1.59-6.21c7-3.61,7.52-15.33,7.54-15.68,0,8,.52,16.34,1.72,21.89,0,0-8.07-1.43-10.59-.08C851.45,319.61,851.45,318.85,851.45,318.85Z"
            fill="#44322c"
          />
          <path
            d="M859.83,318.5c0-2.28-.74-4.42-1-6.67a45.16,45.16,0,0,1-.14-6.78c.25-4.51.71-9,.92-13.48.06-1.12.12-2.24.14-3.36a12.74,12.74,0,0,0-.06-1.65c-.09-.51-.28-1.07-.4-1.62a20,20,0,0,1-.57-3.36,6.84,6.84,0,0,1,.46-3.42c.5-1,1-2,1.58-3A7.76,7.76,0,0,1,863,272.6a5.65,5.65,0,0,1,3.29-.79,14.47,14.47,0,0,1,3.35.47,14.47,14.47,0,0,0-3.34-.35,5.5,5.5,0,0,0-3.16.87,7.69,7.69,0,0,0-2.11,2.52c-.55,1-1,2-1.5,3a6.7,6.7,0,0,0-.38,3.22,19.47,19.47,0,0,0,.59,3.28c.12.55.3,1.06.41,1.65a12.82,12.82,0,0,1,.08,1.73c0,1.14-.06,2.26-.12,3.39-.25,4.5-.7,9-1,13.47a45.81,45.81,0,0,0,0,6.73C859.25,314,860,316.23,859.83,318.5Z"
            fill="#44322c"
          />
          <path
            d="M858.05,297a21.49,21.49,0,0,0,0,2.78,3.46,3.46,0,0,1-.91,2.67,7.52,7.52,0,0,0-2.08,4.88,11.78,11.78,0,0,0,0,2.72,8.42,8.42,0,0,0,.3,1.32c.14.42.31.89.42,1.34a22.63,22.63,0,0,1,.59,5.55,30.2,30.2,0,0,0-1-5.45,15.25,15.25,0,0,1-.79-2.69,11.25,11.25,0,0,1-.08-2.84,10.22,10.22,0,0,1,.67-2.76,6.66,6.66,0,0,1,.68-1.26,7,7,0,0,1,.94-1.06,3.77,3.77,0,0,0,.73-1.1,4.11,4.11,0,0,0,.22-1.32A17.31,17.31,0,0,1,858.05,297Z"
            fill="#44322c"
          />
          <path
            d="M858.05,261.22c.1,1.07.51,2.06.57,3.17a3.26,3.26,0,0,1-.08.82,2.73,2.73,0,0,0-.14.75,6.93,6.93,0,0,0,.3,1.52,15.19,15.19,0,0,1,.92,6.36,12,12,0,0,1-.36,1.6,13,13,0,0,0-.33,1.53,20.65,20.65,0,0,0-.16,3.15,38.58,38.58,0,0,0,.71,6.32,29.16,29.16,0,0,1-1.1-6.31,17.48,17.48,0,0,1,.1-3.23,11.33,11.33,0,0,1,.32-1.6,11.41,11.41,0,0,0,.32-1.52,10.47,10.47,0,0,0-.07-3.11c-.17-1-.47-2.05-.72-3.1a6.6,6.6,0,0,1-.24-1.62,3.22,3.22,0,0,1,.17-.81,3.26,3.26,0,0,0,.12-.76C858.4,263.35,858.07,262.29,858.05,261.22Z"
            fill="#44322c"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="874.8"
          cy="345.49"
          rx="31.2"
          ry="5.51"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M858.43,340.75c-5.36,2.72-6.52,3.3-11.35,1.36s-14.49-13.13-3.67-20.67,21.83,2.52,21.83,7c0,0-18.74-19.51,0-24.53s12.56,14.68,11.2,17.57c0,0,6.77-13.33,14.49-9.27s2.76,29.14-11.46,22.68c0,0,19.19-9.16,25.18.7s-32.65,11.78-39.41,8.5S858.43,340.75,858.43,340.75Z"
          fill="#1f441f"
        />
        <path
          d="M858,317.48c4.84,1.95,3.19-7.63,3.19-7.63s2.13-1.16,2.18-5.39C856.15,307.16,856,312.52,858,317.48Z"
          fill="#659965"
        />
        <path
          d="M874.71,324.53c-13.72-1.35-13.91-12.94-6.38-16.22S874.71,324.53,874.71,324.53Z"
          fill="#245624"
        />
        <path
          d="M868.48,334.68c-22.25,3.63-26.53-12.13-15.69-19.62S868.48,334.68,868.48,334.68Z"
          fill="#245624"
        />
        <path
          d="M877.79,334.21c16.71,9.86,26.56-3.16,20.72-13.15S877.79,334.21,877.79,334.21Z"
          fill="#245624"
        />
        <g>
          <path
            d="M876.44,321.44c7,4.64,8.31-3.67,8.31-3.67,3-.4,3.87-3.36,4.13-6.29C882.05,310.4,876.44,321.44,876.44,321.44Z"
            fill="#659965"
          />
          <path d="M876.44,321.44a13.86,13.86,0,0,0,.54-1.38Z" fill="#659965" />
        </g>
        <path
          d="M884.53,337.12c9.55,2.5,15.6-3.22,15.67-9.88-.35.31-.7.6-1,.85-4.56,3.38-8.23,2.05-8.23,2.05s-.58,7.72-6.18,5.7Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M860.7,342.79s-17-6-12.94-15.65,9.85-4.44,12.94,7.73c0,0-4.06-25.89,10.82-22.41s3.67,21.83,0,22.41c0,0,10.82-14.68,17.77-4.06s-11.4,12.75-16,12S860.7,342.79,860.7,342.79Z"
            fill="#659965"
          />
          <path
            d="M889.29,330.81a9.73,9.73,0,0,0-2.53-2.72C884.69,335.85,877,335,877,335s.2,7.14-8.11,5.79l-.82,1.69a33.24,33.24,0,0,1,5.17.34C877.89,343.56,896.24,341.44,889.29,330.81Z"
            fill="#396039"
          />
          <path
            d="M865.24,332.84s5,2.4,11.1-3.07c2.67-4.63,4.37-11.28,0-15-3,7.48-8.23,7.48-8.23,7.48S873.74,331.49,865.24,332.84Z"
            fill="#396039"
          />
          <path
            d="M861.18,342.75a15.26,15.26,0,0,1-6.37-7.2c-4.68.6-6.77-4.81-7.45-7.21-2.25,9,13.34,14.45,13.34,14.45Z"
            fill="#396039"
          />
        </g>
        <path
          d="M848.24,338.64a20.6,20.6,0,0,1-6.61-1,14.88,14.88,0,0,0,5.45,4.48c4.49,1.8,5.81,1.42,10.28-.82A21.9,21.9,0,0,1,848.24,338.64Z"
          fill="#172d17"
        />
        <path
          d="M904.55,335.39c-2.46,5.13-9,5.68-11.3,5,0,0-3.06,4-14.14,5.13,13.13-.24,29.6-3.28,25.54-10C904.62,335.49,904.58,335.44,904.55,335.39Z"
          fill="#172d17"
        />
        <path
          d="M861.18,342.69c-5.6-2.31-3.67-7.92,0-7.14S861.18,342.69,861.18,342.69Z"
          fill="#245624"
        />
        <path
          d="M860.84,342.43c8.89,8.62,17.83.45,13.4-5.8S860.84,342.43,860.84,342.43Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="125.2"
          cy="361.86"
          rx="17.8"
          ry="3.14"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M115.86,359.15c-3.06,1.55-3.72,1.88-6.47.78s-8.27-7.49-2.1-11.79,12.46,1.43,12.46,4c0,0-10.69-11.13,0-14s7.16,8.38,6.39,10c0,0,3.86-7.61,8.26-5.29s1.58,16.62-6.54,12.94c0,0,11-5.23,14.37.39s-18.63,6.73-22.48,4.85Z"
          fill="#1f441f"
        />
        <path
          d="M115.61,345.88c2.76,1.11,1.82-4.35,1.82-4.35s1.21-.66,1.24-3.08C114.56,340,114.5,343.05,115.61,345.88Z"
          fill="#659965"
        />
        <path
          d="M125.15,349.9c-7.83-.77-7.94-7.38-3.64-9.26S125.15,349.9,125.15,349.9Z"
          fill="#245624"
        />
        <path
          d="M121.59,355.69c-12.69,2.07-15.13-6.92-9-11.19S121.59,355.69,121.59,355.69Z"
          fill="#245624"
        />
        <path
          d="M126.9,355.42c9.54,5.62,15.16-1.8,11.83-7.5S126.9,355.42,126.9,355.42Z"
          fill="#245624"
        />
        <g>
          <path
            d="M126.14,348.14c4,2.64,4.74-2.1,4.74-2.1,1.69-.23,2.2-1.91,2.36-3.59C129.34,341.84,126.14,348.14,126.14,348.14Z"
            fill="#659965"
          />
          <path d="M126.14,348.14a8.21,8.21,0,0,0,.31-.79Z" fill="#659965" />
        </g>
        <path
          d="M130.75,357.08c5.45,1.43,8.9-1.84,8.94-5.64-.2.18-.4.35-.59.49-2.6,1.93-4.7,1.17-4.7,1.17s-.33,4.41-3.52,3.25Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M117.16,360.32s-9.7-3.42-7.39-8.93,5.62-2.54,7.39,4.41c0,0-2.32-14.77,6.17-12.79s2.09,12.46,0,12.79c0,0,6.17-8.38,10.14-2.32s-6.5,7.28-9.15,6.84A36,36,0,0,0,117.16,360.32Z"
            fill="#659965"
          />
          <path
            d="M133.47,353.48a5.76,5.76,0,0,0-1.45-1.55,5.17,5.17,0,0,1-5.55,3.92s.11,4.08-4.63,3.31l-.47,1a18,18,0,0,1,2.95.2C127,360.76,137.43,359.54,133.47,353.48Z"
            fill="#396039"
          />
          <path
            d="M119.75,354.64s2.86,1.37,6.33-1.75c1.52-2.64,2.49-6.44,0-8.57-1.7,4.26-4.69,4.26-4.69,4.26S124.6,353.87,119.75,354.64Z"
            fill="#396039"
          />
          <path
            d="M117.43,360.29a8.67,8.67,0,0,1-3.63-4.11c-2.67.35-3.86-2.74-4.26-4.11-1.28,5.11,7.62,8.25,7.62,8.25Z"
            fill="#396039"
          />
        </g>
        <path
          d="M110.05,358a11.8,11.8,0,0,1-3.78-.58,8.61,8.61,0,0,0,3.12,2.56c2.56,1,3.31.81,5.86-.47A12.51,12.51,0,0,1,110.05,358Z"
          fill="#172d17"
        />
        <path
          d="M142.17,356.1c-1.4,2.92-5.16,3.23-6.44,2.84,0,0-1.75,2.26-8.07,2.93,7.49-.14,16.89-1.87,14.57-5.69Z"
          fill="#172d17"
        />
        <path
          d="M117.43,360.26c-3.19-1.32-2.09-4.52,0-4.08S117.43,360.26,117.43,360.26Z"
          fill="#245624"
        />
        <path
          d="M117.24,360.11c5.07,4.92,10.17.26,7.64-3.31S117.24,360.11,117.24,360.11Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="158.2"
          cy="368.86"
          rx="17.8"
          ry="3.14"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M148.86,366.15c-3.06,1.55-3.72,1.88-6.47.78s-8.27-7.49-2.1-11.79,12.46,1.43,12.46,4c0,0-10.69-11.13,0-14s7.16,8.38,6.39,10c0,0,3.86-7.61,8.26-5.29s1.58,16.62-6.54,12.94c0,0,10.95-5.23,14.37.39s-18.63,6.73-22.48,4.85Z"
          fill="#1f441f"
        />
        <path
          d="M148.61,352.88c2.76,1.11,1.82-4.35,1.82-4.35s1.21-.66,1.24-3.08C147.56,347,147.5,350.05,148.61,352.88Z"
          fill="#659965"
        />
        <path
          d="M158.15,356.9c-7.83-.77-7.94-7.38-3.64-9.26S158.15,356.9,158.15,356.9Z"
          fill="#245624"
        />
        <path
          d="M154.59,362.69c-12.69,2.07-15.13-6.92-9-11.19S154.59,362.69,154.59,362.69Z"
          fill="#245624"
        />
        <path
          d="M159.9,362.42c9.54,5.62,15.16-1.8,11.83-7.5S159.9,362.42,159.9,362.42Z"
          fill="#245624"
        />
        <g>
          <path
            d="M159.14,355.14c4,2.64,4.74-2.1,4.74-2.1,1.69-.23,2.2-1.91,2.36-3.59C162.34,348.84,159.14,355.14,159.14,355.14Z"
            fill="#659965"
          />
          <path d="M159.14,355.14a8.21,8.21,0,0,0,.31-.79Z" fill="#659965" />
        </g>
        <path
          d="M163.75,364.08c5.45,1.43,8.9-1.84,8.94-5.64-.2.18-.4.35-.59.49-2.6,1.93-4.7,1.17-4.7,1.17s-.33,4.41-3.52,3.25Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M150.16,367.32s-9.7-3.42-7.39-8.93,5.62-2.54,7.39,4.41c0,0-2.32-14.77,6.17-12.79s2.09,12.46,0,12.79c0,0,6.17-8.38,10.14-2.32s-6.5,7.28-9.15,6.84A36,36,0,0,0,150.16,367.32Z"
            fill="#659965"
          />
          <path
            d="M166.47,360.48a5.76,5.76,0,0,0-1.45-1.55,5.17,5.17,0,0,1-5.55,3.92s.11,4.08-4.63,3.31l-.47,1a18,18,0,0,1,2.95.2C160,367.76,170.43,366.54,166.47,360.48Z"
            fill="#396039"
          />
          <path
            d="M152.75,361.64s2.86,1.37,6.33-1.75c1.52-2.64,2.49-6.44,0-8.57-1.7,4.26-4.69,4.26-4.69,4.26S157.6,360.87,152.75,361.64Z"
            fill="#396039"
          />
          <path
            d="M150.43,367.29a8.67,8.67,0,0,1-3.63-4.11c-2.67.35-3.86-2.74-4.26-4.11-1.28,5.11,7.62,8.25,7.62,8.25Z"
            fill="#396039"
          />
        </g>
        <path
          d="M143.05,365a11.8,11.8,0,0,1-3.78-.58,8.61,8.61,0,0,0,3.12,2.56c2.56,1,3.31.81,5.86-.47A12.51,12.51,0,0,1,143.05,365Z"
          fill="#172d17"
        />
        <path
          d="M175.17,363.1c-1.4,2.92-5.16,3.23-6.44,2.84,0,0-1.75,2.26-8.07,2.93,7.49-.14,16.89-1.87,14.57-5.69Z"
          fill="#172d17"
        />
        <path
          d="M150.43,367.26c-3.19-1.32-2.09-4.52,0-4.08S150.43,367.26,150.43,367.26Z"
          fill="#245624"
        />
        <path
          d="M150.24,367.11c5.07,4.92,10.17.26,7.64-3.31S150.24,367.11,150.24,367.11Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="195.2"
          cy="380.86"
          rx="17.8"
          ry="3.14"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M185.86,378.15c-3.06,1.55-3.72,1.88-6.47.78s-8.27-7.49-2.1-11.79,12.46,1.43,12.46,4c0,0-10.69-11.13,0-14s7.16,8.38,6.39,10c0,0,3.86-7.61,8.26-5.29s1.58,16.62-6.54,12.94c0,0,10.95-5.23,14.37.39s-18.63,6.73-22.48,4.85Z"
          fill="#1f441f"
        />
        <path
          d="M185.61,364.88c2.76,1.11,1.82-4.35,1.82-4.35s1.21-.66,1.24-3.08C184.56,359,184.5,362.05,185.61,364.88Z"
          fill="#659965"
        />
        <path
          d="M195.15,368.9c-7.83-.77-7.94-7.38-3.64-9.26S195.15,368.9,195.15,368.9Z"
          fill="#245624"
        />
        <path
          d="M191.59,374.69c-12.69,2.07-15.13-6.92-9-11.19S191.59,374.69,191.59,374.69Z"
          fill="#245624"
        />
        <path
          d="M196.9,374.42c9.54,5.62,15.16-1.8,11.83-7.5S196.9,374.42,196.9,374.42Z"
          fill="#245624"
        />
        <g>
          <path
            d="M196.14,367.14c4,2.64,4.74-2.1,4.74-2.1,1.69-.23,2.2-1.91,2.36-3.59C199.34,360.84,196.14,367.14,196.14,367.14Z"
            fill="#659965"
          />
          <path d="M196.14,367.14a8.21,8.21,0,0,0,.31-.79Z" fill="#659965" />
        </g>
        <path
          d="M200.75,376.08c5.45,1.43,8.9-1.84,8.94-5.64-.2.18-.4.35-.59.49-2.6,1.93-4.7,1.17-4.7,1.17s-.33,4.41-3.52,3.25Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M187.16,379.32s-9.7-3.42-7.39-8.93,5.62-2.54,7.39,4.41c0,0-2.32-14.77,6.17-12.79s2.09,12.46,0,12.79c0,0,6.17-8.38,10.14-2.32s-6.5,7.28-9.15,6.84A36,36,0,0,0,187.16,379.32Z"
            fill="#659965"
          />
          <path
            d="M203.47,372.48a5.76,5.76,0,0,0-1.45-1.55,5.17,5.17,0,0,1-5.55,3.92s.11,4.08-4.63,3.31l-.47,1a18,18,0,0,1,2.95.2C197,379.76,207.43,378.54,203.47,372.48Z"
            fill="#396039"
          />
          <path
            d="M189.75,373.64s2.86,1.37,6.33-1.75c1.52-2.64,2.49-6.44,0-8.57-1.7,4.26-4.69,4.26-4.69,4.26S194.6,372.87,189.75,373.64Z"
            fill="#396039"
          />
          <path
            d="M187.43,379.29a8.67,8.67,0,0,1-3.63-4.11c-2.67.35-3.86-2.74-4.26-4.11-1.28,5.11,7.62,8.25,7.62,8.25Z"
            fill="#396039"
          />
        </g>
        <path
          d="M180.05,377a11.8,11.8,0,0,1-3.78-.58,8.61,8.61,0,0,0,3.12,2.56c2.56,1,3.31.81,5.86-.47A12.51,12.51,0,0,1,180.05,377Z"
          fill="#172d17"
        />
        <path
          d="M212.17,375.1c-1.4,2.92-5.16,3.23-6.44,2.84,0,0-1.75,2.26-8.07,2.93,7.49-.14,16.89-1.87,14.57-5.69Z"
          fill="#172d17"
        />
        <path
          d="M187.43,379.26c-3.19-1.32-2.09-4.52,0-4.08S187.43,379.26,187.43,379.26Z"
          fill="#245624"
        />
        <path
          d="M187.24,379.11c5.07,4.92,10.17.26,7.64-3.31S187.24,379.11,187.24,379.11Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="1057.75"
          cy="372.08"
          rx="44.89"
          ry="7.92"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M1034.19,365.25c-7.72,3.91-9.38,4.74-16.33,2s-20.85-18.9-5.29-29.74,31.42,3.61,31.42,10c0,0-27-28.08,0-35.31s18.07,21.13,16.12,25.3c0,0,9.73-19.18,20.85-13.34s4,41.92-16.5,32.63c0,0,27.62-13.18,36.23,1s-47,17-56.7,12.23S1034.19,365.25,1034.19,365.25Z"
          fill="#1f441f"
        />
        <path
          d="M1033.56,331.76c7,2.8,4.59-11,4.59-11s3.06-1.67,3.13-7.75C1030.9,316.92,1030.75,324.62,1033.56,331.76Z"
          fill="#659965"
        />
        <path
          d="M1057.61,341.92c-19.74-1.95-20-18.63-9.18-23.35S1057.61,341.92,1057.61,341.92Z"
          fill="#245624"
        />
        <path
          d="M1048.64,356.52c-32,5.21-38.17-17.46-22.57-28.23S1048.64,356.52,1048.64,356.52Z"
          fill="#245624"
        />
        <path
          d="M1062,355.84c24.06,14.18,38.23-4.55,29.83-18.93S1062,355.84,1062,355.84Z"
          fill="#245624"
        />
        <g>
          <path
            d="M1060.11,337.47c10,6.67,12-5.28,12-5.28,4.28-.59,5.56-4.84,6-9.06C1068.17,321.57,1060.11,337.47,1060.11,337.47Z"
            fill="#659965"
          />
          <path d="M1060.11,337.47c.2-.43.47-1.12.77-2Z" fill="#659965" />
        </g>
        <path
          d="M1071.75,360c13.74,3.61,22.44-4.63,22.55-14.21-.51.45-1,.86-1.51,1.23C1086.24,351.9,1081,350,1081,350s-.84,11.12-8.9,8.2Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M1037.45,368.19s-24.46-8.62-18.62-22.52,14.18-6.39,18.62,11.12c0,0-5.83-37.25,15.57-32.25s5.28,31.41,0,32.25c0,0,15.57-21.13,25.57-5.84s-16.4,18.35-23.07,17.24S1037.45,368.19,1037.45,368.19Z"
            fill="#659965"
          />
          <path
            d="M1078.59,351A14.07,14.07,0,0,0,1075,347c-3,11.17-14,9.9-14,9.9s.28,10.28-11.67,8.34l-1.18,2.42a48.79,48.79,0,0,1,7.43.5C1062.19,369.3,1088.6,366.24,1078.59,351Z"
            fill="#396039"
          />
          <path
            d="M1044,353.87s7.22,3.44,16-4.42c3.84-6.66,6.29-16.23,0-21.62-4.31,10.75-11.84,10.75-11.84,10.75S1056.22,351.92,1044,353.87Z"
            fill="#396039"
          />
          <path
            d="M1038.15,368.12a21.88,21.88,0,0,1-9.17-10.36c-6.74.87-9.74-6.92-10.73-10.36-3.24,12.88,19.2,20.79,19.2,20.79Z"
            fill="#396039"
          />
        </g>
        <path
          d="M1019.52,362.21a29.66,29.66,0,0,1-9.51-1.45,21.47,21.47,0,0,0,7.85,6.45c6.46,2.59,8.35,2.05,14.78-1.18A31.5,31.5,0,0,1,1019.52,362.21Z"
          fill="#172d17"
        />
        <path
          d="M1100.55,357.54c-3.54,7.37-13,8.17-16.26,7.17,0,0-4.4,5.71-20.35,7.38,18.89-.34,42.6-4.71,36.75-14.33Z"
          fill="#172d17"
        />
        <path
          d="M1038.15,368.05c-8.06-3.34-5.28-11.4,0-10.29S1038.15,368.05,1038.15,368.05Z"
          fill="#245624"
        />
        <path
          d="M1037.66,367.66c12.79,12.41,25.65.66,19.28-8.34S1037.66,367.66,1037.66,367.66Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <path
          d="M825,316c16.92-1.62-7.77,60.59,38.88,66.18s62.21,14.91,57.35,26.1-53.46,16.78-71,8.39-71-34.49-58.32-67.11S815.24,317,825,316Z"
          fill="#396039"
        />
        <path
          d="M826.8,321.6c13.57-1.36-6.24,50.67,31.18,55.34s49.89,12.48,46,21.83-42.88,14-56.91,7-56.91-28.85-46.77-56.13S819,322.38,826.8,321.6Z"
          fill="#493b1b"
        />
        <g>
          <path
            d="M885.22,388.81a9.74,9.74,0,0,1-.62-1.66,11.06,11.06,0,0,1-.36-1.73,8.05,8.05,0,0,1-.07-1.77,3.31,3.31,0,0,1,.5-1.71,5.47,5.47,0,0,0-.08,1.71c0,.57.1,1.13.19,1.7C884.92,386.49,885.11,387.63,885.22,388.81Z"
            fill="#396039"
          />
          <path
            d="M885,381.58c-3.79-1.09-2.17-5.79,2.72-5.07S885,381.58,885,381.58Z"
            fill="#a04d90"
          />
          <path
            d="M885,381.58s3.62-3.08,5.61-2-.18,4.16-2.89,3.43S885,381.58,885,381.58Z"
            fill="#a04d90"
          />
          <path
            d="M884.49,381.58a3.18,3.18,0,0,0-2.89-2.17c-2.35-.18-3.26,3.79-.9,3.79A5.42,5.42,0,0,0,884.49,381.58Z"
            fill="#a04d90"
          />
          <path
            d="M884.67,381.21s4.34,1.27,1.63,2.72S881.42,383.2,884.67,381.21Z"
            fill="#a04d90"
          />
          <path
            d="M879.38,382.24a1.24,1.24,0,0,0,1.32,1,5.42,5.42,0,0,0,3.79-1.62C883.41,382,880.62,382.63,879.38,382.24Z"
            fill="#7f3374"
          />
          <path d="M881.6,380.85a3,3,0,0,1,2.89.73" fill="#7f3374" />
          <path d="M885.4,377.78s-2.17,1.45-.91,3.43" fill="#7f3374" />
          <path d="M888.47,377.6s-3.62,1.45-3.8,3.61" fill="#7f3374" />
          <path d="M885,381.58a4.76,4.76,0,0,1,3.8-.91" fill="#7f3374" />
          <path d="M885.21,381.88s3.44-1,5.43-.67" fill="#7f3374" />
          <path
            d="M891,381.88s-3.66.81-5.63.17a6.61,6.61,0,0,0,2.35,1A3,3,0,0,0,891,381.88Z"
            fill="#7f3374"
          />
          <path
            d="M887.13,383.2a4.93,4.93,0,0,1-4.09.11c.06,1,1.55,1.53,3.26.62A1.75,1.75,0,0,0,887.13,383.2Z"
            fill="#7f3374"
          />
          <path d="M884.67,381.94a1.06,1.06,0,0,0-.36,1.26" fill="#7f3374" />
          <path d="M884.67,381.58s.36,1.62,1.45,1.62" fill="#7f3374" />
          <ellipse cx="884.76" cy="381.4" rx="0.99" ry="0.54" fill="#b7b720" />
          <path
            d="M885.12,388.44s-1.08-1.71,1.09-3.16C886.21,385.28,886.91,388,885.12,388.44Z"
            fill="#396039"
          />
          <path
            d="M884.31,385.92s.54-.55-1.63-1.45C882.68,384.47,882.5,385.74,884.31,385.92Z"
            fill="#396039"
          />
          <path
            d="M886.21,385.28c-.17.54-.4,1-.57,1.58-.1.25-.2.51-.28.78a2.46,2.46,0,0,0-.14.81,1.59,1.59,0,0,1,0-.84c.07-.28.15-.55.23-.82A11.1,11.1,0,0,1,886.21,385.28Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M868.8,401c.05-.65.17-1.27.24-1.9.05-.31.08-.63.1-.94a3,3,0,0,0,0-.94,1.93,1.93,0,0,1,.27.94,5.32,5.32,0,0,1,0,1A6.38,6.38,0,0,1,868.8,401Z"
            fill="#396039"
          />
          <path
            d="M868.9,397.06c2.08-.59,1.19-3.17-1.49-2.78S868.9,397.06,868.9,397.06Z"
            fill="#a04d90"
          />
          <path
            d="M868.9,397.06s-2-1.68-3.08-1.09.1,2.29,1.59,1.89S868.9,397.06,868.9,397.06Z"
            fill="#a04d90"
          />
          <path
            d="M869.2,397.06a1.73,1.73,0,0,1,1.58-1.19c1.29-.1,1.79,2.09.5,2.09A3,3,0,0,1,869.2,397.06Z"
            fill="#a04d90"
          />
          <path
            d="M869.1,396.87s-2.39.69-.9,1.49S870.88,398,869.1,396.87Z"
            fill="#a04d90"
          />
          <path
            d="M872,397.43a.67.67,0,0,1-.72.53,3,3,0,0,1-2.08-.9A5.66,5.66,0,0,0,872,397.43Z"
            fill="#7f3374"
          />
          <path d="M870.78,396.67a1.62,1.62,0,0,0-1.58.39" fill="#7f3374" />
          <path d="M868.7,395a1.41,1.41,0,0,1,.5,1.89" fill="#7f3374" />
          <path d="M867,394.88s2,.79,2.09,2" fill="#7f3374" />
          <path d="M868.9,397.06a2.63,2.63,0,0,0-2.09-.49" fill="#7f3374" />
          <path d="M868.8,397.23a8.55,8.55,0,0,0-3-.36" fill="#7f3374" />
          <path
            d="M865.61,397.23a7.51,7.51,0,0,0,3.09.09,3.74,3.74,0,0,1-1.29.54A1.66,1.66,0,0,1,865.61,397.23Z"
            fill="#7f3374"
          />
          <path
            d="M867.75,398A2.74,2.74,0,0,0,870,398c0,.55-.85.84-1.79.34A1,1,0,0,1,867.75,398Z"
            fill="#7f3374"
          />
          <path d="M869.1,397.26a.59.59,0,0,1,.19.7" fill="#7f3374" />
          <path d="M869.1,397.06s-.2.9-.8.9" fill="#7f3374" />
          <ellipse cx="869.05" cy="396.97" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M868.85,400.83s.59-.94-.6-1.73C868.25,399.1,867.87,400.58,868.85,400.83Z"
            fill="#396039"
          />
          <path
            d="M869.29,399.45s-.29-.3.9-.8C870.19,398.65,870.29,399.35,869.29,399.45Z"
            fill="#396039"
          />
          <path
            d="M868.25,399.1a6.4,6.4,0,0,1,.41.83,1.9,1.9,0,0,1,.14.91,1.7,1.7,0,0,0-.08-.45c-.05-.14-.1-.28-.16-.43S868.34,399.4,868.25,399.1Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M872.19,388.81c0-.65.18-1.27.25-1.9,0-.31.07-.62.1-.93a2.7,2.7,0,0,0,0-.94,1.81,1.81,0,0,1,.28.93,6.05,6.05,0,0,1-.58,2.84Z"
            fill="#396039"
          />
          <path
            d="M872.29,384.84c2.09-.6,1.2-3.18-1.49-2.78S872.29,384.84,872.29,384.84Z"
            fill="#a04d90"
          />
          <path
            d="M872.29,384.84s-2-1.69-3.07-1.09.1,2.28,1.58,1.88S872.29,384.84,872.29,384.84Z"
            fill="#a04d90"
          />
          <path
            d="M872.59,384.84a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,872.59,384.84Z"
            fill="#a04d90"
          />
          <path
            d="M872.49,384.64s-2.38.69-.89,1.49S874.28,385.73,872.49,384.64Z"
            fill="#a04d90"
          />
          <path
            d="M875.4,385.2a.69.69,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.69,5.69,0,0,0,875.4,385.2Z"
            fill="#7f3374"
          />
          <path d="M874.18,384.44a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M872.1,382.75a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
          <path d="M870.41,382.65s2,.8,2.08,2" fill="#7f3374" />
          <path d="M872.29,384.84a2.58,2.58,0,0,0-2.08-.5" fill="#7f3374" />
          <path d="M872.2,385a8.55,8.55,0,0,0-3-.36" fill="#7f3374" />
          <path
            d="M869,385a7.7,7.7,0,0,0,3.1.1,3.88,3.88,0,0,1-1.3.53A1.67,1.67,0,0,1,869,385Z"
            fill="#7f3374"
          />
          <path
            d="M871.14,385.73a2.71,2.71,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,871.14,385.73Z"
            fill="#7f3374"
          />
          <path d="M872.49,385a.57.57,0,0,1,.2.69" fill="#7f3374" />
          <path d="M872.49,384.84s-.2.89-.79.89" fill="#7f3374" />
          <ellipse cx="872.44" cy="384.74" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M872.25,388.61s.59-.94-.6-1.74C871.65,386.87,871.26,388.35,872.25,388.61Z"
            fill="#396039"
          />
          <path
            d="M872.69,387.22s-.3-.3.89-.79C873.58,386.43,873.68,387.12,872.69,387.22Z"
            fill="#396039"
          />
          <path
            d="M871.65,386.87a5.28,5.28,0,0,1,.4.83,1.78,1.78,0,0,1,.14.91,1.62,1.62,0,0,0-.07-.44c0-.15-.1-.29-.16-.43C871.87,387.44,871.74,387.17,871.65,386.87Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M882.56,398.32a6.73,6.73,0,0,1-.54-1.86,6.38,6.38,0,0,1,0-1,1.81,1.81,0,0,1,.28-.93,3,3,0,0,0,0,.94c0,.31,0,.62.11.93C882.38,397.05,882.51,397.67,882.56,398.32Z"
            fill="#396039"
          />
          <path
            d="M882.46,394.35c-2.09-.6-1.19-3.18,1.49-2.78S882.46,394.35,882.46,394.35Z"
            fill="#a04d90"
          />
          <path
            d="M882.46,394.35s2-1.69,3.08-1.09-.1,2.28-1.59,1.88S882.46,394.35,882.46,394.35Z"
            fill="#a04d90"
          />
          <path
            d="M882.16,394.35a1.75,1.75,0,0,0-1.59-1.19c-1.29-.1-1.79,2.08-.49,2.08A3,3,0,0,0,882.16,394.35Z"
            fill="#a04d90"
          />
          <path
            d="M882.26,394.15s2.38.69.89,1.49S880.47,395.24,882.26,394.15Z"
            fill="#a04d90"
          />
          <path
            d="M879.35,394.71a.69.69,0,0,0,.73.53,3,3,0,0,0,2.08-.89A5.68,5.68,0,0,1,879.35,394.71Z"
            fill="#7f3374"
          />
          <path d="M880.57,394a1.62,1.62,0,0,1,1.59.4" fill="#7f3374" />
          <path d="M882.66,392.26a1.41,1.41,0,0,0-.5,1.89" fill="#7f3374" />
          <path d="M884.34,392.16s-2,.8-2.08,2" fill="#7f3374" />
          <path d="M882.46,394.35a2.58,2.58,0,0,1,2.08-.5" fill="#7f3374" />
          <path d="M882.56,394.51a8.51,8.51,0,0,1,3-.36" fill="#7f3374" />
          <path
            d="M885.75,394.51a7.65,7.65,0,0,1-3.09.1,3.8,3.8,0,0,0,1.29.53A1.66,1.66,0,0,0,885.75,394.51Z"
            fill="#7f3374"
          />
          <path
            d="M883.61,395.24a2.72,2.72,0,0,1-2.25.06c0,.55.86.84,1.79.34A1,1,0,0,0,883.61,395.24Z"
            fill="#7f3374"
          />
          <path d="M882.26,394.55a.57.57,0,0,0-.2.69" fill="#7f3374" />
          <path d="M882.26,394.35s.2.89.79.89" fill="#7f3374" />
          <ellipse cx="882.31" cy="394.25" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M882.5,398.12s-.59-.94.6-1.74C883.1,396.38,883.49,397.86,882.5,398.12Z"
            fill="#396039"
          />
          <path
            d="M882.06,396.73s.3-.3-.89-.79C881.17,395.94,881.07,396.63,882.06,396.73Z"
            fill="#396039"
          />
          <path
            d="M883.1,396.38c-.09.3-.22.57-.31.87,0,.14-.11.28-.15.43a1.32,1.32,0,0,0-.08.44,1.78,1.78,0,0,1,.14-.91A5.28,5.28,0,0,1,883.1,396.38Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M860.31,388.13c.05-.65.17-1.27.24-1.9.05-.31.08-.62.1-.93a2.7,2.7,0,0,0,0-.94,1.81,1.81,0,0,1,.28.93,5.32,5.32,0,0,1,0,1A6.71,6.71,0,0,1,860.31,388.13Z"
            fill="#396039"
          />
          <path
            d="M860.41,384.16c2.08-.6,1.19-3.18-1.49-2.78S860.41,384.16,860.41,384.16Z"
            fill="#a04d90"
          />
          <path
            d="M860.41,384.16s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S860.41,384.16,860.41,384.16Z"
            fill="#a04d90"
          />
          <path
            d="M860.7,384.16a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,860.7,384.16Z"
            fill="#a04d90"
          />
          <path
            d="M860.6,384s-2.38.69-.89,1.49S862.39,385.05,860.6,384Z"
            fill="#a04d90"
          />
          <path
            d="M863.51,384.52a.68.68,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.71,5.71,0,0,0,863.51,384.52Z"
            fill="#7f3374"
          />
          <path d="M862.29,383.76a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M860.21,382.07a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
          <path d="M858.52,382s2,.8,2.08,2" fill="#7f3374" />
          <path d="M860.41,384.16a2.61,2.61,0,0,0-2.09-.5" fill="#7f3374" />
          <path d="M860.31,384.33a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M857.11,384.33a8,8,0,0,0,3.1.09,3.8,3.8,0,0,1-1.29.53A1.69,1.69,0,0,1,857.11,384.33Z"
            fill="#7f3374"
          />
          <path
            d="M859.26,385.05a2.69,2.69,0,0,0,2.24.06c0,.55-.85.84-1.79.34A1,1,0,0,1,859.26,385.05Z"
            fill="#7f3374"
          />
          <path d="M860.6,384.36a.57.57,0,0,1,.2.69" fill="#7f3374" />
          <path d="M860.6,384.16s-.19.89-.79.89" fill="#7f3374" />
          <ellipse cx="860.56" cy="384.06" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M860.36,387.93s.59-.94-.6-1.74C859.76,386.19,859.37,387.67,860.36,387.93Z"
            fill="#396039"
          />
          <path
            d="M860.8,386.54s-.29-.3.9-.79C861.7,385.75,861.8,386.44,860.8,386.54Z"
            fill="#396039"
          />
          <path
            d="M859.76,386.19a6.4,6.4,0,0,1,.41.83,2,2,0,0,1,.14.91,2.14,2.14,0,0,0-.08-.44c-.05-.15-.1-.29-.16-.43C860,386.77,859.85,386.49,859.76,386.19Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M834.49,368.77c0-.65.18-1.27.25-1.9,0-.31.07-.62.1-.93a2.7,2.7,0,0,0-.05-.94,1.81,1.81,0,0,1,.28.94,6.3,6.3,0,0,1,0,1A6.4,6.4,0,0,1,834.49,368.77Z"
            fill="#396039"
          />
          <path
            d="M834.59,364.8c2.09-.6,1.19-3.18-1.49-2.78S834.59,364.8,834.59,364.8Z"
            fill="#a04d90"
          />
          <path
            d="M834.59,364.8s-2-1.69-3.07-1.09.09,2.28,1.58,1.88S834.59,364.8,834.59,364.8Z"
            fill="#a04d90"
          />
          <path
            d="M834.89,364.8a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,834.89,364.8Z"
            fill="#a04d90"
          />
          <path
            d="M834.79,364.6s-2.38.69-.89,1.49S836.58,365.69,834.79,364.6Z"
            fill="#a04d90"
          />
          <path
            d="M837.7,365.16a.69.69,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.69,5.69,0,0,0,837.7,365.16Z"
            fill="#7f3374"
          />
          <path d="M836.48,364.4a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M834.39,362.71s1.2.8.5,1.89" fill="#7f3374" />
          <path d="M832.71,362.61s2,.8,2.08,2" fill="#7f3374" />
          <path d="M834.59,364.8a2.58,2.58,0,0,0-2.08-.5" fill="#7f3374" />
          <path d="M834.5,365a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M831.3,365a7.91,7.91,0,0,0,3.09.09,3.8,3.8,0,0,1-1.29.53A1.68,1.68,0,0,1,831.3,365Z"
            fill="#7f3374"
          />
          <path
            d="M833.44,365.69a2.71,2.71,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,833.44,365.69Z"
            fill="#7f3374"
          />
          <path d="M834.79,365a.57.57,0,0,1,.2.69" fill="#7f3374" />
          <path d="M834.79,364.8s-.2.89-.79.89" fill="#7f3374" />
          <ellipse cx="834.74" cy="364.7" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M834.55,368.57s.59-.94-.6-1.74C834,366.83,833.56,368.31,834.55,368.57Z"
            fill="#396039"
          />
          <path
            d="M835,367.18s-.3-.3.89-.79C835.88,366.39,836,367.08,835,367.18Z"
            fill="#396039"
          />
          <path
            d="M834,366.83a5.28,5.28,0,0,1,.4.83,1.8,1.8,0,0,1,.14.91,1.32,1.32,0,0,0-.08-.44,3.12,3.12,0,0,0-.15-.43C834.17,367.41,834,367.13,834,366.83Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M813.1,357.9c0-.65.17-1.27.24-1.9,0-.31.08-.62.1-.93a2.71,2.71,0,0,0-.05-.94,1.81,1.81,0,0,1,.28.94,5.25,5.25,0,0,1,0,1A6.61,6.61,0,0,1,813.1,357.9Z"
            fill="#396039"
          />
          <path
            d="M813.2,353.93c2.08-.6,1.19-3.18-1.49-2.78S813.2,353.93,813.2,353.93Z"
            fill="#a04d90"
          />
          <path
            d="M813.2,353.93s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S813.2,353.93,813.2,353.93Z"
            fill="#a04d90"
          />
          <path
            d="M813.49,353.93a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,813.49,353.93Z"
            fill="#a04d90"
          />
          <path
            d="M813.39,353.73s-2.38.7-.89,1.49S815.18,354.82,813.39,353.73Z"
            fill="#a04d90"
          />
          <path
            d="M816.3,354.29a.68.68,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.71,5.71,0,0,0,816.3,354.29Z"
            fill="#7f3374"
          />
          <path d="M815.08,353.53a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M813,351.84a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
          <path d="M811.31,351.75s2,.79,2.08,2" fill="#7f3374" />
          <path d="M813.2,353.93a2.66,2.66,0,0,0-2.09-.5" fill="#7f3374" />
          <path d="M813.1,354.1a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M809.9,354.1a8,8,0,0,0,3.1.09,3.6,3.6,0,0,1-1.29.53A1.69,1.69,0,0,1,809.9,354.1Z"
            fill="#7f3374"
          />
          <path
            d="M812,354.82a2.71,2.71,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,812,354.82Z"
            fill="#7f3374"
          />
          <path d="M813.39,354.13a.58.58,0,0,1,.2.69" fill="#7f3374" />
          <path d="M813.39,353.93s-.19.89-.79.89" fill="#7f3374" />
          <ellipse cx="813.34" cy="353.83" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M813.15,357.7s.59-.94-.6-1.73C812.55,356,812.16,357.44,813.15,357.7Z"
            fill="#396039"
          />
          <path
            d="M813.59,356.31s-.3-.3.9-.79C814.49,355.52,814.59,356.21,813.59,356.31Z"
            fill="#396039"
          />
          <path
            d="M812.55,356a4.79,4.79,0,0,1,.4.82,1.92,1.92,0,0,1,.15.91,2.14,2.14,0,0,0-.08-.44c0-.15-.1-.29-.16-.43S812.64,356.26,812.55,356Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M824.3,337.18c.05-.64.18-1.27.25-1.89.05-.32.07-.63.1-.94a2.71,2.71,0,0,0,0-.94,1.81,1.81,0,0,1,.28.94,6.25,6.25,0,0,1,0,1A6.31,6.31,0,0,1,824.3,337.18Z"
            fill="#396039"
          />
          <path
            d="M824.4,333.21c2.09-.59,1.2-3.18-1.49-2.78S824.4,333.21,824.4,333.21Z"
            fill="#a04d90"
          />
          <path
            d="M824.4,333.21s-2-1.69-3.07-1.09.1,2.28,1.58,1.89S824.4,333.21,824.4,333.21Z"
            fill="#a04d90"
          />
          <path
            d="M824.7,333.21a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.09.5,2.09A3,3,0,0,1,824.7,333.21Z"
            fill="#a04d90"
          />
          <path
            d="M824.6,333s-2.38.7-.89,1.49S826.39,334.11,824.6,333Z"
            fill="#a04d90"
          />
          <path
            d="M827.51,333.57a.69.69,0,0,1-.72.54,3,3,0,0,1-2.09-.9A5.58,5.58,0,0,0,827.51,333.57Z"
            fill="#7f3374"
          />
          <path d="M826.29,332.81a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M824.21,331.13a1.39,1.39,0,0,1,.49,1.88" fill="#7f3374" />
          <path d="M822.52,331s2,.79,2.08,2" fill="#7f3374" />
          <path d="M824.4,333.21a2.6,2.6,0,0,0-2.08-.49" fill="#7f3374" />
          <path d="M824.31,333.38a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M821.11,333.38a8,8,0,0,0,3.1.09,3.83,3.83,0,0,1-1.3.54A1.7,1.7,0,0,1,821.11,333.38Z"
            fill="#7f3374"
          />
          <path
            d="M823.25,334.11a2.7,2.7,0,0,0,2.25.05c0,.56-.85.84-1.79.34A1,1,0,0,1,823.25,334.11Z"
            fill="#7f3374"
          />
          <path d="M824.6,333.41a.59.59,0,0,1,.2.7" fill="#7f3374" />
          <path d="M824.6,333.21s-.2.9-.79.9" fill="#7f3374" />
          <ellipse cx="824.55" cy="333.11" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M824.36,337s.59-.94-.6-1.73C823.76,335.25,823.37,336.73,824.36,337Z"
            fill="#396039"
          />
          <path
            d="M824.8,335.59s-.3-.29.89-.79C825.69,334.8,825.79,335.5,824.8,335.59Z"
            fill="#396039"
          />
          <path
            d="M823.76,335.25a4.88,4.88,0,0,1,.4.83,1.75,1.75,0,0,1,.14.9,1.68,1.68,0,0,0-.07-.44c-.05-.15-.1-.29-.16-.43C824,335.82,823.85,335.54,823.76,335.25Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M827.36,328.35c0-.65.17-1.27.24-1.9.06-.31.08-.62.11-.93a3.3,3.3,0,0,0-.05-.94,1.91,1.91,0,0,1,.28.94,6.25,6.25,0,0,1,0,1A6.63,6.63,0,0,1,827.36,328.35Z"
            fill="#396039"
          />
          <path
            d="M827.46,324.38c2.09-.6,1.19-3.18-1.49-2.78S827.46,324.38,827.46,324.38Z"
            fill="#a04d90"
          />
          <path
            d="M827.46,324.38s-2-1.69-3.08-1.09.1,2.28,1.59,1.89S827.46,324.38,827.46,324.38Z"
            fill="#a04d90"
          />
          <path
            d="M827.76,324.38a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.78,2.08.49,2.08A3,3,0,0,1,827.76,324.38Z"
            fill="#a04d90"
          />
          <path
            d="M827.66,324.18s-2.38.7-.89,1.49S829.45,325.27,827.66,324.18Z"
            fill="#a04d90"
          />
          <path
            d="M830.57,324.74a.68.68,0,0,1-.73.53,3,3,0,0,1-2.08-.89A5.68,5.68,0,0,0,830.57,324.74Z"
            fill="#7f3374"
          />
          <path d="M829.35,324a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M827.26,322.3a1.4,1.4,0,0,1,.5,1.88" fill="#7f3374" />
          <path d="M825.57,322.2s2,.79,2.09,2" fill="#7f3374" />
          <path d="M827.46,324.38a2.63,2.63,0,0,0-2.08-.5" fill="#7f3374" />
          <path d="M827.36,324.55a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M824.17,324.55a7.91,7.91,0,0,0,3.09.09,3.74,3.74,0,0,1-1.29.54A1.7,1.7,0,0,1,824.17,324.55Z"
            fill="#7f3374"
          />
          <path
            d="M826.31,325.27a2.65,2.65,0,0,0,2.24.06c0,.55-.85.84-1.78.34A.94.94,0,0,1,826.31,325.27Z"
            fill="#7f3374"
          />
          <path d="M827.66,324.58a.58.58,0,0,1,.2.69" fill="#7f3374" />
          <path d="M827.66,324.38s-.2.89-.8.89" fill="#7f3374" />
          <ellipse cx="827.61" cy="324.28" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M827.42,328.15s.59-.94-.6-1.73C826.82,326.42,826.43,327.89,827.42,328.15Z"
            fill="#396039"
          />
          <path
            d="M827.86,326.76s-.3-.29.89-.79C828.75,326,828.85,326.66,827.86,326.76Z"
            fill="#396039"
          />
          <path
            d="M826.82,326.42a5.78,5.78,0,0,1,.4.83,1.75,1.75,0,0,1,.14.9,1.32,1.32,0,0,0-.08-.44c0-.15-.1-.29-.15-.43S826.91,326.71,826.82,326.42Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M809.36,350.43c0-.65.17-1.27.24-1.9a7.34,7.34,0,0,0,.1-.93,3,3,0,0,0,0-.94,1.8,1.8,0,0,1,.27.93,5.33,5.33,0,0,1,0,1A6.73,6.73,0,0,1,809.36,350.43Z"
            fill="#396039"
          />
          <path
            d="M809.46,346.46c2.08-.6,1.19-3.18-1.49-2.78S809.46,346.46,809.46,346.46Z"
            fill="#a04d90"
          />
          <path
            d="M809.46,346.46s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S809.46,346.46,809.46,346.46Z"
            fill="#a04d90"
          />
          <path
            d="M809.76,346.46a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.78,2.08.49,2.08A3,3,0,0,1,809.76,346.46Z"
            fill="#a04d90"
          />
          <path
            d="M809.66,346.26s-2.38.69-.9,1.49S811.45,347.35,809.66,346.26Z"
            fill="#a04d90"
          />
          <path
            d="M812.57,346.82a.69.69,0,0,1-.73.53,3,3,0,0,1-2.08-.89A5.68,5.68,0,0,0,812.57,346.82Z"
            fill="#7f3374"
          />
          <path d="M811.35,346.06a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M809.26,344.37a1.41,1.41,0,0,1,.5,1.89" fill="#7f3374" />
          <path d="M807.57,344.27s2,.8,2.09,2" fill="#7f3374" />
          <path d="M809.46,346.46a2.6,2.6,0,0,0-2.09-.5" fill="#7f3374" />
          <path d="M809.36,346.62a8.55,8.55,0,0,0-3-.36" fill="#7f3374" />
          <path
            d="M806.17,346.62a7.65,7.65,0,0,0,3.09.1,3.8,3.8,0,0,1-1.29.53A1.66,1.66,0,0,1,806.17,346.62Z"
            fill="#7f3374"
          />
          <path
            d="M808.31,347.35a2.69,2.69,0,0,0,2.24.06c0,.55-.85.84-1.79.34A1,1,0,0,1,808.31,347.35Z"
            fill="#7f3374"
          />
          <path d="M809.66,346.66a.57.57,0,0,1,.2.69" fill="#7f3374" />
          <path d="M809.66,346.46s-.2.89-.8.89" fill="#7f3374" />
          <ellipse cx="809.61" cy="346.36" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M809.41,350.23s.6-.94-.6-1.74C808.81,348.49,808.43,350,809.41,350.23Z"
            fill="#396039"
          />
          <path
            d="M809.86,348.84s-.3-.3.89-.79C810.75,348.05,810.85,348.74,809.86,348.84Z"
            fill="#396039"
          />
          <path
            d="M808.81,348.49a6.4,6.4,0,0,1,.41.83,1.78,1.78,0,0,1,.14.91,1.32,1.32,0,0,0-.08-.44c0-.15-.1-.29-.15-.43C809,349.06,808.91,348.79,808.81,348.49Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M802.23,356.88c0-.65.17-1.27.24-1.9,0-.31.08-.62.1-.93a3,3,0,0,0,0-.94,1.9,1.9,0,0,1,.27.94,5.22,5.22,0,0,1,0,1A6.3,6.3,0,0,1,802.23,356.88Z"
            fill="#396039"
          />
          <path
            d="M802.33,352.91c2.08-.59,1.19-3.18-1.49-2.78S802.33,352.91,802.33,352.91Z"
            fill="#a04d90"
          />
          <path
            d="M802.33,352.91s-2-1.69-3.08-1.09.1,2.28,1.59,1.89S802.33,352.91,802.33,352.91Z"
            fill="#a04d90"
          />
          <path
            d="M802.62,352.91a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,802.62,352.91Z"
            fill="#a04d90"
          />
          <path
            d="M802.53,352.71s-2.39.7-.9,1.49S804.31,353.8,802.53,352.71Z"
            fill="#a04d90"
          />
          <path
            d="M805.43,353.27a.67.67,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.59,5.59,0,0,0,805.43,353.27Z"
            fill="#7f3374"
          />
          <path d="M804.21,352.51a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
          <path d="M802.13,350.83a1.39,1.39,0,0,1,.49,1.88" fill="#7f3374" />
          <path d="M800.44,350.73s2,.79,2.09,2" fill="#7f3374" />
          <path d="M802.33,352.91a2.66,2.66,0,0,0-2.09-.5" fill="#7f3374" />
          <path d="M802.23,353.08a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
          <path
            d="M799,353.08a8,8,0,0,0,3.1.09,3.74,3.74,0,0,1-1.29.54A1.71,1.71,0,0,1,799,353.08Z"
            fill="#7f3374"
          />
          <path
            d="M801.18,353.8a2.65,2.65,0,0,0,2.24.06c0,.55-.85.84-1.79.34A.9.9,0,0,1,801.18,353.8Z"
            fill="#7f3374"
          />
          <path d="M802.53,353.11a.58.58,0,0,1,.19.69" fill="#7f3374" />
          <path d="M802.53,352.91s-.2.89-.8.89" fill="#7f3374" />
          <ellipse cx="802.48" cy="352.81" rx="0.55" ry="0.3" fill="#b7b720" />
          <path
            d="M802.28,356.68s.59-.94-.6-1.73C801.68,355,801.29,356.42,802.28,356.68Z"
            fill="#396039"
          />
          <path
            d="M802.72,355.29s-.29-.29.9-.79C803.62,354.5,803.72,355.19,802.72,355.29Z"
            fill="#396039"
          />
          <path
            d="M801.68,355a5.82,5.82,0,0,1,.41.83,2,2,0,0,1,.14.9,2.14,2.14,0,0,0-.08-.44c0-.15-.1-.29-.16-.43C801.9,355.52,801.77,355.24,801.68,355Z"
            fill="#204220"
          />
        </g>
        <path
          d="M896.4,386.07h0c3.67,10,1.64,15.48-5.5,15.48s-28.87,4.75-39.06-1.7-50.63-19-53-43.81c-2.08,24.27,35.3,43.29,48.22,49.75,14,7,53,2.34,56.91-7C905.93,394.08,903.77,389.78,896.4,386.07Z"
          fill="#35280f"
        />
        <g>
          <path
            d="M846.5,401.38a10.41,10.41,0,0,1-.62-1.66,12.34,12.34,0,0,1-.36-1.73,8.12,8.12,0,0,1-.07-1.78,3.28,3.28,0,0,1,.5-1.7,5.47,5.47,0,0,0-.08,1.71c0,.56.1,1.13.19,1.7C846.2,399.06,846.39,400.2,846.5,401.38Z"
            fill="#396039"
          />
          <path
            d="M846.32,394.14c-3.8-1.08-2.17-5.78,2.71-5.06S846.32,394.14,846.32,394.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M846.32,394.14s3.61-3.07,5.6-2-.18,4.16-2.89,3.44S846.32,394.14,846.32,394.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M845.77,394.14a3.18,3.18,0,0,0-2.89-2.17c-2.35-.18-3.25,3.8-.9,3.8A5.4,5.4,0,0,0,845.77,394.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M846,393.78s4.34,1.27,1.63,2.71S842.7,395.77,846,393.78Z"
            fill="#4d4d9e"
          />
          <path
            d="M840.66,394.8a1.24,1.24,0,0,0,1.32,1,5.4,5.4,0,0,0,3.79-1.63C844.69,394.61,841.9,395.2,840.66,394.8Z"
            fill="#36367a"
          />
          <path d="M842.88,393.42a3,3,0,0,1,2.89.72" fill="#36367a" />
          <path d="M846.68,390.35s-2.17,1.44-.91,3.43" fill="#36367a" />
          <path d="M849.75,390.17s-3.62,1.44-3.8,3.61" fill="#36367a" />
          <path d="M846.32,394.14a4.74,4.74,0,0,1,3.79-.9" fill="#36367a" />
          <path d="M846.49,394.45s3.44-1,5.43-.67" fill="#36367a" />
          <path
            d="M852.31,394.45s-3.66.81-5.63.16a6.56,6.56,0,0,0,2.35,1A3.06,3.06,0,0,0,852.31,394.45Z"
            fill="#36367a"
          />
          <path
            d="M848.41,395.77a4.93,4.93,0,0,1-4.09.11c.06,1,1.55,1.52,3.26.61A1.74,1.74,0,0,0,848.41,395.77Z"
            fill="#36367a"
          />
          <path d="M846,394.51a1.06,1.06,0,0,0-.36,1.26" fill="#36367a" />
          <path d="M846,394.14s.37,1.63,1.45,1.63" fill="#36367a" />
          <ellipse cx="846.04" cy="393.96" rx="0.99" ry="0.54" fill="#b7b720" />
          <path
            d="M846.4,401s-1.08-1.7,1.09-3.15C847.49,397.85,848.19,400.54,846.4,401Z"
            fill="#396039"
          />
          <path
            d="M845.59,398.48s.54-.54-1.63-1.44C844,397,843.78,398.3,845.59,398.48Z"
            fill="#396039"
          />
          <path
            d="M847.49,397.85c-.17.54-.4,1-.57,1.57-.1.26-.2.52-.28.78a2.51,2.51,0,0,0-.14.81,1.6,1.6,0,0,1,0-.84c.07-.27.15-.54.23-.81A10.56,10.56,0,0,1,847.49,397.85Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M834.61,394.92a10,10,0,0,1-.62-1.65,14.76,14.76,0,0,1-.36-1.73,9.61,9.61,0,0,1-.07-1.78,3.32,3.32,0,0,1,.51-1.71,5.49,5.49,0,0,0-.09,1.71c0,.57.1,1.14.19,1.71C834.31,392.61,834.51,393.74,834.61,394.92Z"
            fill="#396039"
          />
          <path
            d="M834.43,387.69c-3.8-1.08-2.17-5.79,2.71-5.06S834.43,387.69,834.43,387.69Z"
            fill="#4d4d9e"
          />
          <path
            d="M834.43,387.69s3.61-3.07,5.6-2-.18,4.16-2.89,3.44S834.43,387.69,834.43,387.69Z"
            fill="#4d4d9e"
          />
          <path
            d="M833.89,387.69a3.2,3.2,0,0,0-2.9-2.17c-2.35-.18-3.25,3.8-.9,3.8A5.44,5.44,0,0,0,833.89,387.69Z"
            fill="#4d4d9e"
          />
          <path
            d="M834.07,387.33s4.34,1.26,1.62,2.71S830.81,389.32,834.07,387.33Z"
            fill="#4d4d9e"
          />
          <path
            d="M828.77,388.35a1.25,1.25,0,0,0,1.32,1,5.44,5.44,0,0,0,3.8-1.63C832.81,388.15,830,388.75,828.77,388.35Z"
            fill="#36367a"
          />
          <path d="M831,387a3,3,0,0,1,2.9.72" fill="#36367a" />
          <path d="M834.79,383.89s-2.17,1.45-.9,3.44" fill="#36367a" />
          <path d="M837.86,383.71s-3.61,1.45-3.79,3.62" fill="#36367a" />
          <path d="M834.43,387.69a4.72,4.72,0,0,1,3.79-.9" fill="#36367a" />
          <path d="M834.6,388s3.44-1,5.43-.66" fill="#36367a" />
          <path
            d="M840.42,388s-3.65.82-5.63.17a6.85,6.85,0,0,0,2.35,1A3.06,3.06,0,0,0,840.42,388Z"
            fill="#36367a"
          />
          <path
            d="M836.52,389.32a4.85,4.85,0,0,1-4.08.1c.06,1,1.55,1.53,3.25.62A1.75,1.75,0,0,0,836.52,389.32Z"
            fill="#36367a"
          />
          <path d="M834.07,388.05a1.07,1.07,0,0,0-.37,1.27" fill="#36367a" />
          <path d="M834.07,387.69s.36,1.63,1.44,1.63" fill="#36367a" />
          <ellipse cx="834.16" cy="387.51" rx="0.99" ry="0.54" fill="#b7b720" />
          <path
            d="M834.51,394.55s-1.08-1.71,1.09-3.15C835.6,391.4,836.31,394.09,834.51,394.55Z"
            fill="#396039"
          />
          <path
            d="M833.7,392s.55-.54-1.62-1.45C832.08,390.58,831.9,391.85,833.7,392Z"
            fill="#396039"
          />
          <path
            d="M835.6,391.4c-.16.53-.4,1-.56,1.57a8.21,8.21,0,0,0-.29.78,3.2,3.2,0,0,0-.14.81,1.6,1.6,0,0,1,0-.84,6.89,6.89,0,0,1,.23-.81A9.14,9.14,0,0,1,835.6,391.4Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M812.4,338.54a9,9,0,0,1-.73-2.53,8.41,8.41,0,0,1,0-1.33,2.44,2.44,0,0,1,.37-1.27,4.24,4.24,0,0,0-.06,1.28c0,.42.07.85.14,1.27C812.16,336.81,812.33,337.66,812.4,338.54Z"
            fill="#396039"
          />
          <path
            d="M812.26,333.14c-2.83-.81-1.62-4.33,2-3.79S812.26,333.14,812.26,333.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M812.26,333.14s2.71-2.3,4.19-1.49-.13,3.11-2.16,2.57S812.26,333.14,812.26,333.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M811.86,333.14a2.38,2.38,0,0,0-2.16-1.62c-1.76-.14-2.43,2.83-.68,2.83A4.07,4.07,0,0,0,811.86,333.14Z"
            fill="#4d4d9e"
          />
          <path
            d="M812,332.87s3.25.94,1.22,2S809.56,334.35,812,332.87Z"
            fill="#4d4d9e"
          />
          <path
            d="M808,333.63a.93.93,0,0,0,1,.72,4.07,4.07,0,0,0,2.84-1.21A7.73,7.73,0,0,1,808,333.63Z"
            fill="#36367a"
          />
          <path d="M809.7,332.6a2.2,2.2,0,0,1,2.16.54" fill="#36367a" />
          <path d="M812.53,330.3a1.9,1.9,0,0,0-.67,2.57" fill="#36367a" />
          <path d="M814.83,330.17s-2.7,1.08-2.84,2.7" fill="#36367a" />
          <path d="M812.26,333.14a3.58,3.58,0,0,1,2.84-.68" fill="#36367a" />
          <path d="M812.4,333.36a11.67,11.67,0,0,1,4.05-.49" fill="#36367a" />
          <path
            d="M816.74,333.36a10.42,10.42,0,0,1-4.2.13,5.06,5.06,0,0,0,1.75.73A2.27,2.27,0,0,0,816.74,333.36Z"
            fill="#36367a"
          />
          <path
            d="M813.83,334.35a3.67,3.67,0,0,1-3.05.08c0,.75,1.16,1.14,2.43.46A1.26,1.26,0,0,0,813.83,334.35Z"
            fill="#36367a"
          />
          <path d="M812,333.41a.78.78,0,0,0-.27.94" fill="#36367a" />
          <path d="M812,333.14s.27,1.21,1.09,1.21" fill="#36367a" />
          <ellipse cx="812.06" cy="333" rx="0.74" ry="0.41" fill="#b7b720" />
          <path
            d="M812.33,338.26s-.81-1.27.81-2.35C813.14,335.91,813.67,337.92,812.33,338.26Z"
            fill="#396039"
          />
          <path
            d="M811.72,336.38s.41-.41-1.21-1.08C810.51,335.3,810.37,336.24,811.72,336.38Z"
            fill="#396039"
          />
          <path
            d="M813.14,335.91c-.12.4-.3.77-.42,1.17a5.89,5.89,0,0,0-.21.59,2,2,0,0,0-.11.6,2.59,2.59,0,0,1,.19-1.23A7.38,7.38,0,0,1,813.14,335.91Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M823.27,348.39a9,9,0,0,1-.73-2.53,7.37,7.37,0,0,1,0-1.33,2.44,2.44,0,0,1,.37-1.27,4.24,4.24,0,0,0-.06,1.28c0,.42.07.85.14,1.27C823,346.66,823.2,347.51,823.27,348.39Z"
            fill="#396039"
          />
          <path
            d="M823.13,343c-2.83-.81-1.62-4.33,2-3.79S823.13,343,823.13,343Z"
            fill="#4d4d9e"
          />
          <path
            d="M823.13,343s2.71-2.3,4.19-1.49-.13,3.11-2.16,2.57S823.13,343,823.13,343Z"
            fill="#4d4d9e"
          />
          <path
            d="M822.73,343a2.38,2.38,0,0,0-2.16-1.62c-1.76-.14-2.44,2.83-.68,2.83A4.07,4.07,0,0,0,822.73,343Z"
            fill="#4d4d9e"
          />
          <path
            d="M822.86,342.72s3.25.94,1.22,2S820.43,344.2,822.86,342.72Z"
            fill="#4d4d9e"
          />
          <path
            d="M818.91,343.48a.92.92,0,0,0,1,.72,4.07,4.07,0,0,0,2.84-1.21A7.73,7.73,0,0,1,818.91,343.48Z"
            fill="#36367a"
          />
          <path d="M820.57,342.45a2.2,2.2,0,0,1,2.16.54" fill="#36367a" />
          <path d="M823.4,340.15a1.9,1.9,0,0,0-.67,2.57" fill="#36367a" />
          <path d="M825.7,340s-2.7,1.09-2.84,2.71" fill="#36367a" />
          <path d="M823.13,343a3.57,3.57,0,0,1,2.84-.68" fill="#36367a" />
          <path d="M823.27,343.21a11.67,11.67,0,0,1,4.05-.49" fill="#36367a" />
          <path
            d="M827.61,343.21a10.46,10.46,0,0,1-4.21.13,5.25,5.25,0,0,0,1.76.73A2.27,2.27,0,0,0,827.61,343.21Z"
            fill="#36367a"
          />
          <path
            d="M824.7,344.2a3.69,3.69,0,0,1-3.06.08c.05.75,1.16,1.14,2.44.46A1.26,1.26,0,0,0,824.7,344.2Z"
            fill="#36367a"
          />
          <path d="M822.86,343.26a.78.78,0,0,0-.27.94" fill="#36367a" />
          <path d="M822.86,343s.27,1.21,1.08,1.21" fill="#36367a" />
          <ellipse cx="822.93" cy="342.85" rx="0.74" ry="0.41" fill="#b7b720" />
          <path
            d="M823.19,348.11s-.8-1.27.82-2.35C824,345.76,824.54,347.77,823.19,348.11Z"
            fill="#396039"
          />
          <path
            d="M822.59,346.23s.41-.41-1.21-1.08C821.38,345.15,821.24,346.09,822.59,346.23Z"
            fill="#396039"
          />
          <path
            d="M824,345.76c-.12.4-.3.77-.42,1.17a5.89,5.89,0,0,0-.21.59,2,2,0,0,0-.11.6,2.47,2.47,0,0,1,.19-1.23A7.38,7.38,0,0,1,824,345.76Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M808.32,370.13a9.29,9.29,0,0,1-.73-2.53,8.41,8.41,0,0,1-.05-1.33,2.52,2.52,0,0,1,.38-1.28,4.26,4.26,0,0,0-.07,1.28c0,.43.07.85.14,1.28C808.09,368.4,808.26,369.25,808.32,370.13Z"
            fill="#396039"
          />
          <path
            d="M808.19,364.72c-2.84-.81-1.62-4.32,2-3.78S808.19,364.72,808.19,364.72Z"
            fill="#4d4d9e"
          />
          <path
            d="M808.19,364.72s2.7-2.29,4.19-1.48-.14,3.11-2.16,2.57S808.19,364.72,808.19,364.72Z"
            fill="#4d4d9e"
          />
          <path
            d="M807.78,364.72a2.38,2.38,0,0,0-2.16-1.62c-1.75-.13-2.43,2.84-.67,2.84A4,4,0,0,0,807.78,364.72Z"
            fill="#4d4d9e"
          />
          <path
            d="M807.92,364.45s3.24.95,1.21,2S805.49,365.94,807.92,364.45Z"
            fill="#4d4d9e"
          />
          <path
            d="M804,365.22a.94.94,0,0,0,1,.72,4,4,0,0,0,2.83-1.22A7.72,7.72,0,0,1,804,365.22Z"
            fill="#36367a"
          />
          <path d="M805.62,364.18a2.23,2.23,0,0,1,2.16.54" fill="#36367a" />
          <path d="M808.46,361.89s-1.62,1.08-.68,2.56" fill="#36367a" />
          <path d="M810.76,361.75s-2.71,1.08-2.84,2.7" fill="#36367a" />
          <path d="M808.19,364.72a3.54,3.54,0,0,1,2.84-.67" fill="#36367a" />
          <path d="M808.32,365a11.62,11.62,0,0,1,4.06-.5" fill="#36367a" />
          <path
            d="M812.67,365a10.46,10.46,0,0,1-4.21.13,5.15,5.15,0,0,0,1.76.73A2.29,2.29,0,0,0,812.67,365Z"
            fill="#36367a"
          />
          <path
            d="M809.76,365.94a3.69,3.69,0,0,1-3.06.08c0,.75,1.16,1.14,2.43.46A1.35,1.35,0,0,0,809.76,365.94Z"
            fill="#36367a"
          />
          <path d="M807.92,365a.8.8,0,0,0-.27.95" fill="#36367a" />
          <path d="M807.92,364.72s.27,1.22,1.08,1.22" fill="#36367a" />
          <ellipse cx="807.99" cy="364.59" rx="0.74" ry="0.41" fill="#b7b720" />
          <path
            d="M808.25,369.85s-.8-1.28.82-2.36C809.07,367.49,809.59,369.51,808.25,369.85Z"
            fill="#396039"
          />
          <path
            d="M807.65,368s.4-.41-1.22-1.08C806.43,366.89,806.3,367.83,807.65,368Z"
            fill="#396039"
          />
          <path
            d="M809.07,367.49c-.13.41-.3.78-.43,1.18-.07.19-.15.38-.21.58a2.52,2.52,0,0,0-.11.61,2.52,2.52,0,0,1,.2-1.24A8.41,8.41,0,0,1,809.07,367.49Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M875.46,394.92c.07-.88.24-1.72.33-2.58.07-.42.11-.85.14-1.27a4.24,4.24,0,0,0-.06-1.28,2.51,2.51,0,0,1,.37,1.28,8.28,8.28,0,0,1,0,1.32A8.86,8.86,0,0,1,875.46,394.92Z"
            fill="#396039"
          />
          <path
            d="M875.6,389.52c2.83-.81,1.62-4.32-2-3.78S875.6,389.52,875.6,389.52Z"
            fill="#4d4d9e"
          />
          <path
            d="M875.6,389.52s-2.71-2.3-4.19-1.49.13,3.11,2.16,2.57S875.6,389.52,875.6,389.52Z"
            fill="#4d4d9e"
          />
          <path
            d="M876,389.52a2.38,2.38,0,0,1,2.16-1.62c1.76-.14,2.43,2.83.68,2.83A4.07,4.07,0,0,1,876,389.52Z"
            fill="#4d4d9e"
          />
          <path
            d="M875.87,389.25s-3.25.94-1.22,2S878.3,390.73,875.87,389.25Z"
            fill="#4d4d9e"
          />
          <path
            d="M879.82,390a.92.92,0,0,1-1,.72,4.07,4.07,0,0,1-2.84-1.21A7.73,7.73,0,0,0,879.82,390Z"
            fill="#36367a"
          />
          <path d="M878.16,389a2.2,2.2,0,0,0-2.16.54" fill="#36367a" />
          <path d="M875.32,386.68s1.63,1.08.68,2.57" fill="#36367a" />
          <path d="M873,386.55s2.7,1.08,2.84,2.7" fill="#36367a" />
          <path d="M875.6,389.52a3.58,3.58,0,0,0-2.84-.68" fill="#36367a" />
          <path d="M875.46,389.75a11.59,11.59,0,0,0-4.05-.5" fill="#36367a" />
          <path
            d="M871.12,389.75a10.68,10.68,0,0,0,4.2.12,5.06,5.06,0,0,1-1.75.73A2.29,2.29,0,0,1,871.12,389.75Z"
            fill="#36367a"
          />
          <path
            d="M874,390.73a3.67,3.67,0,0,0,3.05.08c0,.76-1.16,1.14-2.43.46A1.26,1.26,0,0,1,874,390.73Z"
            fill="#36367a"
          />
          <path d="M875.87,389.79a.78.78,0,0,1,.27.94" fill="#36367a" />
          <path d="M875.87,389.52s-.27,1.21-1.09,1.21" fill="#36367a" />
          <ellipse cx="875.8" cy="389.38" rx="0.74" ry="0.41" fill="#b7b720" />
          <path
            d="M875.53,394.65s.81-1.28-.81-2.36C874.72,392.29,874.19,394.3,875.53,394.65Z"
            fill="#396039"
          />
          <path
            d="M876.14,392.76s-.41-.4,1.21-1.08C877.35,391.68,877.49,392.63,876.14,392.76Z"
            fill="#396039"
          />
          <path
            d="M874.72,392.29a7.38,7.38,0,0,1,.55,1.13,2.59,2.59,0,0,1,.19,1.23,2.05,2.05,0,0,0-.11-.6c-.06-.2-.13-.39-.21-.59C875,393.07,874.84,392.69,874.72,392.29Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M893.34,397.64c.11-1.24.31-2.45.46-3.65.09-.6.15-1.2.2-1.8a5.82,5.82,0,0,0-.09-1.81,3.5,3.5,0,0,1,.53,1.81,9.08,9.08,0,0,1-.07,1.88,14.35,14.35,0,0,1-.38,1.82A10.81,10.81,0,0,1,893.34,397.64Z"
            fill="#396039"
          />
          <path
            d="M893.53,390c4-1.14,2.29-6.11-2.87-5.35S893.53,390,893.53,390Z"
            fill="#4d4d9e"
          />
          <path
            d="M893.53,390s-3.82-3.25-5.92-2.1.19,4.39,3,3.63S893.53,390,893.53,390Z"
            fill="#4d4d9e"
          />
          <path
            d="M894.1,390a3.36,3.36,0,0,1,3.06-2.29c2.48-.19,3.44,4,1,4A5.74,5.74,0,0,1,894.1,390Z"
            fill="#4d4d9e"
          />
          <path
            d="M893.91,389.62s-4.58,1.34-1.72,2.86S897.35,391.72,893.91,389.62Z"
            fill="#4d4d9e"
          />
          <path
            d="M899.5,390.7a1.32,1.32,0,0,1-1.39,1,5.74,5.74,0,0,1-4-1.72C895.24,390.49,898.19,391.12,899.5,390.7Z"
            fill="#36367a"
          />
          <path d="M897.16,389.24a3.13,3.13,0,0,0-3.06.76" fill="#36367a" />
          <path d="M893.15,386s2.29,1.53,1,3.63" fill="#36367a" />
          <path d="M889.9,385.8s3.82,1.53,4,3.82" fill="#36367a" />
          <path d="M893.53,390a5,5,0,0,0-4-.95" fill="#36367a" />
          <path d="M893.34,390.32s-3.63-1.08-5.73-.7" fill="#36367a" />
          <path
            d="M887.2,390.32s3.86.86,5.95.18a7.39,7.39,0,0,1-2.49,1A3.21,3.21,0,0,1,887.2,390.32Z"
            fill="#36367a"
          />
          <path
            d="M891.31,391.72a5.16,5.16,0,0,0,4.32.11c-.06,1.06-1.64,1.61-3.44.65A2,2,0,0,1,891.31,391.72Z"
            fill="#36367a"
          />
          <path d="M893.91,390.38a1.13,1.13,0,0,1,.38,1.34" fill="#36367a" />
          <path d="M893.91,390s-.38,1.72-1.53,1.72" fill="#36367a" />
          <ellipse cx="893.82" cy="389.81" rx="1.05" ry="0.57" fill="#b7b720" />
          <path
            d="M893.44,397.25s1.14-1.81-1.15-3.33C892.29,393.92,891.54,396.76,893.44,397.25Z"
            fill="#396039"
          />
          <path
            d="M894.29,394.58s-.57-.57,1.72-1.52C896,393.06,896.2,394.39,894.29,394.58Z"
            fill="#396039"
          />
          <path
            d="M892.29,393.92a9.37,9.37,0,0,1,.78,1.59,7.78,7.78,0,0,1,.25.86,2.06,2.06,0,0,1,0,.89,3.11,3.11,0,0,0-.16-.86c-.09-.27-.19-.55-.29-.82C892.69,395,892.47,394.48,892.29,393.92Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M858,404.09c.1-1.17.29-2.31.44-3.45.08-.57.13-1.14.18-1.71a5.48,5.48,0,0,0-.08-1.71,3.31,3.31,0,0,1,.5,1.71,8.14,8.14,0,0,1-.07,1.78,11.56,11.56,0,0,1-.36,1.73A9.92,9.92,0,0,1,858,404.09Z"
            fill="#396039"
          />
          <path
            d="M858.19,396.86c3.79-1.08,2.17-5.79-2.71-5.06S858.19,396.86,858.19,396.86Z"
            fill="#a04d90"
          />
          <path
            d="M858.19,396.86s-3.62-3.07-5.61-2,.18,4.16,2.9,3.44S858.19,396.86,858.19,396.86Z"
            fill="#a04d90"
          />
          <path
            d="M858.73,396.86a3.18,3.18,0,0,1,2.89-2.17c2.35-.18,3.26,3.8.91,3.8A5.44,5.44,0,0,1,858.73,396.86Z"
            fill="#a04d90"
          />
          <path
            d="M858.55,396.5s-4.34,1.26-1.63,2.71S861.8,398.49,858.55,396.5Z"
            fill="#a04d90"
          />
          <path
            d="M863.84,397.52a1.25,1.25,0,0,1-1.31,1,5.44,5.44,0,0,1-3.8-1.63C859.81,397.32,862.6,397.92,863.84,397.52Z"
            fill="#7f3374"
          />
          <path d="M861.62,396.14a3,3,0,0,0-2.89.72" fill="#7f3374" />
          <path d="M857.83,393.06s2.17,1.45.9,3.44" fill="#7f3374" />
          <path d="M854.75,392.88s3.62,1.45,3.8,3.62" fill="#7f3374" />
          <path d="M858.19,396.86a4.73,4.73,0,0,0-3.8-.9" fill="#7f3374" />
          <path d="M858,397.16s-3.44-1-5.43-.66" fill="#7f3374" />
          <path
            d="M852.19,397.16s3.66.82,5.64.17a7,7,0,0,1-2.35,1A3.07,3.07,0,0,1,852.19,397.16Z"
            fill="#7f3374"
          />
          <path
            d="M856.09,398.49a4.87,4.87,0,0,0,4.09.1c-.06,1-1.55,1.53-3.26.62A1.85,1.85,0,0,1,856.09,398.49Z"
            fill="#7f3374"
          />
          <path d="M858.55,397.22a1.07,1.07,0,0,1,.36,1.27" fill="#7f3374" />
          <path d="M858.55,396.86s-.36,1.63-1.45,1.63" fill="#7f3374" />
          <ellipse cx="858.46" cy="396.68" rx="0.99" ry="0.54" fill="#b7b720" />
          <path
            d="M858.11,403.72s1.07-1.71-1.1-3.15C857,400.57,856.31,403.26,858.11,403.72Z"
            fill="#396039"
          />
          <path
            d="M858.91,401.2s-.54-.54,1.63-1.45C860.54,399.75,860.72,401,858.91,401.2Z"
            fill="#396039"
          />
          <path
            d="M857,400.57a10.06,10.06,0,0,1,.74,1.51,7.49,7.49,0,0,1,.23.81,1.71,1.71,0,0,1,0,.84,2.83,2.83,0,0,0-.15-.81c-.08-.26-.18-.52-.28-.78C857.42,401.61,857.18,401.1,857,400.57Z"
            fill="#204220"
          />
        </g>
        <path
          d="M814.65,345.67c3.43-2.86-6.79,21.4,16.31,30.91s31.24,15.29,35,13.93c0,0-9.51,2.71-27.17-8.49s-19.7-6.12-23.78-13.25S812.61,347.37,814.65,345.67Z"
          fill="#35280f"
        />
        <path
          d="M828.92,361.3c-1.36,3.39,2.72,7.47,6.45,8.83s11.55,7.47,12.91,8.83,6.45-1,8.49.68c0,0-9.85,3.06-12.91-.68s-14.26-6.45-16.3-9.17-3.4-10.19-2.38-14.61S830.28,357.9,828.92,361.3Z"
          fill="#35280f"
        />
        <path d="M856.77,405.11c1.36-1,1-1.36,3.06-1" fill="#493b1b" />
        <path d="M845.9,402.06c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
        <path d="M833,395.6c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
        <path d="M822.13,388.47c1.35-1.7,3.73-.68,3.73-.68" fill="#493b1b" />
        <path d="M815.67,382.7c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
        <path d="M809.9,377.26c1.36-1.7,3.73-.68,3.73-.68" fill="#493b1b" />
        <g>
          <path
            d="M824.73,380.32c.11-1.25.31-2.45.46-3.65.09-.6.15-1.2.2-1.8a5.53,5.53,0,0,0-.09-1.81,3.39,3.39,0,0,1,.53,1.81,9,9,0,0,1-.07,1.87,12.65,12.65,0,0,1-.38,1.83A10.81,10.81,0,0,1,824.73,380.32Z"
            fill="#396039"
          />
          <path
            d="M824.92,372.68c4-1.15,2.29-6.11-2.86-5.35S824.92,372.68,824.92,372.68Z"
            fill="#4d4d9e"
          />
          <path
            d="M824.92,372.68s-3.82-3.25-5.92-2.1.19,4.39,3.06,3.63S824.92,372.68,824.92,372.68Z"
            fill="#4d4d9e"
          />
          <path
            d="M825.49,372.68a3.37,3.37,0,0,1,3.06-2.29c2.48-.19,3.44,4,1,4A5.74,5.74,0,0,1,825.49,372.68Z"
            fill="#4d4d9e"
          />
          <path
            d="M825.3,372.3s-4.58,1.33-1.72,2.86S828.74,374.4,825.3,372.3Z"
            fill="#4d4d9e"
          />
          <path
            d="M830.9,373.38a1.33,1.33,0,0,1-1.4,1,5.74,5.74,0,0,1-4-1.72C826.63,373.17,829.58,373.79,830.9,373.38Z"
            fill="#36367a"
          />
          <path d="M828.55,371.92a3.13,3.13,0,0,0-3.06.76" fill="#36367a" />
          <path d="M824.54,368.67s2.29,1.53,1,3.63" fill="#36367a" />
          <path d="M821.29,368.48s3.82,1.53,4,3.82" fill="#36367a" />
          <path d="M824.92,372.68a5,5,0,0,0-4-1" fill="#36367a" />
          <path d="M824.73,373s-3.63-1.08-5.73-.7" fill="#36367a" />
          <path
            d="M818.59,373s3.86.86,5.95.18a7.4,7.4,0,0,1-2.48,1A3.25,3.25,0,0,1,818.59,373Z"
            fill="#36367a"
          />
          <path
            d="M822.71,374.4a5.23,5.23,0,0,0,4.31.11c-.06,1.06-1.63,1.61-3.44.65A1.87,1.87,0,0,1,822.71,374.4Z"
            fill="#36367a"
          />
          <path d="M825.3,373.06a1.11,1.11,0,0,1,.38,1.34" fill="#36367a" />
          <path d="M825.3,372.68s-.38,1.72-1.53,1.72" fill="#36367a" />
          <ellipse cx="825.21" cy="372.49" rx="1.05" ry="0.57" fill="#b7b720" />
          <path
            d="M824.84,379.93s1.13-1.81-1.16-3.34C823.68,376.59,822.94,379.44,824.84,379.93Z"
            fill="#396039"
          />
          <path
            d="M825.68,377.26s-.57-.57,1.72-1.53C827.4,375.73,827.59,377.07,825.68,377.26Z"
            fill="#396039"
          />
          <path
            d="M823.68,376.59a9.47,9.47,0,0,1,.78,1.6,7.78,7.78,0,0,1,.25.86,1.79,1.79,0,0,1,0,.89,2.79,2.79,0,0,0-.16-.86c-.09-.28-.19-.55-.29-.82C824.08,377.7,823.86,377.16,823.68,376.59Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M843,383c0-.59.15-1.15.21-1.71,0-.28.07-.57.1-.85a2.64,2.64,0,0,0,0-.84,2.62,2.62,0,0,1,.22,1.72A6.47,6.47,0,0,1,843,383Z"
            fill="#396039"
          />
          <path
            d="M843.08,379.46c1.87-.54,1.07-2.86-1.35-2.5S843.08,379.46,843.08,379.46Z"
            fill="#4d4d9e"
          />
          <path
            d="M843.08,379.46s-1.79-1.52-2.78-1,.09,2,1.43,1.69S843.08,379.46,843.08,379.46Z"
            fill="#4d4d9e"
          />
          <path
            d="M843.34,379.46a1.58,1.58,0,0,1,1.43-1.07c1.17-.09,1.61,1.87.45,1.87A2.71,2.71,0,0,1,843.34,379.46Z"
            fill="#4d4d9e"
          />
          <path
            d="M843.25,379.28s-2.14.63-.8,1.34S844.86,380.26,843.25,379.28Z"
            fill="#4d4d9e"
          />
          <path
            d="M845.87,379.79a.61.61,0,0,1-.65.47,2.71,2.71,0,0,1-1.88-.8A5.18,5.18,0,0,0,845.87,379.79Z"
            fill="#36367a"
          />
          <path d="M844.77,379.1a1.46,1.46,0,0,0-1.43.36" fill="#36367a" />
          <path d="M842.9,377.58a1.26,1.26,0,0,1,.44,1.7" fill="#36367a" />
          <path d="M841.38,377.49s1.78.72,1.87,1.79" fill="#36367a" />
          <path d="M843.08,379.46a2.35,2.35,0,0,0-1.88-.45" fill="#36367a" />
          <path d="M843,379.61a7.67,7.67,0,0,0-2.69-.33" fill="#36367a" />
          <path
            d="M840.11,379.61a7.06,7.06,0,0,0,2.79.08,3.33,3.33,0,0,1-1.17.48A1.5,1.5,0,0,1,840.11,379.61Z"
            fill="#36367a"
          />
          <path
            d="M842,380.26a2.44,2.44,0,0,0,2,.06c0,.49-.77.75-1.61.3A.83.83,0,0,1,842,380.26Z"
            fill="#36367a"
          />
          <path d="M843.25,379.64a.52.52,0,0,1,.18.62" fill="#36367a" />
          <path d="M843.25,379.46s-.17.8-.71.8" fill="#36367a" />
          <ellipse cx="843.21" cy="379.37" rx="0.49" ry="0.27" fill="#b7b720" />
          <path
            d="M843,382.85s.53-.84-.55-1.56C842.49,381.29,842.15,382.62,843,382.85Z"
            fill="#396039"
          />
          <path
            d="M843.43,381.6s-.27-.26.81-.71C844.24,380.89,844.33,381.52,843.43,381.6Z"
            fill="#396039"
          />
          <path
            d="M842.49,381.29a4.35,4.35,0,0,1,.37.75,1.77,1.77,0,0,1,.13.82,2.38,2.38,0,0,0-.22-.79C842.69,381.81,842.58,381.56,842.49,381.29Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M853.85,380c0-.59.16-1.14.22-1.71a8,8,0,0,0,.09-.84,2.44,2.44,0,0,0,0-.85,2.72,2.72,0,0,1,.22,1.73A6.16,6.16,0,0,1,853.85,380Z"
            fill="#396039"
          />
          <path
            d="M853.94,376.4c1.88-.53,1.08-2.86-1.34-2.5S853.94,376.4,853.94,376.4Z"
            fill="#4d4d9e"
          />
          <path
            d="M853.94,376.4s-1.78-1.52-2.77-1,.09,2.06,1.43,1.7S853.94,376.4,853.94,376.4Z"
            fill="#4d4d9e"
          />
          <path
            d="M854.21,376.4a1.58,1.58,0,0,1,1.43-1.07c1.16-.09,1.61,1.88.45,1.88A2.7,2.7,0,0,1,854.21,376.4Z"
            fill="#4d4d9e"
          />
          <path
            d="M854.12,376.22s-2.14.63-.8,1.34S855.73,377.21,854.12,376.22Z"
            fill="#4d4d9e"
          />
          <path
            d="M856.74,376.73a.62.62,0,0,1-.65.48,2.7,2.7,0,0,1-1.88-.81A5.16,5.16,0,0,0,856.74,376.73Z"
            fill="#36367a"
          />
          <path d="M855.64,376a1.49,1.49,0,0,0-1.43.36" fill="#36367a" />
          <path d="M853.76,374.53a1.25,1.25,0,0,1,.45,1.69" fill="#36367a" />
          <path d="M852.25,374.44s1.78.71,1.87,1.78" fill="#36367a" />
          <path d="M853.94,376.4a2.33,2.33,0,0,0-1.87-.44" fill="#36367a" />
          <path d="M853.86,376.55a7.67,7.67,0,0,0-2.69-.33" fill="#36367a" />
          <path
            d="M851,376.55a6.83,6.83,0,0,0,2.78.08,3.2,3.2,0,0,1-1.16.49A1.51,1.51,0,0,1,851,376.55Z"
            fill="#36367a"
          />
          <path
            d="M852.91,377.21a2.42,2.42,0,0,0,2,.05c0,.5-.77.75-1.61.3A.87.87,0,0,1,852.91,377.21Z"
            fill="#36367a"
          />
          <path d="M854.12,376.58a.53.53,0,0,1,.18.63" fill="#36367a" />
          <path d="M854.12,376.4s-.18.81-.71.81" fill="#36367a" />
          <ellipse cx="854.08" cy="376.31" rx="0.49" ry="0.27" fill="#b7b720" />
          <path
            d="M853.9,379.79s.54-.84-.54-1.55C853.36,378.24,853,379.57,853.9,379.79Z"
            fill="#396039"
          />
          <path
            d="M854.3,378.55s-.27-.27.81-.72C855.11,377.83,855.2,378.46,854.3,378.55Z"
            fill="#396039"
          />
          <path
            d="M853.36,378.24a4.26,4.26,0,0,1,.37.74,1.65,1.65,0,0,1,.12.82,2.26,2.26,0,0,0-.21-.79C853.56,378.75,853.45,378.5,853.36,378.24Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M817.51,381.34c0-.59.16-1.15.22-1.71a8,8,0,0,0,.09-.84,2.42,2.42,0,0,0,0-.85,2.69,2.69,0,0,1,.22,1.72A6.12,6.12,0,0,1,817.51,381.34Z"
            fill="#396039"
          />
          <path
            d="M817.6,377.76c1.88-.54,1.07-2.86-1.34-2.5S817.6,377.76,817.6,377.76Z"
            fill="#4d4d9e"
          />
          <path
            d="M817.6,377.76s-1.79-1.52-2.77-1,.09,2.05,1.43,1.7S817.6,377.76,817.6,377.76Z"
            fill="#4d4d9e"
          />
          <path
            d="M817.87,377.76a1.58,1.58,0,0,1,1.43-1.07c1.16-.09,1.61,1.88.45,1.88A2.7,2.7,0,0,1,817.87,377.76Z"
            fill="#4d4d9e"
          />
          <path
            d="M817.78,377.58s-2.15.63-.8,1.34S819.39,378.57,817.78,377.58Z"
            fill="#4d4d9e"
          />
          <path
            d="M820.4,378.09a.62.62,0,0,1-.65.48,2.7,2.7,0,0,1-1.88-.81A5.15,5.15,0,0,0,820.4,378.09Z"
            fill="#36367a"
          />
          <path d="M819.3,377.4a1.49,1.49,0,0,0-1.43.36" fill="#36367a" />
          <path d="M817.42,375.88s1.08.72.45,1.7" fill="#36367a" />
          <path d="M815.9,375.79s1.79.72,1.88,1.79" fill="#36367a" />
          <path d="M817.6,377.76a2.38,2.38,0,0,0-1.88-.45" fill="#36367a" />
          <path d="M817.51,377.91a7.64,7.64,0,0,0-2.68-.33" fill="#36367a" />
          <path
            d="M814.64,377.91a6.83,6.83,0,0,0,2.78.08,3.2,3.2,0,0,1-1.16.49A1.51,1.51,0,0,1,814.64,377.91Z"
            fill="#36367a"
          />
          <path
            d="M816.57,378.57a2.46,2.46,0,0,0,2,.05c0,.5-.77.75-1.61.3A.87.87,0,0,1,816.57,378.57Z"
            fill="#36367a"
          />
          <path d="M817.78,377.94a.53.53,0,0,1,.18.63" fill="#36367a" />
          <path d="M817.78,377.76s-.18.81-.71.81" fill="#36367a" />
          <ellipse cx="817.74" cy="377.67" rx="0.49" ry="0.27" fill="#b7b720" />
          <path
            d="M817.56,381.15s.53-.84-.54-1.56C817,379.59,816.67,380.93,817.56,381.15Z"
            fill="#396039"
          />
          <path
            d="M818,379.91s-.27-.27.8-.72C818.76,379.19,818.85,379.82,818,379.91Z"
            fill="#396039"
          />
          <path
            d="M817,379.59a5.72,5.72,0,0,1,.36.75,1.55,1.55,0,0,1,.13.82,2.44,2.44,0,0,0-.21-.79C817.22,380.11,817.1,379.86,817,379.59Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M865.58,376.42s-3.4,11.44.41,15.79"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.17"
          />
          <path
            d="M865.67,375.46c-3-1.48-6.14.64-5.93,2.44s3,4.55,3,4.55,1.27-1.8,2-3.18A12.28,12.28,0,0,0,865.67,375.46Z"
            fill="#ba8419"
          />
          <path
            d="M865.78,375.46s-2.4-1.27-1.94-1.7-.18.11.46-.42,3.92.64,3.71,1.59S865.78,375.46,865.78,375.46Z"
            fill="#ba8419"
          />
          <path
            d="M865.89,376a2.61,2.61,0,0,1,3,.74c1.17,1.49-.84,2.76-.84,2.76"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.11"
          />
          <path
            d="M863.88,373.72l.18.6a10.18,10.18,0,0,0,1.72,1.14s2,.42,2.23-.53a.53.53,0,0,0-.12-.42l-.36-.16a3.7,3.7,0,0,1-2.81-1l-.12-.12a.59.59,0,0,0-.3.12C863.68,373.85,864.26,373.37,863.88,373.72Z"
            fill="#a06f18"
          />
          <path
            d="M864.72,375.46s2.76,2.44,2,5.3c-.1.21,4.14-1.7,3.5-3.92S864.72,375.46,864.72,375.46Z"
            fill="#ba8419"
          />
          <path
            d="M862.7,375.24c-2.33-.31-2.75.43-4.23,1.49,0,0,3.07-6.46,7.2-1.27Z"
            fill="#ba8419"
          />
          <path
            d="M865.36,375.57l.22.85a5.15,5.15,0,0,1,1.15,4.34A3.69,3.69,0,0,0,865.36,375.57Z"
            fill="#a06f18"
          />
          <path
            d="M870.26,377.65s-1.25,2.15-3,.51l-.48,1a4,4,0,0,1-.08,1.64C866.64,380.94,869.88,379.5,870.26,377.65Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M862.7,375.24l2.43.18.36-.12a4.78,4.78,0,0,0-3.1-1c-1.8.11-3.92,2.44-3.92,2.44C860,375.67,860.37,374.93,862.7,375.24Z"
            fill="#a06f18"
          />
          <path
            d="M865.67,375.46c-3-1.48-6.14.64-5.93,2.44s3,4.55,3,4.55,1.27-1.8,2-3.18A12.28,12.28,0,0,0,865.67,375.46Z"
            fill="#ba8419"
          />
          <path d="M864.19,375.57a2.76,2.76,0,0,0-2.76,2.33" fill="#a06f18" />
          <path d="M864.72,376a2.79,2.79,0,0,0-1.91,2.76" fill="#a06f18" />
          <path
            d="M860,378.71a14.82,14.82,0,0,0,2.74,3.74s1.27-1.8,2-3.18a1.51,1.51,0,0,0,.11-.22C862.38,380.38,860.81,379.54,860,378.71Z"
            fill="#a06f18"
          />
          <path d="M866.31,375.78s1.7,0,2.23,1.16" fill="#a06f18" />
          <path
            d="M864.54,389.13s0-4.56,5.69-4.77"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.17"
          />
          <path
            d="M868.85,381.5s-2.28,1.27-1.3,3.39A3.71,3.71,0,0,0,868.85,381.5Z"
            fill="#396039"
          />
          <path
            d="M864.72,388a2.57,2.57,0,0,1,2.54-1.62S866.42,388.25,864.72,388Z"
            fill="#396039"
          />
          <path
            d="M869.22,384.45a3.42,3.42,0,0,1,4.19-2S871.7,385,869.22,384.45Z"
            fill="#396039"
          />
          <path
            d="M865.89,386s-1.28-.46-.53-2.26C865.36,383.73,866.52,384.87,865.89,386Z"
            fill="#396039"
          />
          <path
            d="M867.26,385a1.54,1.54,0,0,1,1.91.93A2.23,2.23,0,0,1,867.26,385Z"
            fill="#396039"
          />
          <path
            d="M864.19,386.75a9.6,9.6,0,0,0-3.5-3.87A4.68,4.68,0,0,0,864.19,386.75Z"
            fill="#396039"
          />
          <path
            d="M873.41,382.45l-.32-.08c-.66.66-2.21,2.08-3.48,2.14C871.88,384.7,873.41,382.45,873.41,382.45Z"
            fill="#204220"
          />
          <path
            d="M867.24,386.37h-.4a3.35,3.35,0,0,1-2,1.66,2.7,2.7,0,0,0,2.38-1.62Z"
            fill="#204220"
          />
          <g>
            <path d="M867.53,384.85l0,0,0,0Z" fill="#204220" />
            <path
              d="M867.56,384.83c.14-.1.27-.21.39-.31a3.93,3.93,0,0,0,.9-3l-.06,0C868.63,382.35,868.19,384.29,867.56,384.83Z"
              fill="#204220"
            />
          </g>
          <path
            d="M867.29,385h0l.05.09a2.26,2.26,0,0,0,1.85.84,1.87,1.87,0,0,0-.32-.5A2.83,2.83,0,0,1,867.29,385Z"
            fill="#204220"
          />
          <path
            d="M860.69,382.88a4.67,4.67,0,0,0,3.42,3.84l.06,0v0c-1.65-.47-2.61-2.43-3-3.51A5,5,0,0,0,860.69,382.88Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M847.13,373.16s-2.87,9.62.34,13.27"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M847.21,372.35c-2.5-1.25-5.17.53-5,2s2.5,3.83,2.5,3.83a31.16,31.16,0,0,0,1.69-2.67A10.31,10.31,0,0,0,847.21,372.35Z"
            fill="#ba8419"
          />
          <path
            d="M847.29,372.35s-2-1.07-1.63-1.43-.15.09.39-.35,3.29.53,3.12,1.33S847.29,372.35,847.29,372.35Z"
            fill="#ba8419"
          />
          <path
            d="M847.38,372.8a2.2,2.2,0,0,1,2.5.62c1,1.25-.71,2.32-.71,2.32"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.09"
          />
          <path
            d="M845.7,370.89l.15.5a8.36,8.36,0,0,0,1.44,1s1.7.36,1.88-.45a.49.49,0,0,0-.1-.35l-.3-.14a3.09,3.09,0,0,1-2.36-.84l-.11-.1a.52.52,0,0,0-.25.1C845.53,371,846,370.6,845.7,370.89Z"
            fill="#a06f18"
          />
          <path
            d="M846.4,372.35s2.32,2,1.7,4.46c-.09.17,3.47-1.43,2.94-3.3S846.4,372.35,846.4,372.35Z"
            fill="#ba8419"
          />
          <path
            d="M844.71,372.17c-2-.27-2.32.36-3.56,1.25,0,0,2.58-5.44,6.06-1.07Z"
            fill="#ba8419"
          />
          <path
            d="M846.94,372.44l.19.72a4.36,4.36,0,0,1,1,3.65A3.12,3.12,0,0,0,846.94,372.44Z"
            fill="#a06f18"
          />
          <path
            d="M851.06,374.19s-1,1.81-2.5.43l-.4.81a3.42,3.42,0,0,1-.06,1.38C848,377,850.75,375.75,851.06,374.19Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M844.71,372.17l2,.15.3-.1a4,4,0,0,0-2.61-.85c-1.51.09-3.29,2.05-3.29,2.05C842.39,372.53,842.75,371.9,844.71,372.17Z"
            fill="#a06f18"
          />
          <path
            d="M847.21,372.35c-2.5-1.25-5.17.53-5,2s2.5,3.83,2.5,3.83a31.16,31.16,0,0,0,1.69-2.67A10.31,10.31,0,0,0,847.21,372.35Z"
            fill="#ba8419"
          />
          <path d="M846,372.44a2.33,2.33,0,0,0-2.32,2" fill="#a06f18" />
          <path d="M846.4,372.8a2.33,2.33,0,0,0-1.6,2.31" fill="#a06f18" />
          <path
            d="M842.41,375.08a12.54,12.54,0,0,0,2.3,3.15,31.16,31.16,0,0,0,1.69-2.67,1.14,1.14,0,0,0,.1-.19C844.43,376.48,843.11,375.78,842.41,375.08Z"
            fill="#a06f18"
          />
          <path d="M847.74,372.62s1.43,0,1.87,1" fill="#a06f18" />
          <path
            d="M846.25,383.85s0-3.84,4.79-4"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M849.88,377.43s-1.92,1.07-1.1,2.85A3.13,3.13,0,0,0,849.88,377.43Z"
            fill="#396039"
          />
          <path
            d="M846.41,382.9a2.17,2.17,0,0,1,2.13-1.37S847.84,383.11,846.41,382.9Z"
            fill="#396039"
          />
          <path
            d="M850.19,379.91a2.87,2.87,0,0,1,3.52-1.68S852.27,380.34,850.19,379.91Z"
            fill="#396039"
          />
          <path
            d="M847.38,381.21s-1.07-.39-.44-1.91C846.94,379.3,847.92,380.26,847.38,381.21Z"
            fill="#396039"
          />
          <path
            d="M848.54,380.39a1.3,1.3,0,0,1,1.61.78A1.89,1.89,0,0,1,848.54,380.39Z"
            fill="#396039"
          />
          <path
            d="M846,381.84a8.11,8.11,0,0,0-2.94-3.25A3.94,3.94,0,0,0,846,381.84Z"
            fill="#396039"
          />
          <path
            d="M853.71,378.23l-.27-.07c-.55.56-1.85,1.75-2.93,1.8A4,4,0,0,0,853.71,378.23Z"
            fill="#204220"
          />
          <path
            d="M848.53,381.53a2.08,2.08,0,0,0-.35,0,2.83,2.83,0,0,1-1.65,1.39,2.26,2.26,0,0,0,2-1.36Z"
            fill="#204220"
          />
          <g>
            <path d="M848.77,380.25l0,0,0,0Z" fill="#204220" />
            <path
              d="M848.79,380.23c.12-.09.23-.17.33-.26a3.29,3.29,0,0,0,.76-2.54l-.06,0A6.48,6.48,0,0,1,848.79,380.23Z"
              fill="#204220"
            />
          </g>
          <path
            d="M848.56,380.38h0l0,.08a1.92,1.92,0,0,0,1.56.7,1.69,1.69,0,0,0-.27-.42A2.39,2.39,0,0,1,848.56,380.38Z"
            fill="#204220"
          />
          <path
            d="M843,378.59a3.92,3.92,0,0,0,2.87,3.23l.05,0h0c-1.39-.4-2.19-2.05-2.53-3Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M833.8,365s2.87,9.62-.34,13.27"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M833.73,364.2c2.49-1.25,5.17.53,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.18,10.18,0,0,1,833.73,364.2Z"
            fill="#ba8419"
          />
          <path
            d="M833.64,364.2s2-1.07,1.63-1.43.15.09-.39-.35-3.29.53-3.11,1.33S833.64,364.2,833.64,364.2Z"
            fill="#ba8419"
          />
          <path
            d="M833.55,364.64a2.21,2.21,0,0,0-2.5.63c-1,1.25.72,2.31.72,2.31"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.09"
          />
          <path
            d="M835.23,362.74l-.15.5a8.36,8.36,0,0,1-1.44,1s-1.7.35-1.87-.45a.44.44,0,0,1,.09-.35l.31-.14a3.1,3.1,0,0,0,2.36-.84l.1-.1a.48.48,0,0,1,.25.1C835.4,362.85,834.92,362.44,835.23,362.74Z"
            fill="#a06f18"
          />
          <path
            d="M834.53,364.2s-2.32,2.05-1.7,4.45c.09.18-3.47-1.42-2.94-3.29S834.53,364.2,834.53,364.2Z"
            fill="#ba8419"
          />
          <path
            d="M836.23,364c1.95-.27,2.31.36,3.56,1.25,0,0-2.59-5.44-6.06-1.07Z"
            fill="#ba8419"
          />
          <path
            d="M834,364.29l-.19.72a4.34,4.34,0,0,0-1,3.64A3.11,3.11,0,0,1,834,364.29Z"
            fill="#a06f18"
          />
          <path
            d="M829.87,366s1,1.81,2.5.43l.4.81a3.37,3.37,0,0,0,.06,1.37C832.91,368.81,830.19,367.6,829.87,366Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M836.23,364l-2.05.14-.3-.1a4,4,0,0,1,2.61-.84c1.51.09,3.3,2,3.3,2C838.54,364.38,838.18,363.75,836.23,364Z"
            fill="#a06f18"
          />
          <path
            d="M833.73,364.2c2.49-1.25,5.17.53,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.18,10.18,0,0,1,833.73,364.2Z"
            fill="#ba8419"
          />
          <path d="M835,364.29a2.32,2.32,0,0,1,2.32,2" fill="#a06f18" />
          <path d="M834.53,364.64a2.35,2.35,0,0,1,1.6,2.32" fill="#a06f18" />
          <path
            d="M838.53,366.93a12.74,12.74,0,0,1-2.31,3.15,31.16,31.16,0,0,1-1.69-2.67l-.09-.19C836.5,368.33,837.82,367.63,838.53,366.93Z"
            fill="#a06f18"
          />
          <path d="M833.19,364.47s-1.42,0-1.87,1" fill="#a06f18" />
          <path
            d="M834.68,375.7s0-3.84-4.79-4"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M831.05,369.28s1.92,1.07,1.1,2.85A3.13,3.13,0,0,1,831.05,369.28Z"
            fill="#396039"
          />
          <path
            d="M834.53,374.75a2.19,2.19,0,0,0-2.14-1.37S833.1,375,834.53,374.75Z"
            fill="#396039"
          />
          <path
            d="M830.75,371.76a2.88,2.88,0,0,0-3.53-1.68S828.66,372.19,830.75,371.76Z"
            fill="#396039"
          />
          <path
            d="M833.55,373.06s1.07-.39.44-1.91C834,371.15,833,372.11,833.55,373.06Z"
            fill="#396039"
          />
          <path
            d="M832.39,372.24a1.3,1.3,0,0,0-1.61.78A1.89,1.89,0,0,0,832.39,372.24Z"
            fill="#396039"
          />
          <path
            d="M835,373.69a8.13,8.13,0,0,1,2.94-3.25A3.92,3.92,0,0,1,835,373.69Z"
            fill="#396039"
          />
          <path
            d="M827.22,370.08l.27-.07c.55.56,1.86,1.75,2.93,1.8A4,4,0,0,1,827.22,370.08Z"
            fill="#204220"
          />
          <path
            d="M832.41,373.38a1.3,1.3,0,0,1,.34,0,2.83,2.83,0,0,0,1.65,1.39,2.26,2.26,0,0,1-2-1.36Z"
            fill="#204220"
          />
          <g>
            <path d="M832.16,372.1l0,0h0Z" fill="#204220" />
            <path
              d="M832.14,372.08l-.32-.26a3.26,3.26,0,0,1-.77-2.54l.06,0A6.48,6.48,0,0,0,832.14,372.08Z"
              fill="#204220"
            />
          </g>
          <path
            d="M832.37,372.23h0l0,.07a1.93,1.93,0,0,1-1.57.71,2,2,0,0,1,.27-.42A2.39,2.39,0,0,0,832.37,372.23Z"
            fill="#204220"
          />
          <path
            d="M837.91,370.44a3.92,3.92,0,0,1-2.87,3.23l0,0h0c1.39-.4,2.19-2.05,2.53-2.95Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M823.66,379.9s1.7,5.72-.2,7.89"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M823.62,379.42c1.48-.74,3.07.32,3,1.22s-1.48,2.27-1.48,2.27a18.54,18.54,0,0,1-1-1.59A6,6,0,0,1,823.62,379.42Z"
            fill="#ba8419"
          />
          <path
            d="M823.56,379.42s1.2-.64,1-.85.09.05-.22-.21-2,.32-1.86.79S823.56,379.42,823.56,379.42Z"
            fill="#ba8419"
          />
          <path
            d="M823.51,379.68a1.3,1.3,0,0,0-1.48.37c-.59.74.42,1.38.42,1.38"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.05"
          />
          <path
            d="M824.51,378.55l-.09.3a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.27a.25.25,0,0,1,.06-.21l.18-.08a1.82,1.82,0,0,0,1.4-.5l.06-.06a.34.34,0,0,1,.16.06C824.61,378.61,824.33,378.37,824.51,378.55Z"
            fill="#a06f18"
          />
          <path
            d="M824.09,379.42a3,3,0,0,0-1,2.65c0,.1-2.07-.85-1.75-2S824.09,379.42,824.09,379.42Z"
            fill="#ba8419"
          />
          <path
            d="M825.1,379.31c1.17-.16,1.38.21,2.12.74,0,0-1.54-3.23-3.6-.63Z"
            fill="#ba8419"
          />
          <path
            d="M823.78,379.47l-.12.43a2.57,2.57,0,0,0-.57,2.17A1.86,1.86,0,0,1,823.78,379.47Z"
            fill="#a06f18"
          />
          <path
            d="M821.32,380.51s.63,1.08,1.49.26l.24.48a1.92,1.92,0,0,0,0,.82C823.13,382.16,821.51,381.44,821.32,380.51Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M825.1,379.31l-1.21.09-.18-.06a2.38,2.38,0,0,1,1.55-.51,4,4,0,0,1,2,1.22C826.48,379.52,826.27,379.15,825.1,379.31Z"
            fill="#a06f18"
          />
          <path
            d="M823.62,379.42c1.48-.74,3.07.32,3,1.22s-1.48,2.27-1.48,2.27a18.54,18.54,0,0,1-1-1.59A6,6,0,0,1,823.62,379.42Z"
            fill="#ba8419"
          />
          <path d="M824.36,379.47a1.39,1.39,0,0,1,1.38,1.17" fill="#a06f18" />
          <path d="M824.09,379.68a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
          <path
            d="M826.47,381a7.31,7.31,0,0,1-1.37,1.87,18.54,18.54,0,0,1-1-1.59,1.17,1.17,0,0,1-.05-.11A1.88,1.88,0,0,0,826.47,381Z"
            fill="#a06f18"
          />
          <path d="M823.3,379.58s-.85,0-1.11.58" fill="#a06f18" />
          <path
            d="M824.18,386.25s0-2.28-2.84-2.38"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M822,382.44a1.35,1.35,0,0,1,.65,1.69A1.85,1.85,0,0,1,822,382.44Z"
            fill="#396039"
          />
          <path
            d="M824.09,385.69a1.29,1.29,0,0,0-1.27-.81S823.24,385.81,824.09,385.69Z"
            fill="#396039"
          />
          <path
            d="M821.84,383.91a1.71,1.71,0,0,0-2.09-1A2.25,2.25,0,0,0,821.84,383.91Z"
            fill="#396039"
          />
          <path
            d="M823.51,384.68s.64-.23.27-1.13C823.78,383.55,823.19,384.12,823.51,384.68Z"
            fill="#396039"
          />
          <path
            d="M822.82,384.2a.76.76,0,0,0-1,.46A1.09,1.09,0,0,0,822.82,384.2Z"
            fill="#396039"
          />
          <path
            d="M824.36,385.06a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,824.36,385.06Z"
            fill="#396039"
          />
          <path
            d="M819.75,382.91l.16,0a3.4,3.4,0,0,0,1.74,1.07A2.34,2.34,0,0,1,819.75,382.91Z"
            fill="#204220"
          />
          <path
            d="M822.83,384.87h.2a1.72,1.72,0,0,0,1,.83,1.36,1.36,0,0,1-1.19-.81Z"
            fill="#204220"
          />
          <g>
            <path d="M822.69,384.11h0Z" fill="#204220" />
            <path
              d="M822.67,384.1l-.19-.15a2,2,0,0,1-.45-1.51l0,0A4,4,0,0,0,822.67,384.1Z"
              fill="#204220"
            />
          </g>
          <path
            d="M822.81,384.19h0l0,0a1.13,1.13,0,0,1-.93.42.89.89,0,0,1,.16-.25A1.35,1.35,0,0,0,822.81,384.19Z"
            fill="#204220"
          />
          <path
            d="M826.11,383.13a2.35,2.35,0,0,1-1.71,1.92h0a2.78,2.78,0,0,0,1.51-1.76Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M876.31,398.58s1.7,5.72-.21,7.89"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M876.26,398.1c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.91-1-1.59A6.26,6.26,0,0,1,876.26,398.1Z"
            fill="#ba8419"
          />
          <path
            d="M876.21,398.1s1.2-.64,1-.85.09.05-.23-.21-2,.32-1.85.79S876.21,398.1,876.21,398.1Z"
            fill="#ba8419"
          />
          <path
            d="M876.16,398.36a1.32,1.32,0,0,0-1.49.37c-.58.75.43,1.38.43,1.38"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.05"
          />
          <path
            d="M877.16,397.23l-.09.3a5.3,5.3,0,0,1-.86.57s-1,.21-1.11-.27a.24.24,0,0,1,0-.21l.18-.08a1.85,1.85,0,0,0,1.41-.5l.06-.06a.34.34,0,0,1,.15.06C877.26,397.29,877,397.05,877.16,397.23Z"
            fill="#a06f18"
          />
          <path
            d="M876.74,398.1a3,3,0,0,0-1,2.65c0,.1-2.07-.85-1.75-2S876.74,398.1,876.74,398.1Z"
            fill="#ba8419"
          />
          <path
            d="M877.75,398c1.16-.16,1.37.21,2.11.74,0,0-1.53-3.23-3.6-.63Z"
            fill="#ba8419"
          />
          <path
            d="M876.42,398.15l-.11.43a2.58,2.58,0,0,0-.58,2.17A1.86,1.86,0,0,1,876.42,398.15Z"
            fill="#a06f18"
          />
          <path
            d="M874,399.19s.63,1.08,1.48.26l.24.48a2.09,2.09,0,0,0,0,.82C875.78,400.84,874.16,400.12,874,399.19Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M877.75,398l-1.22.09-.18-.06a2.38,2.38,0,0,1,1.55-.51,4,4,0,0,1,2,1.22C879.12,398.2,878.91,397.83,877.75,398Z"
            fill="#a06f18"
          />
          <path
            d="M876.26,398.1c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.91-1-1.59A6.26,6.26,0,0,1,876.26,398.1Z"
            fill="#ba8419"
          />
          <path d="M877,398.15a1.38,1.38,0,0,1,1.38,1.17" fill="#a06f18" />
          <path d="M876.74,398.36a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
          <path
            d="M879.11,399.72a7.43,7.43,0,0,1-1.37,1.88s-.63-.91-1-1.59l-.06-.12A1.88,1.88,0,0,0,879.11,399.72Z"
            fill="#a06f18"
          />
          <path d="M875.94,398.26s-.84,0-1.11.58" fill="#a06f18" />
          <path
            d="M876.83,404.93s0-2.27-2.85-2.38"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M874.67,401.12s1.14.64.65,1.69A1.88,1.88,0,0,1,874.67,401.12Z"
            fill="#396039"
          />
          <path
            d="M876.74,404.37a1.29,1.29,0,0,0-1.27-.81S875.89,404.49,876.74,404.37Z"
            fill="#396039"
          />
          <path
            d="M874.49,402.59a1.71,1.71,0,0,0-2.1-1A2.28,2.28,0,0,0,874.49,402.59Z"
            fill="#396039"
          />
          <path
            d="M876.16,403.36s.63-.23.26-1.13C876.42,402.23,875.84,402.8,876.16,403.36Z"
            fill="#396039"
          />
          <path
            d="M875.47,402.88a.78.78,0,0,0-1,.46A1.12,1.12,0,0,0,875.47,402.88Z"
            fill="#396039"
          />
          <path
            d="M877,403.74a4.8,4.8,0,0,1,1.75-1.93A2.32,2.32,0,0,1,877,403.74Z"
            fill="#396039"
          />
          <path
            d="M872.39,401.6l.16-.05a3.44,3.44,0,0,0,1.74,1.07A2.36,2.36,0,0,1,872.39,401.6Z"
            fill="#204220"
          />
          <path
            d="M875.48,403.56h.2a1.69,1.69,0,0,0,1,.83,1.34,1.34,0,0,1-1.19-.81Z"
            fill="#204220"
          />
          <g>
            <path d="M875.33,402.79h0Z" fill="#204220" />
            <path
              d="M875.32,402.78a1.57,1.57,0,0,1-.19-.15,2,2,0,0,1-.46-1.51l0,0A3.79,3.79,0,0,0,875.32,402.78Z"
              fill="#204220"
            />
          </g>
          <path
            d="M875.45,402.87h0l0,0a1.12,1.12,0,0,1-.93.42,1.2,1.2,0,0,1,.16-.25A1.33,1.33,0,0,0,875.45,402.87Z"
            fill="#204220"
          />
          <path
            d="M878.75,401.81a2.33,2.33,0,0,1-1.71,1.92h0c.82-.24,1.3-1.22,1.51-1.75A1.07,1.07,0,0,1,878.75,401.81Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M888.53,396.88s1.71,5.72-.2,7.89"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M888.49,396.4c1.48-.74,3.07.32,3,1.22A6,6,0,0,1,890,399.9s-.63-.9-1-1.59A6,6,0,0,1,888.49,396.4Z"
            fill="#ba8419"
          />
          <path
            d="M888.44,396.4s1.2-.64,1-.85.09.05-.23-.21-2,.32-1.86.79S888.44,396.4,888.44,396.4Z"
            fill="#ba8419"
          />
          <path
            d="M888.38,396.66a1.3,1.3,0,0,0-1.48.38c-.58.74.42,1.37.42,1.37"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.05"
          />
          <path
            d="M889.39,395.53l-.09.3a5.3,5.3,0,0,1-.86.57s-1,.21-1.12-.27a.3.3,0,0,1,.06-.21l.18-.08a1.82,1.82,0,0,0,1.4-.5l.07-.06a.34.34,0,0,1,.15.06C889.48,395.6,889.2,395.36,889.39,395.53Z"
            fill="#a06f18"
          />
          <path
            d="M889,396.4a3,3,0,0,0-1,2.65c0,.11-2.07-.85-1.75-2S889,396.4,889,396.4Z"
            fill="#ba8419"
          />
          <path
            d="M890,396.29c1.17-.16,1.38.22,2.12.75,0,0-1.53-3.24-3.6-.64Z"
            fill="#ba8419"
          />
          <path
            d="M888.65,396.45l-.12.43a2.62,2.62,0,0,0-.57,2.17A1.86,1.86,0,0,1,888.65,396.45Z"
            fill="#a06f18"
          />
          <path
            d="M886.19,397.49s.63,1.08,1.49.26l.24.48a1.92,1.92,0,0,0,0,.82C888,399.14,886.38,398.42,886.19,397.49Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M890,396.29l-1.21.09-.18-.06a2.34,2.34,0,0,1,1.55-.5c.9.05,2,1.22,2,1.22C891.35,396.51,891.14,396.13,890,396.29Z"
            fill="#a06f18"
          />
          <path
            d="M888.49,396.4c1.48-.74,3.07.32,3,1.22A6,6,0,0,1,890,399.9s-.63-.9-1-1.59A6,6,0,0,1,888.49,396.4Z"
            fill="#ba8419"
          />
          <path d="M889.23,396.45a1.39,1.39,0,0,1,1.38,1.17" fill="#a06f18" />
          <path d="M889,396.66a1.4,1.4,0,0,1,.95,1.38" fill="#a06f18" />
          <path
            d="M891.34,398A7.43,7.43,0,0,1,890,399.9s-.63-.9-1-1.59l-.06-.11A1.89,1.89,0,0,0,891.34,398Z"
            fill="#a06f18"
          />
          <path d="M888.17,396.56s-.85,0-1.11.58" fill="#a06f18" />
          <path
            d="M889.06,403.24s0-2.28-2.85-2.39"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M886.9,399.42a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,886.9,399.42Z"
            fill="#396039"
          />
          <path
            d="M889,402.67a1.29,1.29,0,0,0-1.27-.81S888.11,402.79,889,402.67Z"
            fill="#396039"
          />
          <path
            d="M886.72,400.9a1.72,1.72,0,0,0-2.1-1A2.3,2.3,0,0,0,886.72,400.9Z"
            fill="#396039"
          />
          <path
            d="M888.38,401.67s.64-.24.27-1.14C888.65,400.53,888.06,401.1,888.38,401.67Z"
            fill="#396039"
          />
          <path
            d="M887.69,401.18a.77.77,0,0,0-1,.47A1.11,1.11,0,0,0,887.69,401.18Z"
            fill="#396039"
          />
          <path
            d="M889.23,402a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,889.23,402Z"
            fill="#396039"
          />
          <path
            d="M884.62,399.9l.16,0a3.28,3.28,0,0,0,1.74,1.07A2.36,2.36,0,0,1,884.62,399.9Z"
            fill="#204220"
          />
          <path
            d="M887.7,401.86h.21a1.66,1.66,0,0,0,1,.83,1.34,1.34,0,0,1-1.19-.81Z"
            fill="#204220"
          />
          <g>
            <path d="M887.56,401.09h0Z" fill="#204220" />
            <path
              d="M887.54,401.08l-.19-.15a2,2,0,0,1-.45-1.51l0,0A3.91,3.91,0,0,0,887.54,401.08Z"
              fill="#204220"
            />
          </g>
          <path
            d="M887.68,401.18h0l0,0a1.14,1.14,0,0,1-.93.43.83.83,0,0,1,.16-.25A1.49,1.49,0,0,0,887.68,401.18Z"
            fill="#204220"
          />
          <path
            d="M891,400.11a2.34,2.34,0,0,1-1.71,1.92h0a2.74,2.74,0,0,0,1.51-1.75Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M831.47,345.59s1.71,5.72-.2,7.9"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M831.43,345.11c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6.12,6.12,0,0,1,831.43,345.11Z"
            fill="#ba8419"
          />
          <path
            d="M831.37,345.11s1.21-.63,1-.85.08.06-.23-.21-2,.32-1.86.8S831.37,345.11,831.37,345.11Z"
            fill="#ba8419"
          />
          <path
            d="M831.32,345.38a1.3,1.3,0,0,0-1.48.37c-.58.74.42,1.38.42,1.38"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.05"
          />
          <path
            d="M832.32,344.25l-.09.29a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.26a.29.29,0,0,1,.06-.21l.18-.08a1.85,1.85,0,0,0,1.4-.51L832,344a.33.33,0,0,1,.15.05C832.42,344.31,832.14,344.07,832.32,344.25Z"
            fill="#a06f18"
          />
          <path
            d="M831.9,345.11a3,3,0,0,0-1,2.65c.05.11-2.07-.85-1.75-2S831.9,345.11,831.9,345.11Z"
            fill="#ba8419"
          />
          <path
            d="M832.91,345c1.17-.15,1.38.22,2.12.75,0,0-1.54-3.23-3.6-.64Z"
            fill="#ba8419"
          />
          <path
            d="M831.59,345.17l-.12.42a2.62,2.62,0,0,0-.57,2.17A1.84,1.84,0,0,1,831.59,345.17Z"
            fill="#a06f18"
          />
          <path
            d="M829.13,346.21s.63,1.08,1.49.25l.24.48a1.91,1.91,0,0,0,0,.82C830.94,347.86,829.32,347.13,829.13,346.21Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M832.91,345l-1.21.09-.18-.06a2.4,2.4,0,0,1,1.55-.5c.9.05,2,1.22,2,1.22C834.29,345.22,834.08,344.85,832.91,345Z"
            fill="#a06f18"
          />
          <path
            d="M831.43,345.11c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6.12,6.12,0,0,1,831.43,345.11Z"
            fill="#ba8419"
          />
          <path d="M832.17,345.17a1.38,1.38,0,0,1,1.38,1.16" fill="#a06f18" />
          <path d="M831.9,345.38a1.39,1.39,0,0,1,1,1.38" fill="#a06f18" />
          <path
            d="M834.28,346.74a7.51,7.51,0,0,1-1.37,1.87s-.63-.9-1-1.59l0-.11A1.9,1.9,0,0,0,834.28,346.74Z"
            fill="#a06f18"
          />
          <path d="M831.11,345.27s-.85,0-1.11.58" fill="#a06f18" />
          <path
            d="M832,352s0-2.28-2.85-2.39"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M829.84,348.13a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,829.84,348.13Z"
            fill="#396039"
          />
          <path
            d="M831.9,351.38a1.3,1.3,0,0,0-1.27-.81S831.05,351.51,831.9,351.38Z"
            fill="#396039"
          />
          <path
            d="M829.66,349.61a1.72,1.72,0,0,0-2.1-1A2.28,2.28,0,0,0,829.66,349.61Z"
            fill="#396039"
          />
          <path
            d="M831.32,350.38s.64-.23.27-1.13C831.59,349.25,831,349.82,831.32,350.38Z"
            fill="#396039"
          />
          <path
            d="M830.63,349.89a.77.77,0,0,0-1,.47A1.11,1.11,0,0,0,830.63,349.89Z"
            fill="#396039"
          />
          <path
            d="M832.17,350.76a4.8,4.8,0,0,1,1.75-1.94A2.36,2.36,0,0,1,832.17,350.76Z"
            fill="#396039"
          />
          <path
            d="M827.56,348.61l.16,0a3.4,3.4,0,0,0,1.74,1.07A2.39,2.39,0,0,1,827.56,348.61Z"
            fill="#204220"
          />
          <path
            d="M830.64,350.57h.21a1.65,1.65,0,0,0,1,.82,1.34,1.34,0,0,1-1.19-.81Z"
            fill="#204220"
          />
          <g>
            <path d="M830.5,349.81h0Z" fill="#204220" />
            <path
              d="M830.48,349.8l-.19-.16a2,2,0,0,1-.45-1.51l0,0A4,4,0,0,0,830.48,349.8Z"
              fill="#204220"
            />
          </g>
          <path
            d="M830.62,349.89h0l0,.05a1.15,1.15,0,0,1-.93.42,1.2,1.2,0,0,1,.16-.25A1.51,1.51,0,0,0,830.62,349.89Z"
            fill="#204220"
          />
          <path
            d="M833.92,348.82a2.34,2.34,0,0,1-1.71,1.92h0a2.78,2.78,0,0,0,1.51-1.76Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M811.43,368.69s1.71,5.72-.2,7.89"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M811.39,368.21c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6,6,0,0,1,811.39,368.21Z"
            fill="#ba8419"
          />
          <path
            d="M811.34,368.21s1.2-.64,1-.85.09.05-.23-.21-2,.32-1.86.79S811.34,368.21,811.34,368.21Z"
            fill="#ba8419"
          />
          <path
            d="M811.28,368.47a1.3,1.3,0,0,0-1.48.37c-.58.75.42,1.38.42,1.38"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.05"
          />
          <path
            d="M812.29,367.34l-.09.3a5.3,5.3,0,0,1-.86.57s-1,.21-1.12-.27a.29.29,0,0,1,.06-.21l.18-.08a1.82,1.82,0,0,0,1.4-.5l.07-.06a.34.34,0,0,1,.15.06C812.39,367.4,812.1,367.17,812.29,367.34Z"
            fill="#a06f18"
          />
          <path
            d="M811.87,368.21a3,3,0,0,0-1,2.65c0,.1-2.07-.85-1.75-2S811.87,368.21,811.87,368.21Z"
            fill="#ba8419"
          />
          <path
            d="M812.88,368.1c1.16-.16,1.37.21,2.11.74,0,0-1.53-3.23-3.6-.63Z"
            fill="#ba8419"
          />
          <path
            d="M811.55,368.26l-.12.43a2.62,2.62,0,0,0-.57,2.17A1.86,1.86,0,0,1,811.55,368.26Z"
            fill="#a06f18"
          />
          <path
            d="M809.1,369.3s.62,1.08,1.48.26l.24.48a2.09,2.09,0,0,0,0,.82C810.91,371,809.28,370.23,809.1,369.3Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M812.88,368.1l-1.22.09-.18-.06a2.34,2.34,0,0,1,1.55-.5c.9.05,2,1.21,2,1.21C814.25,368.31,814,367.94,812.88,368.1Z"
            fill="#a06f18"
          />
          <path
            d="M811.39,368.21c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6,6,0,0,1,811.39,368.21Z"
            fill="#ba8419"
          />
          <path d="M812.13,368.26a1.39,1.39,0,0,1,1.38,1.17" fill="#a06f18" />
          <path d="M811.87,368.47a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
          <path
            d="M814.24,369.83a7.43,7.43,0,0,1-1.37,1.88s-.63-.9-1-1.59l-.06-.11A1.89,1.89,0,0,0,814.24,369.83Z"
            fill="#a06f18"
          />
          <path d="M811.07,368.37s-.85,0-1.11.58" fill="#a06f18" />
          <path
            d="M812,375s0-2.27-2.85-2.38"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.08"
          />
          <path
            d="M809.8,371.23a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,809.8,371.23Z"
            fill="#396039"
          />
          <path
            d="M811.86,374.48a1.29,1.29,0,0,0-1.27-.81S811,374.6,811.86,374.48Z"
            fill="#396039"
          />
          <path
            d="M809.62,372.71a1.72,1.72,0,0,0-2.1-1A2.3,2.3,0,0,0,809.62,372.71Z"
            fill="#396039"
          />
          <path
            d="M811.28,373.48s.64-.24.27-1.14C811.55,372.34,811,372.91,811.28,373.48Z"
            fill="#396039"
          />
          <path
            d="M810.59,373a.77.77,0,0,0-1,.47A1.11,1.11,0,0,0,810.59,373Z"
            fill="#396039"
          />
          <path
            d="M812.13,373.85a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,812.13,373.85Z"
            fill="#396039"
          />
          <path
            d="M807.52,371.71l.16,0a3.34,3.34,0,0,0,1.74,1.07A2.36,2.36,0,0,1,807.52,371.71Z"
            fill="#204220"
          />
          <path
            d="M810.6,373.67h.21a1.66,1.66,0,0,0,1,.83,1.34,1.34,0,0,1-1.19-.81Z"
            fill="#204220"
          />
          <g>
            <path d="M810.46,372.9h0Z" fill="#204220" />
            <path
              d="M810.45,372.89l-.2-.15a2,2,0,0,1-.45-1.51l0,0A3.79,3.79,0,0,0,810.45,372.89Z"
              fill="#204220"
            />
          </g>
          <path
            d="M810.58,373h0l0,0a1.14,1.14,0,0,1-.93.43.83.83,0,0,1,.16-.25A1.49,1.49,0,0,0,810.58,373Z"
            fill="#204220"
          />
          <path
            d="M813.88,371.92a2.34,2.34,0,0,1-1.71,1.92h0c.82-.23,1.3-1.21,1.5-1.75Z"
            fill="#204220"
          />
        </g>
        <g>
          <path
            d="M821.24,352.44s2.86,9.62-.35,13.27"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M821.16,351.63c2.49-1.25,5.17.54,5,2.05s-2.5,3.83-2.5,3.83-1.06-1.51-1.69-2.67A10.48,10.48,0,0,1,821.16,351.63Z"
            fill="#ba8419"
          />
          <path
            d="M821.07,351.63s2-1.07,1.63-1.42.15.08-.38-.36-3.3.53-3.12,1.34S821.07,351.63,821.07,351.63Z"
            fill="#ba8419"
          />
          <path
            d="M821,352.08a2.18,2.18,0,0,0-2.49.62c-1,1.25.71,2.32.71,2.32"
            fill="none"
            stroke="#a06f18"
            strokeMiterlimit="10"
            strokeWidth="0.09"
          />
          <path
            d="M822.67,350.17l-.15.5a8.7,8.7,0,0,1-1.45,1s-1.69.36-1.87-.44a.45.45,0,0,1,.09-.36l.31-.13a3.14,3.14,0,0,0,2.36-.85l.1-.1a.57.57,0,0,1,.26.1C822.83,350.28,822.35,349.88,822.67,350.17Z"
            fill="#a06f18"
          />
          <path
            d="M822,351.63s-2.32,2.05-1.69,4.46c.09.18-3.48-1.43-2.94-3.3S822,351.63,822,351.63Z"
            fill="#ba8419"
          />
          <path
            d="M823.66,351.45c2-.26,2.31.36,3.56,1.25,0,0-2.58-5.44-6.06-1.07Z"
            fill="#ba8419"
          />
          <path
            d="M821.43,351.72l-.19.72a4.33,4.33,0,0,0-1,3.65A3.11,3.11,0,0,1,821.43,351.72Z"
            fill="#a06f18"
          />
          <path
            d="M817.3,353.47s1.06,1.82,2.5.43l.4.81a3.42,3.42,0,0,0,.07,1.38C820.35,356.24,817.62,355,817.3,353.47Z"
            fill="#a06f18"
            opacity="0.65"
          />
          <path
            d="M823.66,351.45l-2,.15-.3-.1a4,4,0,0,1,2.61-.85c1.52.09,3.3,2.05,3.3,2.05C826,351.81,825.62,351.19,823.66,351.45Z"
            fill="#a06f18"
          />
          <path
            d="M821.16,351.63c2.49-1.25,5.17.54,5,2.05s-2.5,3.83-2.5,3.83-1.06-1.51-1.69-2.67A10.48,10.48,0,0,1,821.16,351.63Z"
            fill="#ba8419"
          />
          <path d="M822.41,351.72a2.31,2.31,0,0,1,2.31,2" fill="#a06f18" />
          <path d="M822,352.08a2.33,2.33,0,0,1,1.61,2.31" fill="#a06f18" />
          <path
            d="M826,354.36a12.74,12.74,0,0,1-2.31,3.15s-1.06-1.51-1.69-2.67l-.09-.19C823.93,355.77,825.25,355.06,826,354.36Z"
            fill="#a06f18"
          />
          <path d="M820.62,351.9s-1.42,0-1.87,1" fill="#a06f18" />
          <path
            d="M822.12,363.13s0-3.83-4.79-4"
            fill="none"
            stroke="#396039"
            strokeMiterlimit="10"
            strokeWidth="0.14"
          />
          <path
            d="M818.49,356.71s1.92,1.07,1.09,2.85A3.13,3.13,0,0,1,818.49,356.71Z"
            fill="#396039"
          />
          <path
            d="M822,362.18a2.17,2.17,0,0,0-2.14-1.37S820.53,362.39,822,362.18Z"
            fill="#396039"
          />
          <path
            d="M818.18,359.19a2.88,2.88,0,0,0-3.53-1.68S816.09,359.63,818.18,359.19Z"
            fill="#396039"
          />
          <path
            d="M821,360.49s1.07-.39.45-1.91C821.43,358.58,820.45,359.54,821,360.49Z"
            fill="#396039"
          />
          <path
            d="M819.82,359.67a1.3,1.3,0,0,0-1.6.78A1.87,1.87,0,0,0,819.82,359.67Z"
            fill="#396039"
          />
          <path
            d="M822.41,361.12a8.11,8.11,0,0,1,2.94-3.25A3.93,3.93,0,0,1,822.41,361.12Z"
            fill="#396039"
          />
          <path
            d="M814.65,357.51l.27-.07c.55.56,1.86,1.75,2.93,1.8A4,4,0,0,1,814.65,357.51Z"
            fill="#204220"
          />
          <path
            d="M819.84,360.81a2,2,0,0,1,.34,0,2.82,2.82,0,0,0,1.66,1.39,2.26,2.26,0,0,1-2-1.36Z"
            fill="#204220"
          />
          <g>
            <path d="M819.6,359.53l0,0,0,0Z" fill="#204220" />
            <path
              d="M819.57,359.51l-.32-.26a3.25,3.25,0,0,1-.76-2.54l0,0A6.57,6.57,0,0,0,819.57,359.51Z"
              fill="#204220"
            />
          </g>
          <path
            d="M819.8,359.67h0l0,.08a1.92,1.92,0,0,1-1.56.7,1.62,1.62,0,0,1,.27-.41A2.55,2.55,0,0,0,819.8,359.67Z"
            fill="#204220"
          />
          <path
            d="M825.35,357.87a3.93,3.93,0,0,1-2.88,3.23l-.05,0h0c1.39-.39,2.19-2,2.54-2.95C825.09,358,825.22,358,825.35,357.87Z"
            fill="#204220"
          />
        </g>
        <path d="M874.43,407.15c1.36-1,1-1.36,3.06-1" fill="#493b1b" />
        <path d="M887,405.45c1.36-1,1-1.36,3-1" fill="#493b1b" />
        <path d="M819.07,366.05c1.36-1.7,3.73-.68,3.73-.68" fill="#35280f" />
        <path d="M831.3,378.62c1.35-1.7,3.73-.68,3.73-.68" fill="#35280f" />
        <path d="M845.56,386.77c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
        <path d="M859.15,388.81c1.35-1.7,3.73-.68,3.73-.68" fill="#35280f" />
        <path d="M864.58,392.88c1.36-1.69,3.74-.67,3.74-.67" fill="#35280f" />
        <path d="M882.58,389.49c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
        <path d="M892.43,398.32c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
        <path
          d="M917.91,413.94c3.39-6.45-2-11.88-4.42-9.51s0,6.8,0,6.8-7.13-5.78-8.83-2,3.23,6.88,3.23,6.88Z"
          fill="#1f441f"
        />
        <path
          d="M886,423.11c5.43-3.39,5.43-13.24,5.43-13.24s-4.75-.34-6.45,3.05S886,423.11,886,423.11Z"
          fill="#1f441f"
        />
        <path
          d="M887.34,422.43c-2.72-6.45-7.48-10.53-13.25-10.86,0,0,1.7,9.17,6.45,10.86S887.34,422.43,887.34,422.43Z"
          fill="#1f441f"
        />
        <path
          d="M891.41,409.87s-4.75-.34-6.45,3.05,1,10.19,1,10.19C884.28,414.62,891.41,409.87,891.41,409.87Z"
          fill="#659965"
        />
        <g>
          <path
            d="M916.94,404.79c-1.15-1-2.53-1.28-3.45-.36-1.58,1.58-1.06,4.05-.54,5.54C912.8,407.25,915.44,405.32,916.94,404.79Z"
            fill="#659965"
          />
          <path
            d="M912.89,410.77l-.11-.08C912.83,410.75,912.86,410.78,912.89,410.77Z"
            fill="#659965"
          />
        </g>
        <path
          d="M907.74,408.07c-1.32-.32-2.51-.14-3.08,1.12-.91,2,.07,3.82,1.18,5.09C904.44,411.72,906.58,409.17,907.74,408.07Z"
          fill="#659965"
        />
      </g>
      <g>
        <ellipse
          cx="782.13"
          cy="355.7"
          rx="16.87"
          ry="2.98"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M773.27,353.14c-2.9,1.47-3.53,1.78-6.14.74s-7.83-7.11-2-11.18,11.8,1.35,11.8,3.76c0,0-10.13-10.56,0-13.27s6.8,7.94,6.06,9.51c0,0,3.66-7.21,7.84-5s1.49,15.76-6.2,12.27c0,0,10.38-5,13.62.37s-17.66,6.38-21.32,4.6S773.27,353.14,773.27,353.14Z"
          fill="#1f441f"
        />
        <path
          d="M773,340.55c2.62,1.05,1.73-4.12,1.73-4.12s1.15-.63,1.18-2.92C772,335,772,337.87,773,340.55Z"
          fill="#659965"
        />
        <path
          d="M782.07,344.37c-7.41-.73-7.52-7-3.44-8.78S782.07,344.37,782.07,344.37Z"
          fill="#245624"
        />
        <path
          d="M778.7,349.86c-12,2-14.34-6.56-8.48-10.62S778.7,349.86,778.7,349.86Z"
          fill="#245624"
        />
        <path
          d="M783.74,349.6c9,5.33,14.37-1.71,11.21-7.11S783.74,349.6,783.74,349.6Z"
          fill="#245624"
        />
        <g>
          <path
            d="M783,342.7c3.77,2.5,4.5-2,4.5-2,1.6-.22,2.09-1.82,2.23-3.4C786.05,336.72,783,342.7,783,342.7Z"
            fill="#659965"
          />
          <path d="M783,342.7q.12-.26.3-.75Z" fill="#659965" />
        </g>
        <path
          d="M787.39,351.17c5.16,1.36,8.43-1.74,8.47-5.34-.19.17-.38.32-.56.46a5,5,0,0,1-4.45,1.11s-.31,4.18-3.34,3.08Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M774.5,354.24s-9.2-3.24-7-8.46,5.33-2.41,7,4.18c0,0-2.2-14,5.85-12.12s2,11.8,0,12.12c0,0,5.85-7.94,9.61-2.2s-6.16,6.9-8.67,6.48A33.87,33.87,0,0,0,774.5,354.24Z"
            fill="#659965"
          />
          <path
            d="M790,347.76a5.16,5.16,0,0,0-1.37-1.47,4.91,4.91,0,0,1-5.26,3.72s.1,3.87-4.39,3.13l-.45.92a18.56,18.56,0,0,1,2.8.18C783.8,354.66,793.72,353.51,790,347.76Z"
            fill="#396039"
          />
          <path
            d="M777,348.86s2.72,1.29,6-1.66c1.44-2.51,2.36-6.1,0-8.13-1.62,4-4.45,4-4.45,4S781.55,348.13,777,348.86Z"
            fill="#396039"
          />
          <path
            d="M774.76,354.22a8.25,8.25,0,0,1-3.45-3.9c-2.53.33-3.66-2.6-4-3.89-1.22,4.84,7.22,7.81,7.22,7.81Z"
            fill="#396039"
          />
        </g>
        <path
          d="M767.76,352a11.24,11.24,0,0,1-3.58-.54,8.15,8.15,0,0,0,3,2.43c2.43,1,3.14.76,5.56-.45A11.69,11.69,0,0,1,767.76,352Z"
          fill="#172d17"
        />
        <path
          d="M798.21,350.24c-1.33,2.77-4.89,3.07-6.11,2.69,0,0-1.65,2.15-7.65,2.78,7.11-.13,16-1.77,13.82-5.39Z"
          fill="#172d17"
        />
        <path
          d="M774.76,354.19c-3-1.26-2-4.29,0-3.87S774.76,354.19,774.76,354.19Z"
          fill="#245624"
        />
        <path
          d="M774.57,354c4.81,4.67,9.65.25,7.25-3.13S774.57,354,774.57,354Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="794.13"
          cy="329.7"
          rx="16.87"
          ry="2.98"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M785.27,327.14c-2.9,1.47-3.53,1.78-6.14.74s-7.83-7.11-2-11.18,11.8,1.35,11.8,3.76c0,0-10.13-10.56,0-13.27s6.8,7.94,6.06,9.51c0,0,3.66-7.21,7.84-5s1.49,15.76-6.2,12.27c0,0,10.38-5,13.62.37s-17.66,6.38-21.32,4.6S785.27,327.14,785.27,327.14Z"
          fill="#1f441f"
        />
        <path
          d="M785,314.55c2.62,1.05,1.73-4.12,1.73-4.12s1.15-.63,1.18-2.92C784,309,784,311.87,785,314.55Z"
          fill="#659965"
        />
        <path
          d="M794.07,318.37c-7.41-.73-7.52-7-3.44-8.78S794.07,318.37,794.07,318.37Z"
          fill="#245624"
        />
        <path
          d="M790.7,323.86c-12,2-14.34-6.56-8.48-10.62S790.7,323.86,790.7,323.86Z"
          fill="#245624"
        />
        <path
          d="M795.74,323.6c9,5.33,14.37-1.71,11.21-7.11S795.74,323.6,795.74,323.6Z"
          fill="#245624"
        />
        <g>
          <path
            d="M795,316.7c3.77,2.5,4.5-2,4.5-2,1.6-.22,2.09-1.82,2.23-3.4C798.05,310.72,795,316.7,795,316.7Z"
            fill="#659965"
          />
          <path d="M795,316.7q.12-.26.3-.75Z" fill="#659965" />
        </g>
        <path
          d="M799.39,325.17c5.16,1.36,8.43-1.74,8.47-5.34-.19.17-.38.32-.56.46a5,5,0,0,1-4.45,1.11s-.31,4.18-3.34,3.08Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M786.5,328.24s-9.2-3.24-7-8.46,5.33-2.41,7,4.18c0,0-2.2-14,5.85-12.12s2,11.8,0,12.12c0,0,5.85-7.94,9.61-2.2s-6.16,6.9-8.67,6.48A33.87,33.87,0,0,0,786.5,328.24Z"
            fill="#659965"
          />
          <path
            d="M802,321.76a5.16,5.16,0,0,0-1.37-1.47,4.91,4.91,0,0,1-5.26,3.72s.1,3.87-4.39,3.13l-.45.92a18.56,18.56,0,0,1,2.8.18C795.8,328.66,805.72,327.51,802,321.76Z"
            fill="#396039"
          />
          <path
            d="M789,322.86s2.72,1.29,6-1.66c1.44-2.51,2.36-6.1,0-8.13-1.62,4-4.45,4-4.45,4S793.55,322.13,789,322.86Z"
            fill="#396039"
          />
          <path
            d="M786.76,328.22a8.25,8.25,0,0,1-3.45-3.9c-2.53.33-3.66-2.6-4-3.89-1.22,4.84,7.22,7.81,7.22,7.81Z"
            fill="#396039"
          />
        </g>
        <path
          d="M779.76,326a11.24,11.24,0,0,1-3.58-.54,8.15,8.15,0,0,0,3,2.43c2.43,1,3.14.76,5.56-.45A11.69,11.69,0,0,1,779.76,326Z"
          fill="#172d17"
        />
        <path
          d="M810.21,324.24c-1.33,2.77-4.89,3.07-6.11,2.69,0,0-1.65,2.15-7.65,2.78,7.11-.13,16-1.77,13.82-5.39Z"
          fill="#172d17"
        />
        <path
          d="M786.76,328.19c-3-1.26-2-4.29,0-3.87S786.76,328.19,786.76,328.19Z"
          fill="#245624"
        />
        <path
          d="M786.57,328c4.81,4.67,9.65.25,7.25-3.13S786.57,328,786.57,328Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="823.36"
          cy="314.7"
          rx="16.87"
          ry="2.98"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M832.21,312.14c2.9,1.47,3.53,1.78,6.14.74s7.83-7.11,2-11.18-11.8,1.35-11.8,3.76c0,0,10.13-10.56,0-13.27s-6.79,7.94-6.06,9.51c0,0-3.66-7.21-7.84-5s-1.49,15.76,6.2,12.27c0,0-10.38-5-13.62.37s17.66,6.38,21.32,4.6S832.21,312.14,832.21,312.14Z"
          fill="#1f441f"
        />
        <path
          d="M832.45,299.55c-2.62,1.05-1.73-4.12-1.73-4.12s-1.15-.63-1.17-2.92C833.45,294,833.5,296.87,832.45,299.55Z"
          fill="#659965"
        />
        <path
          d="M823.41,303.37c7.42-.73,7.52-7,3.45-8.78S823.41,303.37,823.41,303.37Z"
          fill="#245624"
        />
        <path
          d="M826.78,308.86c12,2,14.35-6.56,8.48-10.62S826.78,308.86,826.78,308.86Z"
          fill="#245624"
        />
        <path
          d="M821.74,308.6c-9,5.33-14.37-1.71-11.21-7.11S821.74,308.6,821.74,308.6Z"
          fill="#245624"
        />
        <g>
          <path
            d="M822.47,301.7c-3.76,2.5-4.5-2-4.5-2-1.6-.22-2.09-1.82-2.23-3.4C819.44,295.72,822.47,301.7,822.47,301.7Z"
            fill="#659965"
          />
          <path d="M822.47,301.7a7.1,7.1,0,0,1-.29-.75Z" fill="#659965" />
        </g>
        <path
          d="M818.09,310.17c-5.16,1.36-8.43-1.74-8.47-5.34.19.17.38.32.56.46a5,5,0,0,0,4.45,1.11s.31,4.18,3.34,3.08Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M831,313.24s9.2-3.24,7-8.46-5.33-2.41-7,4.18c0,0,2.2-14-5.85-12.12s-2,11.8,0,12.12c0,0-5.85-7.94-9.61-2.2s6.16,6.9,8.67,6.48A33.87,33.87,0,0,1,831,313.24Z"
            fill="#659965"
          />
          <path
            d="M815.52,306.76a5.16,5.16,0,0,1,1.37-1.47,4.91,4.91,0,0,0,5.26,3.72s-.1,3.87,4.39,3.13l.45.92a18.65,18.65,0,0,0-2.8.18C821.68,313.66,811.76,312.51,815.52,306.76Z"
            fill="#396039"
          />
          <path
            d="M828.53,307.86s-2.72,1.29-6-1.66c-1.44-2.51-2.36-6.1,0-8.13,1.62,4,4.45,4,4.45,4S823.93,307.13,828.53,307.86Z"
            fill="#396039"
          />
          <path
            d="M830.72,313.22a8.25,8.25,0,0,0,3.45-3.9c2.53.33,3.66-2.6,4-3.89,1.22,4.84-7.22,7.81-7.22,7.81Z"
            fill="#396039"
          />
        </g>
        <path
          d="M837.72,311a11.24,11.24,0,0,0,3.58-.54,8.15,8.15,0,0,1-2.95,2.43c-2.43,1-3.14.76-5.56-.45A11.69,11.69,0,0,0,837.72,311Z"
          fill="#172d17"
        />
        <path
          d="M807.27,309.24c1.33,2.77,4.89,3.07,6.11,2.69,0,0,1.65,2.15,7.65,2.78-7.1-.13-16-1.77-13.82-5.39Z"
          fill="#172d17"
        />
        <path
          d="M830.72,313.19c3-1.26,2-4.29,0-3.87S830.72,313.19,830.72,313.19Z"
          fill="#245624"
        />
        <path
          d="M830.91,313c-4.81,4.67-9.65.25-7.25-3.13S830.91,313,830.91,313Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="898.73"
          cy="240.23"
          rx="8.25"
          ry="1.46"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M903.06,239c1.42.72,1.73.87,3,.36s3.84-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.83-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
          fill="#1f441f"
        />
        <path
          d="M903.18,232.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C903.67,230.09,903.69,231.5,903.18,232.82Z"
          fill="#659965"
        />
        <path
          d="M898.76,234.68c3.63-.36,3.68-3.42,1.68-4.29S898.76,234.68,898.76,234.68Z"
          fill="#245624"
        />
        <path
          d="M900.41,237.37c5.88.95,7-3.21,4.14-5.19S900.41,237.37,900.41,237.37Z"
          fill="#245624"
        />
        <path
          d="M897.94,237.24c-4.42,2.61-7-.84-5.48-3.48S897.94,237.24,897.94,237.24Z"
          fill="#245624"
        />
        <g>
          <path
            d="M898.3,233.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C896.82,230.94,898.3,233.86,898.3,233.86Z"
            fill="#659965"
          />
          <path d="M898.3,233.86a2.08,2.08,0,0,1-.14-.36Z" fill="#659965" />
        </g>
        <path
          d="M896.16,238c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.43,2.43,0,0,0,2.18.54s.15,2.05,1.63,1.51Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M902.46,239.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,902.46,239.51Z"
            fill="#659965"
          />
          <path
            d="M894.9,236.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C897.91,239.71,893.06,239.15,894.9,236.34Z"
            fill="#396039"
          />
          <path
            d="M901.26,236.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S899,236.52,901.26,236.88Z"
            fill="#396039"
          />
          <path
            d="M902.33,239.5a4,4,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.6,2.37-3.53,3.82-3.53,3.82Z"
            fill="#396039"
          />
        </g>
        <path
          d="M905.76,238.41a5.22,5.22,0,0,0,1.75-.27,3.84,3.84,0,0,1-1.45,1.19,2.49,2.49,0,0,1-2.71-.22A5.76,5.76,0,0,0,905.76,238.41Z"
          fill="#172d17"
        />
        <path
          d="M890.87,237.55a2.77,2.77,0,0,0,3,1.32s.81,1,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64Z"
          fill="#172d17"
        />
        <path
          d="M902.33,239.48c1.49-.61,1-2.09,0-1.89S902.33,239.48,902.33,239.48Z"
          fill="#245624"
        />
        <path
          d="M902.42,239.41c-2.35,2.28-4.71.12-3.54-1.53S902.42,239.41,902.42,239.41Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="917.73"
          cy="226.23"
          rx="8.25"
          ry="1.46"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M922.06,225c1.42.72,1.73.87,3,.36s3.84-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.83-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
          fill="#1f441f"
        />
        <path
          d="M922.18,218.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C922.67,216.09,922.69,217.5,922.18,218.82Z"
          fill="#659965"
        />
        <path
          d="M917.76,220.68c3.63-.36,3.68-3.42,1.68-4.29S917.76,220.68,917.76,220.68Z"
          fill="#245624"
        />
        <path
          d="M919.41,223.37c5.88.95,7-3.21,4.14-5.19S919.41,223.37,919.41,223.37Z"
          fill="#245624"
        />
        <path
          d="M916.94,223.24c-4.42,2.61-7-.84-5.48-3.48S916.94,223.24,916.94,223.24Z"
          fill="#245624"
        />
        <g>
          <path
            d="M917.3,219.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C915.82,216.94,917.3,219.86,917.3,219.86Z"
            fill="#659965"
          />
          <path d="M917.3,219.86a2.08,2.08,0,0,1-.14-.36Z" fill="#659965" />
        </g>
        <path
          d="M915.16,224c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.43,2.43,0,0,0,2.18.54s.15,2.05,1.63,1.51Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M921.46,225.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,921.46,225.51Z"
            fill="#659965"
          />
          <path
            d="M913.9,222.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C916.91,225.71,912.06,225.15,913.9,222.34Z"
            fill="#396039"
          />
          <path
            d="M920.26,222.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S918,222.52,920.26,222.88Z"
            fill="#396039"
          />
          <path
            d="M921.33,225.5a4,4,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.6,2.37-3.53,3.82-3.53,3.82Z"
            fill="#396039"
          />
        </g>
        <path
          d="M924.76,224.41a5.22,5.22,0,0,0,1.75-.27,3.84,3.84,0,0,1-1.45,1.19,2.49,2.49,0,0,1-2.71-.22A5.76,5.76,0,0,0,924.76,224.41Z"
          fill="#172d17"
        />
        <path
          d="M909.87,223.55a2.77,2.77,0,0,0,3,1.32s.81,1,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64Z"
          fill="#172d17"
        />
        <path
          d="M921.33,225.48c1.49-.61,1-2.09,0-1.89S921.33,225.48,921.33,225.48Z"
          fill="#245624"
        />
        <path
          d="M921.42,225.41c-2.35,2.28-4.71.12-3.54-1.53S921.42,225.41,921.42,225.41Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="907.73"
          cy="161.23"
          rx="8.25"
          ry="1.46"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M912.06,160c1.42.72,1.73.87,3,.36s3.84-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.83-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
          fill="#1f441f"
        />
        <path
          d="M912.18,153.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C912.67,151.09,912.69,152.5,912.18,153.82Z"
          fill="#659965"
        />
        <path
          d="M907.76,155.68c3.63-.36,3.68-3.42,1.68-4.29S907.76,155.68,907.76,155.68Z"
          fill="#245624"
        />
        <path
          d="M909.41,158.37c5.88.95,7-3.21,4.14-5.19S909.41,158.37,909.41,158.37Z"
          fill="#245624"
        />
        <path
          d="M906.94,158.24c-4.42,2.61-7-.84-5.48-3.48S906.94,158.24,906.94,158.24Z"
          fill="#245624"
        />
        <g>
          <path
            d="M907.3,154.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C905.82,151.94,907.3,154.86,907.3,154.86Z"
            fill="#659965"
          />
          <path d="M907.3,154.86a2.08,2.08,0,0,1-.14-.36Z" fill="#659965" />
        </g>
        <path
          d="M905.16,159c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.43,2.43,0,0,0,2.18.54s.15,2.05,1.63,1.51Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M911.46,160.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,911.46,160.51Z"
            fill="#659965"
          />
          <path
            d="M903.9,157.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C906.91,160.71,902.06,160.15,903.9,157.34Z"
            fill="#396039"
          />
          <path
            d="M910.26,157.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S908,157.52,910.26,157.88Z"
            fill="#396039"
          />
          <path
            d="M911.33,160.5a4,4,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.6,2.37-3.53,3.82-3.53,3.82Z"
            fill="#396039"
          />
        </g>
        <path
          d="M914.76,159.41a5.22,5.22,0,0,0,1.75-.27,3.84,3.84,0,0,1-1.45,1.19,2.49,2.49,0,0,1-2.71-.22A5.76,5.76,0,0,0,914.76,159.41Z"
          fill="#172d17"
        />
        <path
          d="M899.87,158.55a2.77,2.77,0,0,0,3,1.32s.81,1,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64Z"
          fill="#172d17"
        />
        <path
          d="M911.33,160.48c1.49-.61,1-2.09,0-1.89S911.33,160.48,911.33,160.48Z"
          fill="#245624"
        />
        <path
          d="M911.42,160.41c-2.35,2.28-4.71.12-3.54-1.53S911.42,160.41,911.42,160.41Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="927.73"
          cy="163.23"
          rx="8.25"
          ry="1.46"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M932.06,162c1.42.72,1.73.87,3,.36s3.84-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.83-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
          fill="#1f441f"
        />
        <path
          d="M932.18,155.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C932.67,153.09,932.69,154.5,932.18,155.82Z"
          fill="#659965"
        />
        <path
          d="M927.76,157.68c3.63-.36,3.68-3.42,1.68-4.29S927.76,157.68,927.76,157.68Z"
          fill="#245624"
        />
        <path
          d="M929.41,160.37c5.88.95,7-3.21,4.14-5.19S929.41,160.37,929.41,160.37Z"
          fill="#245624"
        />
        <path
          d="M926.94,160.24c-4.42,2.61-7-.84-5.48-3.48S926.94,160.24,926.94,160.24Z"
          fill="#245624"
        />
        <g>
          <path
            d="M927.3,156.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C925.82,153.94,927.3,156.86,927.3,156.86Z"
            fill="#659965"
          />
          <path d="M927.3,156.86a2.08,2.08,0,0,1-.14-.36Z" fill="#659965" />
        </g>
        <path
          d="M925.16,161c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.43,2.43,0,0,0,2.18.54s.15,2.05,1.63,1.51Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M931.46,162.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,931.46,162.51Z"
            fill="#659965"
          />
          <path
            d="M923.9,159.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C926.91,162.71,922.06,162.15,923.9,159.34Z"
            fill="#396039"
          />
          <path
            d="M930.26,159.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S928,159.52,930.26,159.88Z"
            fill="#396039"
          />
          <path
            d="M931.33,162.5a4,4,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.6,2.37-3.53,3.82-3.53,3.82Z"
            fill="#396039"
          />
        </g>
        <path
          d="M934.76,161.41a5.22,5.22,0,0,0,1.75-.27,3.84,3.84,0,0,1-1.45,1.19,2.49,2.49,0,0,1-2.71-.22A5.76,5.76,0,0,0,934.76,161.41Z"
          fill="#172d17"
        />
        <path
          d="M919.87,160.55a2.77,2.77,0,0,0,3,1.32s.81,1,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64Z"
          fill="#172d17"
        />
        <path
          d="M931.33,162.48c1.49-.61,1-2.09,0-1.89S931.33,162.48,931.33,162.48Z"
          fill="#245624"
        />
        <path
          d="M931.42,162.41c-2.35,2.28-4.71.12-3.54-1.53S931.42,162.41,931.42,162.41Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <ellipse
          cx="946.73"
          cy="165.23"
          rx="8.25"
          ry="1.46"
          fill="#141c66"
          opacity="0.2"
        />
        <path
          d="M951.06,164c1.42.72,1.73.87,3,.36s3.84-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.83-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
          fill="#1f441f"
        />
        <path
          d="M951.18,157.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C951.67,155.09,951.69,156.5,951.18,157.82Z"
          fill="#659965"
        />
        <path
          d="M946.76,159.68c3.63-.36,3.68-3.42,1.68-4.29S946.76,159.68,946.76,159.68Z"
          fill="#245624"
        />
        <path
          d="M948.41,162.37c5.88.95,7-3.21,4.14-5.19S948.41,162.37,948.41,162.37Z"
          fill="#245624"
        />
        <path
          d="M945.94,162.24c-4.42,2.61-7-.84-5.48-3.48S945.94,162.24,945.94,162.24Z"
          fill="#245624"
        />
        <g>
          <path
            d="M946.3,158.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C944.82,155.94,946.3,158.86,946.3,158.86Z"
            fill="#659965"
          />
          <path d="M946.3,158.86a2.08,2.08,0,0,1-.14-.36Z" fill="#659965" />
        </g>
        <path
          d="M944.16,163c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.43,2.43,0,0,0,2.18.54s.15,2.05,1.63,1.51Z"
          fill="#172d17"
        />
        <g>
          <path
            d="M950.46,164.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,950.46,164.51Z"
            fill="#659965"
          />
          <path
            d="M942.9,161.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C945.91,164.71,941.06,164.15,942.9,161.34Z"
            fill="#396039"
          />
          <path
            d="M949.26,161.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S947,161.52,949.26,161.88Z"
            fill="#396039"
          />
          <path
            d="M950.33,164.5a4,4,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.6,2.37-3.53,3.82-3.53,3.82Z"
            fill="#396039"
          />
        </g>
        <path
          d="M953.76,163.41a5.22,5.22,0,0,0,1.75-.27,3.84,3.84,0,0,1-1.45,1.19,2.49,2.49,0,0,1-2.71-.22A5.76,5.76,0,0,0,953.76,163.41Z"
          fill="#172d17"
        />
        <path
          d="M938.87,162.55a2.77,2.77,0,0,0,3,1.32s.81,1,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64Z"
          fill="#172d17"
        />
        <path
          d="M950.33,164.48c1.49-.61,1-2.09,0-1.89S950.33,164.48,950.33,164.48Z"
          fill="#245624"
        />
        <path
          d="M950.42,164.41c-2.35,2.28-4.71.12-3.54-1.53S950.42,164.41,950.42,164.41Z"
          fill="#1f441f"
        />
      </g>
      <g>
        <polygon
          points="912 324 926 331 956 314 942 303.49 912 324"
          fill="#141c66"
          opacity="0.2"
        />
        <g>
          <g>
            <polygon
              points="941.79 273.5 941.79 308.42 943.83 307.24 943.79 272.35 941.79 273.5"
              fill="#54392e"
            />
            <polygon
              points="940.7 307.79 941.79 308.42 941.79 273.5 940.7 272.88 940.7 307.79"
              fill="#96695c"
            />
            <polygon
              points="940.7 272.88 941.79 273.5 943.79 272.35 942.7 271.8 940.7 272.88"
              fill="#704d3c"
            />
          </g>
          <line
            x1="916.58"
            y1="311.31"
            x2="948.92"
            y2="292.73"
            fill="none"
            stroke="#54392e"
            strokeMiterlimit="10"
          />
          <line
            x1="921.61"
            y1="314.21"
            x2="953.96"
            y2="295.64"
            fill="none"
            stroke="#54392e"
            strokeMiterlimit="10"
          />
          <g>
            <polygon
              points="936.73 311.31 921.61 302.58 921.61 305.61 936.73 314.21 936.73 311.31"
              fill="#96695c"
            />
            <polygon
              points="921.61 302.58 923.65 301.41 938.84 310.1 936.73 311.31 921.61 302.58"
              fill="#704d3c"
            />
            <polygon
              points="936.73 311.31 938.84 310.1 938.84 312.88 936.73 314.21 936.73 311.31"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="941.77 308.41 926.65 299.68 926.65 302.71 941.77 311.31 941.77 308.41"
              fill="#96695c"
            />
            <polygon
              points="926.65 299.68 928.69 298.51 943.88 307.2 941.77 308.41 926.65 299.68"
              fill="#704d3c"
            />
            <polygon
              points="941.77 308.41 943.88 307.2 943.88 309.97 941.77 311.31 941.77 308.41"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="946.81 305.49 931.69 296.77 931.69 299.8 946.81 308.4 946.81 305.49"
              fill="#96695c"
            />
            <polygon
              points="931.69 296.77 933.73 295.59 948.92 304.29 946.81 305.49 931.69 296.77"
              fill="#704d3c"
            />
            <polygon
              points="946.81 305.49 948.92 304.29 948.92 307.06 946.81 308.4 946.81 305.49"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="951.85 302.59 936.73 293.86 936.73 296.89 951.85 305.49 951.85 302.59"
              fill="#96695c"
            />
            <polygon
              points="936.73 293.86 938.77 292.69 953.96 301.38 951.85 302.59 936.73 293.86"
              fill="#704d3c"
            />
            <polygon
              points="951.85 302.59 953.96 301.38 953.96 304.16 951.85 305.49 951.85 302.59"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="956.89 299.71 941.77 290.98 941.77 294.01 956.89 302.61 956.89 299.71"
              fill="#96695c"
            />
            <polygon
              points="941.77 290.98 943.81 289.81 959 298.5 956.89 299.71 941.77 290.98"
              fill="#704d3c"
            />
            <polygon
              points="956.89 299.71 959 298.5 959 301.27 956.89 302.61 956.89 299.71"
              fill="#a06338"
            />
          </g>
          <g>
            <polygon
              points="931.69 314.22 916.57 305.49 916.58 308.52 931.69 317.12 931.69 314.22"
              fill="#96695c"
            />
            <polygon
              points="916.57 305.49 918.61 304.32 933.8 313.01 931.69 314.22 916.57 305.49"
              fill="#704d3c"
            />
            <polygon
              points="931.69 314.22 933.8 313.01 933.8 315.79 931.69 317.12 931.69 314.22"
              fill="#54392e"
            />
          </g>
          <polygon
            points="911.53 290.94 911.53 325.86 913.57 324.68 913.54 289.79 911.53 290.94"
            fill="#54392e"
          />
          <polygon
            points="910.45 325.23 911.53 325.86 911.53 290.94 910.45 290.31 910.45 325.23"
            fill="#96695c"
          />
          <g>
            <polygon
              points="926.65 317.12 911.53 308.4 911.53 311.43 926.65 320.03 926.65 317.12"
              fill="#96695c"
            />
            <polygon
              points="911.53 308.4 913.57 307.22 928.76 315.92 926.65 317.12 911.53 308.4"
              fill="#704d3c"
            />
            <polygon
              points="926.65 317.12 928.76 315.92 928.76 318.69 926.65 320.03 926.65 317.12"
              fill="#a06338"
            />
          </g>
          <polygon
            points="910.45 290.31 911.53 290.94 913.54 289.79 912.45 289.24 910.45 290.31"
            fill="#704d3c"
          />
          <polygon
            points="926.65 334.59 926.65 317.12 924.55 315.92 924.55 333.37 926.65 334.59"
            fill="#96695c"
          />
          <polygon
            points="926.65 334.59 928.76 333.37 928.76 315.92 926.65 317.12 926.65 334.59"
            fill="#54392e"
          />
          <polygon
            points="956.9 317.12 956.89 299.71 959 298.5 959 315.91 956.9 317.12"
            fill="#54392e"
          />
          <polygon
            points="955.33 298.81 955.33 316.23 956.9 317.12 956.89 299.71 955.33 298.81"
            fill="#96695c"
          />
          <polygon
            points="911.53 296.76 941.77 279.31 941.77 282.54 911.53 299.68 911.53 296.76"
            fill="#54392e"
          />
          <polygon
            points="940.7 278.69 941.77 279.31 913.54 295.6 913.54 293.86 940.7 278.69"
            fill="#704d3c"
          />
        </g>
      </g>
      <g>
        <polygon
          points="980 293 994 300 1024 283 1010 272.49 980 293"
          fill="#141c66"
          opacity="0.2"
        />
        <g>
          <g>
            <polygon
              points="1002.79 259.86 1002.79 277.42 1004.83 276.83 1004.79 259.28 1002.79 259.86"
              fill="#54392e"
            />
            <polygon
              points="1001.7 277.1 1002.79 277.42 1002.79 259.86 1002 260 1001.7 277.1"
              fill="#96695c"
            />
            <polyline
              points="1002.79 259.86 1004.79 259.28 1003.7 259"
              fill="#704d3c"
            />
          </g>
          <line
            x1="977.58"
            y1="280.31"
            x2="1009.92"
            y2="261.73"
            fill="none"
            stroke="#54392e"
            strokeMiterlimit="10"
          />
          <line
            x1="982.61"
            y1="283.21"
            x2="1014.96"
            y2="264.64"
            fill="none"
            stroke="#54392e"
            strokeMiterlimit="10"
          />
          <g>
            <polygon
              points="997.73 280.31 982.61 271.58 982.61 274.61 997.73 283.21 997.73 280.31"
              fill="#96695c"
            />
            <polygon
              points="982.61 271.58 984.65 270.41 999.84 279.1 997.73 280.31 982.61 271.58"
              fill="#704d3c"
            />
            <polygon
              points="997.73 280.31 999.84 279.1 999.84 281.88 997.73 283.21 997.73 280.31"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="1002.77 277.41 987.65 268.68 987.65 271.71 1002.77 280.31 1002.77 277.41"
              fill="#96695c"
            />
            <polygon
              points="987.65 268.68 989.69 267.51 1004.88 276.2 1002.77 277.41 987.65 268.68"
              fill="#704d3c"
            />
            <polygon
              points="1002.77 277.41 1004.88 276.2 1004.88 278.97 1002.77 280.31 1002.77 277.41"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="1007.81 274.49 992.69 265.77 992.69 268.8 1007.81 277.4 1007.81 274.49"
              fill="#96695c"
            />
            <polygon
              points="992.69 265.77 994.73 264.59 1009.92 273.29 1007.81 274.49 992.69 265.77"
              fill="#704d3c"
            />
            <polygon
              points="1007.81 274.49 1009.92 273.29 1009.92 276.06 1007.81 277.4 1007.81 274.49"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="1012.85 271.59 997.73 262.86 997.73 265.89 1012.85 274.49 1012.85 271.59"
              fill="#96695c"
            />
            <polygon
              points="997.73 262.86 999.77 261.69 1014.96 270.38 1012.85 271.59 997.73 262.86"
              fill="#704d3c"
            />
            <polygon
              points="1012.85 271.59 1014.96 270.38 1014.96 273.16 1012.85 274.49 1012.85 271.59"
              fill="#54392e"
            />
          </g>
          <g>
            <polygon
              points="1017.79 268.52 1002 259.25 1002 262.47 1017.79 271.61 1017.79 268.52"
              fill="#96695c"
            />
            <polygon
              points="1002 259.25 1004.13 258 1020 267.24 1017.79 268.52 1002 259.25"
              fill="#704d3c"
            />
            <polygon
              points="1017.79 268.52 1020 267.24 1020 270.19 1017.79 271.61 1017.79 268.52"
              fill="#a06338"
            />
          </g>
          <g>
            <polygon
              points="992.69 283.22 977.57 274.49 977.58 277.52 992.69 286.12 992.69 283.22"
              fill="#96695c"
            />
            <polygon
              points="977.57 274.49 979.61 273.32 994.8 282.01 992.69 283.22 977.57 274.49"
              fill="#704d3c"
            />
            <polygon
              points="992.69 283.22 994.8 282.01 994.8 284.79 992.69 286.12 992.69 283.22"
              fill="#54392e"
            />
          </g>
          <polygon
            points="973.53 277.83 973.53 294.86 975.57 294.28 975.54 277.27 973.53 277.83"
            fill="#54392e"
          />
          <polygon
            points="972.45 294.55 973.53 294.86 973.53 277.83 972.45 277.52 972.45 294.55"
            fill="#96695c"
          />
          <g>
            <polygon
              points="987.65 286.12 972.53 277.4 972.53 280.43 987.65 289.03 987.65 286.12"
              fill="#96695c"
            />
            <polygon
              points="972.53 277.4 974.57 276.22 989.76 284.92 987.65 286.12 972.53 277.4"
              fill="#704d3c"
            />
            <polygon
              points="987.65 286.12 989.76 284.92 989.76 287.69 987.65 289.03 987.65 286.12"
              fill="#a06338"
            />
          </g>
          <polygon
            points="987.65 303.59 987.65 286.12 985.55 284.92 985.55 302.37 987.65 303.59"
            fill="#96695c"
          />
          <polygon
            points="987.65 303.59 989.76 302.37 989.76 284.92 987.65 286.12 987.65 303.59"
            fill="#54392e"
          />
          <polygon
            points="1017.9 286.12 1017.89 268.71 1020 267.5 1020 284.91 1017.9 286.12"
            fill="#54392e"
          />
          <polygon
            points="1016.33 267.81 1016.33 285.23 1017.9 286.12 1017.89 268.71 1016.33 267.81"
            fill="#96695c"
          />
        </g>
      </g>
    </g>
  );
};

export default Decor3;
